// This file is auto-generated by @hey-api/openapi-ts

import {
  type Client,
  type ClientMeta,
  formDataBodySerializer,
  type Options as Options2,
  type RequestResult,
  type TDataShape,
} from "./client";
import { client } from "./client.gen";
import {
  abandonPendingIntegrationSetupResponseTransformer,
  addInitialTicketAttachmentsApiSupportTicketsTicketIdAttachmentsPostResponseTransformer,
  adminCostRollupResponseTransformer,
  adminCreateLlmProviderTopupResponseTransformer,
  adminGetLlmProviderRunwayResponseTransformer,
  adminInternalReconciliationResponseTransformer,
  adminListLlmProviderRunwayResponseTransformer,
  adminListLlmProviderTopupsResponseTransformer,
  cloneSystemAgentResponseTransformer,
  createAdminMcpServerResponseTransformer,
  createAgentResponseTransformer,
  createBillingPlanVersionResponseTransformer,
  createBillingPriceResponseTransformer,
  createConversationResponseTransformer,
  createPromotionApiAdminPromotionsPostResponseTransformer,
  createSharedLinkResponseTransformer,
  createSupportTicketApiSupportTicketsPostResponseTransformer,
  createWebhookEndpointResponseTransformer,
  enableAgentExtensionTriggerResponseTransformer,
  getAdminUserResponseTransformer,
  getAgentResponseTransformer,
  getAgentWizardDraftResponseTransformer,
  getConversationResponseTransformer,
  getLastUsedConversationResponseTransformer,
  getMessageLatencyApiAdminSupportMetricsMessagesMessageIdLatencyGetResponseTransformer,
  getPlatformVersionsResponseTransformer,
  getPromotionApiAdminPromotionsPromotionIdGetResponseTransformer,
  getTicketApiSupportTicketsTicketIdGetResponseTransformer,
  getTicketMessagesApiSupportTicketsTicketIdMessagesGetResponseTransformer,
  getWebhookEndpointResponseTransformer,
  listAdminAuditLogResponseTransformer,
  listAdminMcpServersResponseTransformer,
  listAdminMcpSnapshotsResponseTransformer,
  listAdminMcpToolsResponseTransformer,
  listAdminUserAuditLogsResponseTransformer,
  listAdminUsersResponseTransformer,
  listAgentExtensionTriggersResponseTransformer,
  listAgentsResponseTransformer,
  listAgentSubAgentsResponseTransformer,
  listBillingPlansResponseTransformer,
  listBillingPricingResponseTransformer,
  listConversationsResponseTransformer,
  listIsolationAuditEventsResponseTransformer,
  listMcpCatalogToolsResponseTransformer,
  listNotificationsResponseTransformer,
  listPendingDeadLetterCasesResponseTransformer,
  listPlatformSettingsResponseTransformer,
  listPromotionsApiAdminPromotionsGetResponseTransformer,
  listPromotionUsagesApiAdminPromotionsPromotionIdUsagesGetResponseTransformer,
  listSharedLinksResponseTransformer,
  listTicketsApiSupportTicketsGetResponseTransformer,
  listWebhookDeliveriesResponseTransformer,
  listWebhookEndpointsResponseTransformer,
  passkeyListResponseTransformer,
  passkeyRegisterVerifyResponseTransformer,
  passkeyRenameResponseTransformer,
  reenableWebhookEndpointResponseTransformer,
  replyToTicketApiSupportTicketsTicketIdMessagesPostResponseTransformer,
  revokePromotionApiAdminPromotionsPromotionIdRevokePostResponseTransformer,
  runAdminMcpServerDiscoveryResponseTransformer,
  saveAgentWizardDraftResponseTransformer,
  sessionListResponseTransformer,
  setAdminMcpDiscoveryConnectionResponseTransformer,
  setPlatformSettingResponseTransformer,
  updateAdminMcpServerResponseTransformer,
  updateAdminMcpToolResponseTransformer,
  updateAdminUserResponseTransformer,
  updateConversationResponseTransformer,
  updatePromotionApiAdminPromotionsPromotionIdPatchResponseTransformer,
  updateTicketApiSupportTicketsTicketIdPatchResponseTransformer,
} from "./transformers.gen";
import type {
  AbandonPendingIntegrationSetupData,
  AbandonPendingIntegrationSetupErrors,
  AbandonPendingIntegrationSetupResponses,
  AcceptAdminMcpAiSuggestionsData,
  AcceptAdminMcpAiSuggestionsErrors,
  AcceptAdminMcpAiSuggestionsResponses,
  AcceptSubAgentKeepOfferData,
  AcceptSubAgentKeepOfferErrors,
  AcceptSubAgentKeepOfferResponses,
  AcknowledgeAgentLeakRiskReviewData,
  AcknowledgeAgentLeakRiskReviewErrors,
  AcknowledgeAgentLeakRiskReviewResponses,
  ActivateExtensionToolkitData,
  ActivateExtensionToolkitErrors,
  ActivateExtensionToolkitResponses,
  AddAgentDocumentData,
  AddAgentDocumentErrors,
  AddAgentDocumentResponses,
  AddAgentMemoryData,
  AddAgentMemoryErrors,
  AddAgentMemoryResponses,
  AddAgentToolData,
  AddAgentToolErrors,
  AddAgentToolResponses,
  AddInitialTicketAttachmentsApiSupportTicketsTicketIdAttachmentsPostData,
  AddInitialTicketAttachmentsApiSupportTicketsTicketIdAttachmentsPostErrors,
  AddInitialTicketAttachmentsApiSupportTicketsTicketIdAttachmentsPostResponses,
  AddPatternToolData,
  AddPatternToolErrors,
  AddPatternToolResponses,
  AdminArchiveSystemAgentTemplateData,
  AdminArchiveSystemAgentTemplateErrors,
  AdminArchiveSystemAgentTemplateResponses,
  AdminCostRollupData,
  AdminCostRollupErrors,
  AdminCostRollupResponses,
  AdminCreateLlmProviderTopupData,
  AdminCreateLlmProviderTopupErrors,
  AdminCreateLlmProviderTopupResponses,
  AdminCreateSystemAgentCategoryData,
  AdminCreateSystemAgentCategoryErrors,
  AdminCreateSystemAgentCategoryResponses,
  AdminCreateSystemAgentTemplateData,
  AdminCreateSystemAgentTemplateErrors,
  AdminCreateSystemAgentTemplateResponses,
  AdminDeleteLlmProviderTopupData,
  AdminDeleteLlmProviderTopupErrors,
  AdminDeleteLlmProviderTopupResponses,
  AdminDeleteSystemAgentCategoryData,
  AdminDeleteSystemAgentCategoryErrors,
  AdminDeleteSystemAgentCategoryResponses,
  AdminDuplicateSystemAgentTemplateData,
  AdminDuplicateSystemAgentTemplateErrors,
  AdminDuplicateSystemAgentTemplateResponses,
  AdminGetAgentData,
  AdminGetAgentErrors,
  AdminGetAgentResponses,
  AdminGetConversationData,
  AdminGetConversationErrors,
  AdminGetConversationResponses,
  AdminGetLlmProviderRunwayData,
  AdminGetLlmProviderRunwayErrors,
  AdminGetLlmProviderRunwayResponses,
  AdminGetSystemAgentTemplateData,
  AdminGetSystemAgentTemplateDraftData,
  AdminGetSystemAgentTemplateDraftErrors,
  AdminGetSystemAgentTemplateDraftResponses,
  AdminGetSystemAgentTemplateErrors,
  AdminGetSystemAgentTemplateResponses,
  AdminInternalReconciliationData,
  AdminInternalReconciliationErrors,
  AdminInternalReconciliationResponses,
  AdminListAgentConversationsData,
  AdminListAgentConversationsErrors,
  AdminListAgentConversationsResponses,
  AdminListLlmProviderRunwayData,
  AdminListLlmProviderRunwayErrors,
  AdminListLlmProviderRunwayResponses,
  AdminListLlmProviderTopupsData,
  AdminListLlmProviderTopupsErrors,
  AdminListLlmProviderTopupsResponses,
  AdminListSystemAgentCategoriesData,
  AdminListSystemAgentCategoriesErrors,
  AdminListSystemAgentCategoriesResponses,
  AdminListSystemAgentTemplatesData,
  AdminListSystemAgentTemplatesErrors,
  AdminListSystemAgentTemplatesResponses,
  AdminListSystemAgentTemplateVersionsData,
  AdminListSystemAgentTemplateVersionsErrors,
  AdminListSystemAgentTemplateVersionsResponses,
  AdminListUserAgentsData,
  AdminListUserAgentsErrors,
  AdminListUserAgentsResponses,
  AdminMakeUserWholeData,
  AdminMakeUserWholeErrors,
  AdminMakeUserWholeResponses,
  AdminPublishSystemAgentTemplateData,
  AdminPublishSystemAgentTemplateErrors,
  AdminPublishSystemAgentTemplateResponses,
  AdminPutSystemAgentCategoryTranslationData,
  AdminPutSystemAgentCategoryTranslationErrors,
  AdminPutSystemAgentCategoryTranslationResponses,
  AdminPutSystemAgentTemplateContentData,
  AdminPutSystemAgentTemplateContentErrors,
  AdminPutSystemAgentTemplateContentResponses,
  AdminPutSystemAgentTemplateTranslationData,
  AdminPutSystemAgentTemplateTranslationErrors,
  AdminPutSystemAgentTemplateTranslationResponses,
  AdminRestoreSystemAgentTemplateVersionData,
  AdminRestoreSystemAgentTemplateVersionErrors,
  AdminRestoreSystemAgentTemplateVersionResponses,
  AdminUnpublishSystemAgentTemplateData,
  AdminUnpublishSystemAgentTemplateErrors,
  AdminUnpublishSystemAgentTemplateResponses,
  AdminUpdateSystemAgentCategoryData,
  AdminUpdateSystemAgentCategoryErrors,
  AdminUpdateSystemAgentCategoryResponses,
  AdminUpdateSystemAgentTemplateData,
  AdminUpdateSystemAgentTemplateDraftData,
  AdminUpdateSystemAgentTemplateDraftErrors,
  AdminUpdateSystemAgentTemplateDraftResponses,
  AdminUpdateSystemAgentTemplateErrors,
  AdminUpdateSystemAgentTemplateResponses,
  AdminVendorReconciliationData,
  AdminVendorReconciliationErrors,
  AdminVendorReconciliationResponses,
  AppendConversationMessagesData,
  AppendConversationMessagesErrors,
  AppendConversationMessagesResponses,
  ApplyOrganizedAgentMemoriesData,
  ApplyOrganizedAgentMemoriesErrors,
  ApplyOrganizedAgentMemoriesResponses,
  ApplyPreConnectionSettingsData2,
  ApplyPreConnectionSettingsErrors,
  ApplyPreConnectionSettingsResponses,
  BulkDeleteNotificationsData,
  BulkDeleteNotificationsErrors,
  BulkDeleteNotificationsResponses,
  BulkSetAgentExtensionToolsData,
  BulkSetAgentExtensionToolsErrors,
  BulkSetAgentExtensionToolsResponses,
  ChangePasswordConfirmData,
  ChangePasswordConfirmErrors,
  ChangePasswordConfirmResponses,
  ChangePasswordRequestData,
  ChangePasswordRequestErrors,
  ChangePasswordRequestResponses,
  CheckConnectionPolicyData,
  CheckConnectionPolicyErrors,
  CheckConnectionPolicyResponses,
  ClaimInteractiveApprovalSessionData,
  ClaimInteractiveApprovalSessionErrors,
  ClaimInteractiveApprovalSessionResponses,
  CloneSystemAgentData,
  CloneSystemAgentErrors,
  CloneSystemAgentResponses,
  CompactConversationData,
  CompactConversationErrors,
  CompactConversationResponses,
  ConfirmEmailData,
  ConfirmEmailErrors,
  ConfirmEmailResponses,
  ConnectCalDavData,
  ConnectCalDavErrors,
  ConnectCalDavResponses,
  ConnectGoogleChatData,
  ConnectGoogleChatErrors,
  ConnectGoogleChatResponses,
  ConnectIcsFeedData,
  ConnectIcsFeedErrors,
  ConnectIcsFeedResponses,
  ConnectMattermostData,
  ConnectMattermostErrors,
  ConnectMattermostResponses,
  ConnectSmtpData,
  ConnectSmtpErrors,
  ConnectSmtpResponses,
  ConnectTelegramData,
  ConnectTelegramErrors,
  ConnectTelegramResponses,
  ConnectTwilioWhatsAppData,
  ConnectTwilioWhatsAppErrors,
  ConnectTwilioWhatsAppResponses,
  ConsumeConnectionHandoffPolicyData,
  ConsumeConnectionHandoffPolicyErrors,
  ConsumeConnectionHandoffPolicyResponses,
  ConvertBehaviorToInstructionsData,
  ConvertBehaviorToInstructionsDualData,
  ConvertBehaviorToInstructionsDualErrors,
  ConvertBehaviorToInstructionsDualResponses,
  ConvertBehaviorToInstructionsErrors,
  ConvertBehaviorToInstructionsResponses,
  CopyPatternData,
  CopyPatternErrors,
  CopyPatternResponses,
  CreateAdminMcpServerData,
  CreateAdminMcpServerErrors,
  CreateAdminMcpServerResponses,
  CreateAgentData,
  CreateAgentErrors,
  CreateAgentFromQuestionnaireAsyncData,
  CreateAgentFromQuestionnaireAsyncErrors,
  CreateAgentFromQuestionnaireAsyncResponses,
  CreateAgentFromQuestionnaireData,
  CreateAgentFromQuestionnaireErrors,
  CreateAgentFromQuestionnaireResponses,
  CreateAgentGuardrailData,
  CreateAgentGuardrailErrors,
  CreateAgentGuardrailFromFileData,
  CreateAgentGuardrailFromFileErrors,
  CreateAgentGuardrailFromFileResponses,
  CreateAgentGuardrailResponses,
  CreateAgentInstructionData,
  CreateAgentInstructionErrors,
  CreateAgentInstructionResponses,
  CreateAgentQueryData,
  CreateAgentQueryErrors,
  CreateAgentQueryResponses,
  CreateAgentResponses,
  CreateAgentSubAgentRelationshipData,
  CreateAgentSubAgentRelationshipErrors,
  CreateAgentSubAgentRelationshipResponses,
  CreateApiTokenData,
  CreateApiTokenErrors,
  CreateApiTokenResponses,
  CreateBillingPlanVersionData,
  CreateBillingPlanVersionErrors,
  CreateBillingPlanVersionResponses,
  CreateBillingPriceData,
  CreateBillingPriceErrors,
  CreateBillingPriceResponses,
  CreateCheckoutSessionApiBillingCheckoutSessionPostData,
  CreateCheckoutSessionApiBillingCheckoutSessionPostErrors,
  CreateCheckoutSessionApiBillingCheckoutSessionPostResponses,
  CreateConversationData,
  CreateConversationErrors,
  CreateConversationResponses,
  CreateHumanTaskData,
  CreateHumanTaskErrors,
  CreateHumanTaskResponses,
  CreateMcpData,
  CreateMcpErrors,
  CreateMcpResponses,
  CreatePatternData,
  CreatePatternErrors,
  CreatePatternGuardrailData,
  CreatePatternGuardrailErrors,
  CreatePatternGuardrailResponses,
  CreatePatternInstructionData,
  CreatePatternInstructionErrors,
  CreatePatternInstructionResponses,
  CreatePatternResponses,
  CreatePortalSessionApiBillingPortalSessionPostData,
  CreatePortalSessionApiBillingPortalSessionPostErrors,
  CreatePortalSessionApiBillingPortalSessionPostResponses,
  CreatePromotionApiAdminPromotionsPostData,
  CreatePromotionApiAdminPromotionsPostErrors,
  CreatePromotionApiAdminPromotionsPostResponses,
  CreateReferralInviteData,
  CreateReferralInviteErrors,
  CreateReferralInviteResponses,
  CreateReferralTemplateData,
  CreateReferralTemplateErrors,
  CreateReferralTemplateResponses,
  CreateReferrerData,
  CreateReferrerErrors,
  CreateReferrerResponses,
  CreateSetupIntentApiBillingSetupIntentPostData,
  CreateSetupIntentApiBillingSetupIntentPostErrors,
  CreateSetupIntentApiBillingSetupIntentPostResponses,
  CreateSharedLinkData,
  CreateSharedLinkErrors,
  CreateSharedLinkResponses,
  CreateSupportTicketApiSupportTicketsPostData,
  CreateSupportTicketApiSupportTicketsPostErrors,
  CreateSupportTicketApiSupportTicketsPostResponses,
  CreateTelegramSharedLinkCodeData,
  CreateTelegramSharedLinkCodeErrors,
  CreateTelegramSharedLinkCodeResponses,
  CreateToolData,
  CreateToolErrors,
  CreateToolResponses,
  CreateWebhookEndpointData,
  CreateWebhookEndpointErrors,
  CreateWebhookEndpointResponses,
  DecideApprovalApiApprovalsApprovalIdDecidePostData,
  DecideApprovalApiApprovalsApprovalIdDecidePostErrors,
  DecideApprovalApiApprovalsApprovalIdDecidePostResponses,
  DecideDeadLetterCaseData,
  DecideDeadLetterCaseErrors,
  DecideDeadLetterCaseResponses,
  DeleteAdminMcpServerData,
  DeleteAdminMcpServerErrors,
  DeleteAdminMcpServerResponses,
  DeleteAgentData,
  DeleteAgentDocumentData,
  DeleteAgentDocumentErrors,
  DeleteAgentDocumentResponses,
  DeleteAgentErrors,
  DeleteAgentGuardrailData,
  DeleteAgentGuardrailErrors,
  DeleteAgentGuardrailResponses,
  DeleteAgentInstructionData,
  DeleteAgentInstructionErrors,
  DeleteAgentInstructionResponses,
  DeleteAgentMemoryData,
  DeleteAgentMemoryErrors,
  DeleteAgentMemoryResponses,
  DeleteAgentQueryData,
  DeleteAgentQueryErrors,
  DeleteAgentQueryResponses,
  DeleteAgentResponses,
  DeleteAgentSubAgentRelationshipData,
  DeleteAgentSubAgentRelationshipErrors,
  DeleteAgentSubAgentRelationshipResponses,
  DeleteAgentWizardDraftData,
  DeleteAgentWizardDraftErrors,
  DeleteAgentWizardDraftResponses,
  DeleteConversationData,
  DeleteConversationErrors,
  DeleteConversationResponses,
  DeleteHumanTaskData,
  DeleteHumanTaskErrors,
  DeleteHumanTaskResponses,
  DeleteMcpData,
  DeleteMcpErrors,
  DeleteMcpResponses,
  DeleteNotificationData,
  DeleteNotificationErrors,
  DeleteNotificationResponses,
  DeletePatternData,
  DeletePatternDocumentData,
  DeletePatternDocumentErrors,
  DeletePatternDocumentResponses,
  DeletePatternErrors,
  DeletePatternGuardrailData,
  DeletePatternGuardrailErrors,
  DeletePatternGuardrailResponses,
  DeletePatternInstructionData,
  DeletePatternInstructionErrors,
  DeletePatternInstructionResponses,
  DeletePatternResponses,
  DeleteReadNotificationsData,
  DeleteReadNotificationsErrors,
  DeleteReadNotificationsResponses,
  DeleteReferralInviteData,
  DeleteReferralInviteErrors,
  DeleteReferralInviteResponses,
  DeleteToolData,
  DeleteToolErrors,
  DeleteToolResponses,
  DeleteWebhookEndpointData,
  DeleteWebhookEndpointErrors,
  DeleteWebhookEndpointResponses,
  DesignSubAgentsData,
  DesignSubAgentsErrors,
  DesignSubAgentsResponses,
  DisableAgentExtensionTriggerData,
  DisableAgentExtensionTriggerErrors,
  DisableAgentExtensionTriggerResponses,
  DisableNonChatModelsData,
  DisableNonChatModelsErrors,
  DisableNonChatModelsResponses,
  DisconnectUserConnectionData,
  DisconnectUserConnectionErrors,
  DisconnectUserConnectionResponses,
  DismissAgentOpenLoopData,
  DismissAgentOpenLoopErrors,
  DismissAgentOpenLoopResponses,
  DismissSubAgentKeepOfferData,
  DismissSubAgentKeepOfferErrors,
  DismissSubAgentKeepOfferResponses,
  DownloadTicketAttachmentApiSupportTicketsTicketIdAttachmentsAttachmentIdGetData,
  DownloadTicketAttachmentApiSupportTicketsTicketIdAttachmentsAttachmentIdGetErrors,
  DownloadTicketAttachmentApiSupportTicketsTicketIdAttachmentsAttachmentIdGetResponses,
  EnableAgentExtensionTriggerData,
  EnableAgentExtensionTriggerErrors,
  EnableAgentExtensionTriggerResponses,
  EnrollExtensionConnectionData,
  EnrollExtensionConnectionErrors,
  EnrollExtensionConnectionResponses,
  EnrollReferralProgramData,
  EnrollReferralProgramErrors,
  EnrollReferralProgramResponses,
  ExecuteUnsubscribeSelectionData,
  ExecuteUnsubscribeSelectionErrors,
  ExecuteUnsubscribeSelectionResponses,
  ExportReferralTaxReportData,
  ExportReferralTaxReportErrors,
  ExportReferralTaxReportResponses,
  ExtractAgentEditChatData,
  ExtractAgentEditChatErrors,
  ExtractAgentEditChatResponses,
  ExtractWizardChatDataData,
  ExtractWizardChatDataErrors,
  ExtractWizardChatDataResponses,
  ForgotPasswordData,
  ForgotPasswordErrors,
  ForgotPasswordResponses,
  GeneratePromoLinkApiAdminPromotionsPromotionIdGenerateTokenPostData,
  GeneratePromoLinkApiAdminPromotionsPromotionIdGenerateTokenPostErrors,
  GeneratePromoLinkApiAdminPromotionsPromotionIdGenerateTokenPostResponses,
  GenerateStreamData,
  GenerateStreamErrors,
  GenerateStreamResponses,
  GetAdminUserData,
  GetAdminUserErrors,
  GetAdminUserResponses,
  GetAgentChatKnowledgePreferenceData,
  GetAgentChatKnowledgePreferenceErrors,
  GetAgentChatKnowledgePreferenceResponses,
  GetAgentCreationJobData,
  GetAgentCreationJobErrors,
  GetAgentCreationJobResponses,
  GetAgentCreationModelsData,
  GetAgentCreationModelsErrors,
  GetAgentCreationModelsResponses,
  GetAgentData,
  GetAgentDocumentData,
  GetAgentDocumentErrors,
  GetAgentDocumentResponses,
  GetAgentDocumentsHealthData,
  GetAgentDocumentsHealthErrors,
  GetAgentDocumentsHealthResponses,
  GetAgentEditChatReadOnlyFieldsData,
  GetAgentEditChatReadOnlyFieldsErrors,
  GetAgentEditChatReadOnlyFieldsResponses,
  GetAgentErrors,
  GetAgentGuardrailData,
  GetAgentGuardrailErrors,
  GetAgentGuardrailResponses,
  GetAgentInstructionData,
  GetAgentInstructionErrors,
  GetAgentInstructionResponses,
  GetAgentKnowledgeUploadPolicyData,
  GetAgentKnowledgeUploadPolicyErrors,
  GetAgentKnowledgeUploadPolicyResponses,
  GetAgentLlmInfoData,
  GetAgentLlmInfoErrors,
  GetAgentLlmInfoResponses,
  GetAgentQueryData,
  GetAgentQueryErrors,
  GetAgentQueryResponses,
  GetAgentQuestionnaireConnectionQuestionsData,
  GetAgentQuestionnaireConnectionQuestionsErrors,
  GetAgentQuestionnaireConnectionQuestionsResponses,
  GetAgentQuestionnaireContextualQuestionsData,
  GetAgentQuestionnaireContextualQuestionsErrors,
  GetAgentQuestionnaireContextualQuestionsResponses,
  GetAgentQuestionnaireFollowUpQuestionsData,
  GetAgentQuestionnaireFollowUpQuestionsErrors,
  GetAgentQuestionnaireFollowUpQuestionsResponses,
  GetAgentQuestionnaireToolQuestionsData,
  GetAgentQuestionnaireToolQuestionsErrors,
  GetAgentQuestionnaireToolQuestionsResponses,
  GetAgentResponses,
  GetAgentRouterSummaryData,
  GetAgentRouterSummaryErrors,
  GetAgentRouterSummaryResponses,
  GetAgentSubAgentKeepPreferenceData,
  GetAgentSubAgentKeepPreferenceErrors,
  GetAgentSubAgentKeepPreferenceResponses,
  GetAgentSyncConflictData,
  GetAgentSyncConflictErrors,
  GetAgentSyncConflictResponses,
  GetAgentSystemPromptData,
  GetAgentSystemPromptErrors,
  GetAgentSystemPromptResponses,
  GetAgentUpdateJobData,
  GetAgentUpdateJobErrors,
  GetAgentUpdateJobResponses,
  GetAgentWizardDraftData,
  GetAgentWizardDraftErrors,
  GetAgentWizardDraftResponses,
  GetApprovalApiApprovalsApprovalIdGetData,
  GetApprovalApiApprovalsApprovalIdGetErrors,
  GetApprovalApiApprovalsApprovalIdGetResponses,
  GetApprovalExecutionHealthApiApprovalQueueRequestIdHealthGetData,
  GetApprovalExecutionHealthApiApprovalQueueRequestIdHealthGetErrors,
  GetApprovalExecutionHealthApiApprovalQueueRequestIdHealthGetResponses,
  GetAuthMeData,
  GetAuthMeErrors,
  GetAuthMeResponses,
  GetAutoRechargeConfigApiBillingAutoRechargeGetData,
  GetAutoRechargeConfigApiBillingAutoRechargeGetErrors,
  GetAutoRechargeConfigApiBillingAutoRechargeGetResponses,
  GetBillingAccountStatusData,
  GetBillingAccountStatusErrors,
  GetBillingAccountStatusResponses,
  GetChatCapabilitiesData,
  GetChatCapabilitiesErrors,
  GetChatCapabilitiesResponses,
  GetConnectionHandoffPolicyData,
  GetConnectionHandoffPolicyErrors,
  GetConnectionHandoffPolicyResponses,
  GetConnectionSettingsData,
  GetConnectionSettingsErrors,
  GetConnectionSettingsResponses,
  GetConversationActiveRunData,
  GetConversationActiveRunErrors,
  GetConversationActiveRunResponses,
  GetConversationContextUsageData,
  GetConversationContextUsageErrors,
  GetConversationContextUsageResponses,
  GetConversationData,
  GetConversationErrors,
  GetConversationResponses,
  GetDeveloperTraceData,
  GetDeveloperTraceErrors,
  GetDeveloperTraceResponses,
  GetEmailTierPolicyData,
  GetEmailTierPolicyErrors,
  GetEmailTierPolicyResponses,
  GetEphemeralAgentCleanupStatsData,
  GetEphemeralAgentCleanupStatsErrors,
  GetEphemeralAgentCleanupStatsResponses,
  GetExecutionDiagnosticsApiApprovalQueueRequestIdExecutionDiagnosticsGetData,
  GetExecutionDiagnosticsApiApprovalQueueRequestIdExecutionDiagnosticsGetErrors,
  GetExecutionDiagnosticsApiApprovalQueueRequestIdExecutionDiagnosticsGetResponses,
  GetExecutionStatusApiApprovalQueueRequestIdExecutionStatusGetData,
  GetExecutionStatusApiApprovalQueueRequestIdExecutionStatusGetErrors,
  GetExecutionStatusApiApprovalQueueRequestIdExecutionStatusGetResponses,
  GetGenerateStreamLinesData,
  GetGenerateStreamLinesErrors,
  GetGenerateStreamLinesResponses,
  GetGenerationParamsData,
  GetGenerationParamsErrors,
  GetGenerationParamsResponses,
  GetHealthData,
  GetHealthResponses,
  GetHumanTaskByQueryData,
  GetHumanTaskByQueryErrors,
  GetHumanTaskByQueryResponses,
  GetInstructionEvaluationApiAdminInstructionEvaluationsRunIdGetData,
  GetInstructionEvaluationApiAdminInstructionEvaluationsRunIdGetErrors,
  GetInstructionEvaluationApiAdminInstructionEvaluationsRunIdGetResponses,
  GetInteractiveApprovalSessionData,
  GetInteractiveApprovalSessionErrors,
  GetInteractiveApprovalSessionResponses,
  GetIsolationPolicyData,
  GetIsolationPolicyErrors,
  GetIsolationPolicyResponses,
  GetLastUsedConversationData,
  GetLastUsedConversationErrors,
  GetLastUsedConversationResponses,
  GetLlmProvidersAdminData,
  GetLlmProvidersAdminErrors,
  GetLlmProvidersAdminResponses,
  GetMcpCatalogIconData,
  GetMcpCatalogIconErrors,
  GetMcpCatalogIconResponses,
  GetMcpData,
  GetMcpErrors,
  GetMcpResponses,
  GetMessageLatencyApiAdminSupportMetricsMessagesMessageIdLatencyGetData,
  GetMessageLatencyApiAdminSupportMetricsMessagesMessageIdLatencyGetErrors,
  GetMessageLatencyApiAdminSupportMetricsMessagesMessageIdLatencyGetResponses,
  GetModelSyncLogEntriesData,
  GetModelSyncLogEntriesErrors,
  GetModelSyncLogEntriesResponses,
  GetNotificationsUnreadCountData,
  GetNotificationsUnreadCountErrors,
  GetNotificationsUnreadCountResponses,
  GetPatternData,
  GetPatternErrors,
  GetPatternResponses,
  GetPlatformVersionsData,
  GetPlatformVersionsErrors,
  GetPlatformVersionsResponses,
  GetPromotionApiAdminPromotionsPromotionIdGetData,
  GetPromotionApiAdminPromotionsPromotionIdGetErrors,
  GetPromotionApiAdminPromotionsPromotionIdGetResponses,
  GetPromptDiffApiAdminInstructionEvaluationsRunIdPromptDiffGetData,
  GetPromptDiffApiAdminInstructionEvaluationsRunIdPromptDiffGetErrors,
  GetPromptDiffApiAdminInstructionEvaluationsRunIdPromptDiffGetResponses,
  GetReferralDashboardData,
  GetReferralDashboardErrors,
  GetReferralDashboardResponses,
  GetReferralPublicConfigData,
  GetReferralPublicConfigResponses,
  GetReferralSettingsData,
  GetReferralSettingsErrors,
  GetReferralSettingsResponses,
  GetReferrerAdminDetailData,
  GetReferrerAdminDetailErrors,
  GetReferrerAdminDetailResponses,
  GetRelationshipTreeApiAgentsAgentIdRelationshipsTreeGetData,
  GetRelationshipTreeApiAgentsAgentIdRelationshipsTreeGetErrors,
  GetRelationshipTreeApiAgentsAgentIdRelationshipsTreeGetResponses,
  GetRouterModelsData,
  GetRouterModelsErrors,
  GetRouterModelsResponses,
  GetSharedConversationSharedTokenGetData,
  GetSharedConversationSharedTokenGetErrors,
  GetSharedConversationSharedTokenGetResponses,
  GetSystemAgentData,
  GetSystemAgentErrors,
  GetSystemAgentMonitoringApiAgentsSystemMonitoringGetData,
  GetSystemAgentMonitoringApiAgentsSystemMonitoringGetErrors,
  GetSystemAgentMonitoringApiAgentsSystemMonitoringGetResponses,
  GetSystemAgentOrchestrationHealthApiAgentsSystemAgentIdOrchestrationHealthGetData,
  GetSystemAgentOrchestrationHealthApiAgentsSystemAgentIdOrchestrationHealthGetErrors,
  GetSystemAgentOrchestrationHealthApiAgentsSystemAgentIdOrchestrationHealthGetResponses,
  GetSystemAgentResponses,
  GetTelegramSharedStatusData,
  GetTelegramSharedStatusErrors,
  GetTelegramSharedStatusResponses,
  GetTicketApiSupportTicketsTicketIdGetData,
  GetTicketApiSupportTicketsTicketIdGetErrors,
  GetTicketApiSupportTicketsTicketIdGetResponses,
  GetTicketMessagesApiSupportTicketsTicketIdMessagesGetData,
  GetTicketMessagesApiSupportTicketsTicketIdMessagesGetErrors,
  GetTicketMessagesApiSupportTicketsTicketIdMessagesGetResponses,
  GetToolConfigurationProposalsData,
  GetToolConfigurationProposalsErrors,
  GetToolConfigurationProposalsResponses,
  GetToolData,
  GetToolErrors,
  GetToolResponses,
  GetTransactionsApiBillingTransactionsGetData,
  GetTransactionsApiBillingTransactionsGetErrors,
  GetTransactionsApiBillingTransactionsGetResponses,
  GetUserLatencySummaryApiAdminSupportMetricsUsersUserIdLatencySummaryGetData,
  GetUserLatencySummaryApiAdminSupportMetricsUsersUserIdLatencySummaryGetErrors,
  GetUserLatencySummaryApiAdminSupportMetricsUsersUserIdLatencySummaryGetResponses,
  GetUserModelMigrationData,
  GetUserModelMigrationErrors,
  GetUserModelMigrationResponses,
  GetUsersMeAgentPlanSelectionData,
  GetUsersMeAgentPlanSelectionErrors,
  GetUsersMeAgentPlanSelectionResponses,
  GetUsersMeBillingStatusData,
  GetUsersMeBillingStatusErrors,
  GetUsersMeBillingStatusResponses,
  GetUsersMeData,
  GetUsersMeErrors,
  GetUsersMeExportData,
  GetUsersMeExportErrors,
  GetUsersMeExportResponses,
  GetUsersMeHomeSuggestionsData,
  GetUsersMeHomeSuggestionsErrors,
  GetUsersMeHomeSuggestionsResponses,
  GetUsersMePlanLimitsData,
  GetUsersMePlanLimitsErrors,
  GetUsersMePlanLimitsResponses,
  GetUsersMeResponses,
  GetUsersMeUsageData,
  GetUsersMeUsageErrors,
  GetUsersMeUsageResponses,
  GetWebhookEndpointData,
  GetWebhookEndpointErrors,
  GetWebhookEndpointResponses,
  HealthBrowserAutomationHealthBrowserAutomationGetData,
  HealthBrowserAutomationHealthBrowserAutomationGetResponses,
  HealthCodeExecutionHealthCodeExecutionGetData,
  HealthCodeExecutionHealthCodeExecutionGetResponses,
  HealthRagConfigHealthRagConfigGetData,
  HealthRagConfigHealthRagConfigGetErrors,
  HealthRagConfigHealthRagConfigGetResponses,
  HealthReadyHealthReadyGetData,
  HealthReadyHealthReadyGetResponses,
  HealthVersionHealthVersionGetData,
  HealthVersionHealthVersionGetErrors,
  HealthVersionHealthVersionGetResponses,
  IncomingGoogleChatApiChannelsGoogleChatIncomingUserConnectionIdPostData,
  IncomingGoogleChatApiChannelsGoogleChatIncomingUserConnectionIdPostErrors,
  IncomingGoogleChatApiChannelsGoogleChatIncomingUserConnectionIdPostResponses,
  IncomingMattermostApiChannelsMattermostIncomingPostData,
  IncomingMattermostApiChannelsMattermostIncomingPostResponses,
  IncomingSharedTelegramApiChannelsTelegramSharedIncomingPostData,
  IncomingSharedTelegramApiChannelsTelegramSharedIncomingPostResponses,
  IncomingTelegramApiChannelsTelegramIncomingUserConnectionIdPostData,
  IncomingTelegramApiChannelsTelegramIncomingUserConnectionIdPostErrors,
  IncomingTelegramApiChannelsTelegramIncomingUserConnectionIdPostResponses,
  IncomingWhatsappApiTwilioWhatsappIncomingPostData,
  IncomingWhatsappApiTwilioWhatsappIncomingPostResponses,
  IngestAgentDocumentData,
  IngestAgentDocumentErrors,
  IngestAgentDocumentResponses,
  IngestAgentDocumentUrlData,
  IngestAgentDocumentUrlErrors,
  IngestAgentDocumentUrlResponses,
  IngestDocumentData,
  IngestDocumentErrors,
  IngestDocumentResponses,
  IngestPatternDocumentData,
  IngestPatternDocumentErrors,
  IngestPatternDocumentResponses,
  IngestPatternDocumentUrlData,
  IngestPatternDocumentUrlErrors,
  IngestPatternDocumentUrlResponses,
  JoinReferralPartnerProgramData,
  JoinReferralPartnerProgramErrors,
  JoinReferralPartnerProgramResponses,
  KeepAgentSubAgentData,
  KeepAgentSubAgentErrors,
  KeepAgentSubAgentResponses,
  ListAdminAuditLogData,
  ListAdminAuditLogErrors,
  ListAdminAuditLogResponses,
  ListAdminConnectionTypesData,
  ListAdminConnectionTypesErrors,
  ListAdminConnectionTypesResponses,
  ListAdminMcpDiscoveryCandidatesData,
  ListAdminMcpDiscoveryCandidatesErrors,
  ListAdminMcpDiscoveryCandidatesResponses,
  ListAdminMcpServersData,
  ListAdminMcpServersErrors,
  ListAdminMcpServersResponses,
  ListAdminMcpSnapshotsData,
  ListAdminMcpSnapshotsErrors,
  ListAdminMcpSnapshotsResponses,
  ListAdminMcpToolsData,
  ListAdminMcpToolsErrors,
  ListAdminMcpToolsResponses,
  ListAdminRolesData,
  ListAdminRolesErrors,
  ListAdminRolesResponses,
  ListAdminUserAuditLogsData,
  ListAdminUserAuditLogsErrors,
  ListAdminUserAuditLogsResponses,
  ListAdminUsersData,
  ListAdminUsersErrors,
  ListAdminUsersResponses,
  ListAgentDocumentsData,
  ListAgentDocumentsErrors,
  ListAgentDocumentsResponses,
  ListAgentExecutionTraceData,
  ListAgentExecutionTraceErrors,
  ListAgentExecutionTraceResponses,
  ListAgentExtensionToolsData,
  ListAgentExtensionToolsErrors,
  ListAgentExtensionToolsResponses,
  ListAgentExtensionTriggersData,
  ListAgentExtensionTriggersErrors,
  ListAgentExtensionTriggersResponses,
  ListAgentGuardrailsData,
  ListAgentGuardrailsErrors,
  ListAgentGuardrailsResponses,
  ListAgentInstructionsData,
  ListAgentInstructionsErrors,
  ListAgentInstructionsResponses,
  ListAgentMemoriesData,
  ListAgentMemoriesErrors,
  ListAgentMemoriesResponses,
  ListAgentQueriesData,
  ListAgentQueriesErrors,
  ListAgentQueriesResponses,
  ListAgentsData,
  ListAgentsErrors,
  ListAgentSharedMemoryApiAgentsAgentIdSharedMemoryGetData,
  ListAgentSharedMemoryApiAgentsAgentIdSharedMemoryGetErrors,
  ListAgentSharedMemoryApiAgentsAgentIdSharedMemoryGetResponses,
  ListAgentsResponses,
  ListAgentStatsData,
  ListAgentStatsErrors,
  ListAgentStatsResponses,
  ListAgentSubAgentsData,
  ListAgentSubAgentsErrors,
  ListAgentSubAgentsResponses,
  ListAgentSyncConflictsData,
  ListAgentSyncConflictsErrors,
  ListAgentSyncConflictsResponses,
  ListAgentToolsData,
  ListAgentToolsErrors,
  ListAgentToolsResponses,
  ListAgentTriggerEventsData,
  ListAgentTriggerEventsErrors,
  ListAgentTriggerEventsResponses,
  ListAggregateStatsData,
  ListAggregateStatsErrors,
  ListAggregateStatsResponses,
  ListAllConnectionsData,
  ListAllConnectionsErrors,
  ListAllConnectionsResponses,
  ListApiTokensData,
  ListApiTokensErrors,
  ListApiTokensResponses,
  ListApprovalsApiApprovalsGetData,
  ListApprovalsApiApprovalsGetErrors,
  ListApprovalsApiApprovalsGetResponses,
  ListBillingPlansData,
  ListBillingPlansErrors,
  ListBillingPlansResponses,
  ListBillingPricingData,
  ListBillingPricingErrors,
  ListBillingPricingResponses,
  ListConnectionCatalogData,
  ListConnectionCatalogErrors,
  ListConnectionCatalogResponses,
  ListConnectionProviderToolsData,
  ListConnectionProviderToolsErrors,
  ListConnectionProviderToolsResponses,
  ListConnectionsData,
  ListConnectionsErrors,
  ListConnectionsResponses,
  ListConversationsData,
  ListConversationsErrors,
  ListConversationsResponses,
  ListDelegationEventsApiAgentsAgentIdOrchestrationDelegationsGetData,
  ListDelegationEventsApiAgentsAgentIdOrchestrationDelegationsGetErrors,
  ListDelegationEventsApiAgentsAgentIdOrchestrationDelegationsGetResponses,
  ListEligibleToolsForAgentEditData,
  ListEligibleToolsForAgentEditErrors,
  ListEligibleToolsForAgentEditResponses,
  ListExtensionProviderConfigsData,
  ListExtensionProviderConfigsErrors,
  ListExtensionProviderConfigsResponses,
  ListExtensionToolConfigsData,
  ListExtensionToolConfigsErrors,
  ListExtensionToolConfigsResponses,
  ListExtensionToolkitsData,
  ListExtensionToolkitsErrors,
  ListExtensionToolkitsResponses,
  ListHumanTasksData,
  ListHumanTasksErrors,
  ListHumanTasksResponses,
  ListIcsFeedUrlsData,
  ListIcsFeedUrlsErrors,
  ListIcsFeedUrlsResponses,
  ListInstructionEvaluationsApiAdminInstructionEvaluationsGetData,
  ListInstructionEvaluationsApiAdminInstructionEvaluationsGetErrors,
  ListInstructionEvaluationsApiAdminInstructionEvaluationsGetResponses,
  ListInstructionMismatchesApiAdminInstructionEvaluationsMismatchesGetData,
  ListInstructionMismatchesApiAdminInstructionEvaluationsMismatchesGetErrors,
  ListInstructionMismatchesApiAdminInstructionEvaluationsMismatchesGetResponses,
  ListIsolationAuditEventsData,
  ListIsolationAuditEventsErrors,
  ListIsolationAuditEventsResponses,
  ListLlmProvidersData,
  ListLlmProvidersErrors,
  ListLlmProvidersResponses,
  ListLlmProviderTiersData,
  ListLlmProviderTiersErrors,
  ListLlmProviderTiersResponses,
  ListMcpCatalogData,
  ListMcpCatalogErrors,
  ListMcpCatalogResponses,
  ListMcpCatalogToolsData,
  ListMcpCatalogToolsErrors,
  ListMcpCatalogToolsResponses,
  ListMcpData,
  ListMcpErrors,
  ListMcpResourcesData,
  ListMcpResourcesErrors,
  ListMcpResourcesResponses,
  ListMcpResponses,
  ListMcpToolsData,
  ListMcpToolsErrors,
  ListMcpToolsResponses,
  ListModelsData,
  ListModelsErrors,
  ListModelsResponses,
  ListModelSyncLogsData,
  ListModelSyncLogsErrors,
  ListModelSyncLogsResponses,
  ListNotificationsData,
  ListNotificationsErrors,
  ListNotificationsResponses,
  ListOrchestrationEventsApiAgentsAgentIdOrchestrationEventsGetData,
  ListOrchestrationEventsApiAgentsAgentIdOrchestrationEventsGetErrors,
  ListOrchestrationEventsApiAgentsAgentIdOrchestrationEventsGetResponses,
  ListPatternConnectedAgentsData,
  ListPatternConnectedAgentsErrors,
  ListPatternConnectedAgentsResponses,
  ListPatternGuardrailsData,
  ListPatternGuardrailsErrors,
  ListPatternGuardrailsResponses,
  ListPatternInstructionsData,
  ListPatternInstructionsErrors,
  ListPatternInstructionsResponses,
  ListPatternsData,
  ListPatternsErrors,
  ListPatternsResponses,
  ListPatternToolsData,
  ListPatternToolsErrors,
  ListPatternToolsResponses,
  ListPendingDeadLetterCasesData,
  ListPendingDeadLetterCasesErrors,
  ListPendingDeadLetterCasesResponses,
  ListPlatformSettingsData,
  ListPlatformSettingsErrors,
  ListPlatformSettingsResponses,
  ListPromotionsApiAdminPromotionsGetData,
  ListPromotionsApiAdminPromotionsGetErrors,
  ListPromotionsApiAdminPromotionsGetResponses,
  ListPromotionUsagesApiAdminPromotionsPromotionIdUsagesGetData,
  ListPromotionUsagesApiAdminPromotionsPromotionIdUsagesGetErrors,
  ListPromotionUsagesApiAdminPromotionsPromotionIdUsagesGetResponses,
  ListPublicSystemAgentCategoriesData,
  ListPublicSystemAgentCategoriesErrors,
  ListPublicSystemAgentCategoriesResponses,
  ListPublicSystemAgentsData,
  ListPublicSystemAgentsErrors,
  ListPublicSystemAgentsResponses,
  ListReferralCommissionsData,
  ListReferralCommissionsErrors,
  ListReferralCommissionsResponses,
  ListReferralInvitesData,
  ListReferralInvitesErrors,
  ListReferralInvitesResponses,
  ListReferralSignupsData,
  ListReferralSignupsErrors,
  ListReferralSignupsResponses,
  ListReferralTemplatesData,
  ListReferralTemplatesErrors,
  ListReferralTemplatesResponses,
  ListReferralUserCommissionsData,
  ListReferralUserCommissionsErrors,
  ListReferralUserCommissionsResponses,
  ListReferrersData,
  ListReferrersErrors,
  ListReferrersResponses,
  ListSharedLinksData,
  ListSharedLinksErrors,
  ListSharedLinksResponses,
  ListSmtpFoldersData,
  ListSmtpFoldersErrors,
  ListSmtpFoldersResponses,
  ListSystemAgentCategoriesData,
  ListSystemAgentCategoriesErrors,
  ListSystemAgentCategoriesResponses,
  ListSystemAgentsData,
  ListSystemAgentsErrors,
  ListSystemAgentsResponses,
  ListTicketsApiSupportTicketsGetData,
  ListTicketsApiSupportTicketsGetErrors,
  ListTicketsApiSupportTicketsGetResponses,
  ListToolsData,
  ListToolsErrors,
  ListToolsResponses,
  ListWebhookDeliveriesData,
  ListWebhookDeliveriesErrors,
  ListWebhookDeliveriesResponses,
  ListWebhookEndpointsData,
  ListWebhookEndpointsErrors,
  ListWebhookEndpointsResponses,
  LoginData,
  LoginErrors,
  LoginResponses,
  LogoutData,
  LogoutResponses,
  MarkAllNotificationsReadData,
  MarkAllNotificationsReadErrors,
  MarkAllNotificationsReadResponses,
  MarkNotificationReadData,
  MarkNotificationReadErrors,
  MarkNotificationReadResponses,
  MfaRecoveryRegenerateData,
  MfaRecoveryRegenerateErrors,
  MfaRecoveryRegenerateResponses,
  MfaStatusData,
  MfaStatusErrors,
  MfaStatusResponses,
  MfaTotpConfirmData,
  MfaTotpConfirmErrors,
  MfaTotpConfirmResponses,
  MfaTotpDisableData,
  MfaTotpDisableErrors,
  MfaTotpDisableResponses,
  MfaTotpEnrollData,
  MfaTotpEnrollErrors,
  MfaTotpEnrollResponses,
  MfaVerifyData,
  MfaVerifyErrors,
  MfaVerifyResponses,
  ModelsListModelsGetData,
  ModelsListModelsGetResponses,
  OrganizeAgentMemoriesData,
  OrganizeAgentMemoriesErrors,
  OrganizeAgentMemoriesResponses,
  OverrideReferralAttributionData,
  OverrideReferralAttributionErrors,
  OverrideReferralAttributionResponses,
  PasskeyConfigData,
  PasskeyConfigResponses,
  PasskeyDeleteData,
  PasskeyDeleteErrors,
  PasskeyDeleteResponses,
  PasskeyListData,
  PasskeyListErrors,
  PasskeyListResponses,
  PasskeyLoginOptionsData,
  PasskeyLoginOptionsResponses,
  PasskeyLoginVerifyData,
  PasskeyLoginVerifyErrors,
  PasskeyLoginVerifyResponses,
  PasskeyRegisterOptionsData,
  PasskeyRegisterOptionsErrors,
  PasskeyRegisterOptionsResponses,
  PasskeyRegisterVerifyData,
  PasskeyRegisterVerifyErrors,
  PasskeyRegisterVerifyResponses,
  PasskeyRenameData,
  PasskeyRenameErrors,
  PasskeyRenameResponses,
  PasswordBreachCheckData,
  PasswordBreachCheckErrors,
  PasswordBreachCheckResponses,
  PatchAuthMeData,
  PatchAuthMeErrors,
  PatchAuthMeResponses,
  PendingCountApiApprovalsPendingCountGetData,
  PendingCountApiApprovalsPendingCountGetErrors,
  PendingCountApiApprovalsPendingCountGetResponses,
  PostSharedChatSharedTokenChatPostData,
  PostSharedChatSharedTokenChatPostErrors,
  PostSharedChatSharedTokenChatPostResponses,
  PostUsersMeDeleteData,
  PostUsersMeDeleteErrors,
  PostUsersMeDeleteResponses,
  PreviewReferralPayoutsData,
  PreviewReferralPayoutsErrors,
  PreviewReferralPayoutsResponses,
  PreviewUnsubscribeCandidatesData,
  PreviewUnsubscribeCandidatesErrors,
  PreviewUnsubscribeCandidatesResponses,
  ProbeMcpData,
  ProbeMcpErrors,
  ProbeMcpResponses,
  ProbeSmtpDavCapabilitiesData,
  ProbeSmtpDavCapabilitiesErrors,
  ProbeSmtpDavCapabilitiesResponses,
  PromoPreviewApiBillingPromoPreviewGetData,
  PromoPreviewApiBillingPromoPreviewGetErrors,
  PromoPreviewApiBillingPromoPreviewGetResponses,
  ProxyCanaryHealthProxyCanaryGetData,
  ProxyCanaryHealthProxyCanaryGetResponses,
  PurgeInstructionEvaluationsApiAdminInstructionEvaluationsPurgeExpiredPostData,
  PurgeInstructionEvaluationsApiAdminInstructionEvaluationsPurgeExpiredPostErrors,
  PurgeInstructionEvaluationsApiAdminInstructionEvaluationsPurgeExpiredPostResponses,
  PutAgentChatKnowledgePreferenceData,
  PutAgentChatKnowledgePreferenceErrors,
  PutAgentChatKnowledgePreferenceResponses,
  PutAgentSubAgentKeepPreferenceData,
  PutAgentSubAgentKeepPreferenceErrors,
  PutAgentSubAgentKeepPreferenceResponses,
  ReapplyReferrerTemplateData,
  ReapplyReferrerTemplateErrors,
  ReapplyReferrerTemplateResponses,
  ReassignLlmModelTiersData,
  ReassignLlmModelTiersErrors,
  ReassignLlmModelTiersResponses,
  RedeliverWebhookDeliveryData,
  RedeliverWebhookDeliveryErrors,
  RedeliverWebhookDeliveryResponses,
  ReenableWebhookEndpointData,
  ReenableWebhookEndpointErrors,
  ReenableWebhookEndpointResponses,
  RegenerateAgentPromptData,
  RegenerateAgentPromptErrors,
  RegenerateAgentPromptResponses,
  RegisterData,
  RegisterErrors,
  RegisterExtensionWebhookSubscriptionData,
  RegisterExtensionWebhookSubscriptionErrors,
  RegisterExtensionWebhookSubscriptionResponses,
  RegisterMobileDeviceTokenData,
  RegisterMobileDeviceTokenErrors,
  RegisterMobileDeviceTokenResponses,
  RegisterResponses,
  ReindexAgentDocumentsData,
  ReindexAgentDocumentsErrors,
  ReindexAgentDocumentsResponses,
  ReindexAllDocumentsData,
  ReindexAllDocumentsErrors,
  ReindexAllDocumentsResponses,
  RemoveAgentToolData,
  RemoveAgentToolErrors,
  RemoveAgentToolResponses,
  RemoveIcsFeedUrlData,
  RemoveIcsFeedUrlErrors,
  RemoveIcsFeedUrlResponses,
  RemovePatternToolData,
  RemovePatternToolErrors,
  RemovePatternToolResponses,
  RemoveReferrerData,
  RemoveReferrerErrors,
  RemoveReferrerResponses,
  ReplyToTicketApiSupportTicketsTicketIdMessagesPostData,
  ReplyToTicketApiSupportTicketsTicketIdMessagesPostErrors,
  ReplyToTicketApiSupportTicketsTicketIdMessagesPostResponses,
  ResendConfirmationData,
  ResendConfirmationErrors,
  ResendConfirmationResponses,
  ResetPasswordData,
  ResetPasswordErrors,
  ResetPasswordResponses,
  ResetPlatformSettingData,
  ResetPlatformSettingErrors,
  ResetPlatformSettingResponses,
  ResolveAgentSyncConflictData,
  ResolveAgentSyncConflictErrors,
  ResolveAgentSyncConflictResponses,
  RetryAgentCreationJobData,
  RetryAgentCreationJobErrors,
  RetryAgentCreationJobGetHintData,
  RetryAgentCreationJobGetHintErrors,
  RetryAgentCreationJobGetHintResponses,
  RetryAgentCreationJobResponses,
  RetryAgentUpdateJobData,
  RetryAgentUpdateJobErrors,
  RetryAgentUpdateJobResponses,
  RevalidateInstructionEvaluationApiAdminInstructionEvaluationsRunIdRevalidatePostData,
  RevalidateInstructionEvaluationApiAdminInstructionEvaluationsRunIdRevalidatePostErrors,
  RevalidateInstructionEvaluationApiAdminInstructionEvaluationsRunIdRevalidatePostResponses,
  ReviewAdminMcpToolsData,
  ReviewAdminMcpToolsErrors,
  ReviewAdminMcpToolsResponses,
  RevokeApiTokenData,
  RevokeApiTokenErrors,
  RevokeApiTokenResponses,
  RevokeExtensionConnectionData,
  RevokeExtensionConnectionErrors,
  RevokeExtensionConnectionResponses,
  RevokePromotionApiAdminPromotionsPromotionIdRevokePostData,
  RevokePromotionApiAdminPromotionsPromotionIdRevokePostErrors,
  RevokePromotionApiAdminPromotionsPromotionIdRevokePostResponses,
  RevokeReferralInviteData,
  RevokeReferralInviteErrors,
  RevokeReferralInviteResponses,
  RevokeSharedLinkData,
  RevokeSharedLinkErrors,
  RevokeSharedLinkResponses,
  RotateReferralInviteData,
  RotateReferralInviteErrors,
  RotateReferralInviteResponses,
  RotateReferrerCodeData,
  RotateReferrerCodeErrors,
  RotateReferrerCodeResponses,
  RotateWebhookSecretData,
  RotateWebhookSecretErrors,
  RotateWebhookSecretResponses,
  RunActiveAgentRagReadinessPassData,
  RunActiveAgentRagReadinessPassErrors,
  RunActiveAgentRagReadinessPassResponses,
  RunAdminMcpDiscoveryData,
  RunAdminMcpDiscoveryErrors,
  RunAdminMcpDiscoveryResponses,
  RunAdminMcpServerDiscoveryData,
  RunAdminMcpServerDiscoveryErrors,
  RunAdminMcpServerDiscoveryResponses,
  RunAgentTestSandboxData,
  RunAgentTestSandboxErrors,
  RunAgentTestSandboxResponses,
  RunEphemeralAgentCleanupData,
  RunEphemeralAgentCleanupErrors,
  RunEphemeralAgentCleanupResponses,
  RunReferralPayoutsData,
  RunReferralPayoutsErrors,
  RunReferralPayoutsResponses,
  RunStartupChecksData,
  RunStartupChecksErrors,
  RunStartupChecksResponses,
  SaveAgentWizardDraftData,
  SaveAgentWizardDraftErrors,
  SaveAgentWizardDraftResponses,
  SaveUsersMeAgentPlanSelectionData,
  SaveUsersMeAgentPlanSelectionErrors,
  SaveUsersMeAgentPlanSelectionResponses,
  SessionListData,
  SessionListErrors,
  SessionListResponses,
  SessionRevokeData,
  SessionRevokeErrors,
  SessionRevokeOthersData,
  SessionRevokeOthersErrors,
  SessionRevokeOthersResponses,
  SessionRevokeResponses,
  SetAdminMcpDiscoveryConnectionData,
  SetAdminMcpDiscoveryConnectionErrors,
  SetAdminMcpDiscoveryConnectionResponses,
  SetAgentExtensionToolData,
  SetAgentExtensionToolErrors,
  SetAgentExtensionToolResponses,
  SetDefaultPaymentMethodApiBillingDefaultPaymentMethodPostData,
  SetDefaultPaymentMethodApiBillingDefaultPaymentMethodPostErrors,
  SetDefaultPaymentMethodApiBillingDefaultPaymentMethodPostResponses,
  SetPlatformSettingData,
  SetPlatformSettingErrors,
  SetPlatformSettingResponses,
  StartMcpOauthData,
  StartMcpOauthErrors,
  StartMcpOauthResponses,
  StartReferralConnectOnboardingData,
  StartReferralConnectOnboardingErrors,
  StartReferralConnectOnboardingResponses,
  StepUpData,
  StepUpErrors,
  StepUpResponses,
  StepUpStatusData,
  StepUpStatusErrors,
  StepUpStatusResponses,
  StopGenerateStreamData,
  StopGenerateStreamErrors,
  StopGenerateStreamResponses,
  StorePreConnectionSettingsData2,
  StorePreConnectionSettingsErrors,
  StorePreConnectionSettingsResponses,
  StreamAgentCreationJobData,
  StreamAgentCreationJobErrors,
  StreamAgentCreationJobResponses,
  StreamAgentEditChatData,
  StreamAgentEditChatErrors,
  StreamAgentEditChatResponses,
  StreamAgentUpdateJobData,
  StreamAgentUpdateJobErrors,
  StreamAgentUpdateJobResponses,
  StreamExecutionTraceApiApprovalQueueRequestIdExecutionTraceStreamGetData,
  StreamExecutionTraceApiApprovalQueueRequestIdExecutionTraceStreamGetErrors,
  StreamExecutionTraceApiApprovalQueueRequestIdExecutionTraceStreamGetResponses,
  StreamRealtimeEventsData,
  StreamRealtimeEventsErrors,
  StreamRealtimeEventsResponses,
  StreamWizardChatData,
  StreamWizardChatErrors,
  StreamWizardChatResponses,
  SyncLlmProviderModelsData,
  SyncLlmProviderModelsErrors,
  SyncLlmProviderModelsResponses,
  SyncReferralConnectStatusData,
  SyncReferralConnectStatusErrors,
  SyncReferralConnectStatusResponses,
  SynthesizeAgentPreviewData,
  SynthesizeAgentPreviewErrors,
  SynthesizeAgentPreviewResponses,
  TestMcpData,
  TestMcpErrors,
  TestMcpResponses,
  TestTwilioWhatsAppCredentialsData,
  TestTwilioWhatsAppCredentialsErrors,
  TestTwilioWhatsAppCredentialsResponses,
  TestWebhookEndpointData,
  TestWebhookEndpointErrors,
  TestWebhookEndpointResponses,
  TranscribeChatAudioData,
  TranscribeChatAudioErrors,
  TranscribeChatAudioResponses,
  TriggerAgentAutoRunData,
  TriggerAgentAutoRunErrors,
  TriggerAgentAutoRunResponses,
  TriggerUnsubscribeScanData,
  TriggerUnsubscribeScanErrors,
  TriggerUnsubscribeScanResponses,
  UnlinkTelegramSharedData,
  UnlinkTelegramSharedErrors,
  UnlinkTelegramSharedResponses,
  UnregisterMobileDeviceTokenData,
  UnregisterMobileDeviceTokenErrors,
  UnregisterMobileDeviceTokenResponses,
  UpdateAdminConnectionTypeData,
  UpdateAdminConnectionTypeErrors,
  UpdateAdminConnectionTypeResponses,
  UpdateAdminMcpServerData,
  UpdateAdminMcpServerErrors,
  UpdateAdminMcpServerResponses,
  UpdateAdminMcpToolData,
  UpdateAdminMcpToolErrors,
  UpdateAdminMcpToolResponses,
  UpdateAdminUserData,
  UpdateAdminUserErrors,
  UpdateAdminUserResponses,
  UpdateAdminUserRolesData,
  UpdateAdminUserRolesErrors,
  UpdateAdminUserRolesResponses,
  UpdateAgentCreationModelsData,
  UpdateAgentCreationModelsErrors,
  UpdateAgentCreationModelsResponses,
  UpdateAgentData,
  UpdateAgentDocumentData,
  UpdateAgentDocumentErrors,
  UpdateAgentDocumentResponses,
  UpdateAgentErrors,
  UpdateAgentGuardrailData,
  UpdateAgentGuardrailErrors,
  UpdateAgentGuardrailResponses,
  UpdateAgentIndexData,
  UpdateAgentIndexErrors,
  UpdateAgentIndexResponses,
  UpdateAgentInstructionData,
  UpdateAgentInstructionErrors,
  UpdateAgentInstructionResponses,
  UpdateAgentQueryData,
  UpdateAgentQueryErrors,
  UpdateAgentQueryResponses,
  UpdateAgentResponses,
  UpdateAgentToolSettingsData,
  UpdateAgentToolSettingsErrors,
  UpdateAgentToolSettingsResponses,
  UpdateAutoRechargeConfigApiBillingAutoRechargePutData,
  UpdateAutoRechargeConfigApiBillingAutoRechargePutErrors,
  UpdateAutoRechargeConfigApiBillingAutoRechargePutResponses,
  UpdateConnectionSettingsData,
  UpdateConnectionSettingsErrors,
  UpdateConnectionSettingsResponses,
  UpdateConversationData,
  UpdateConversationDraftData,
  UpdateConversationDraftErrors,
  UpdateConversationDraftResponses,
  UpdateConversationErrors,
  UpdateConversationMessageData,
  UpdateConversationMessageErrors,
  UpdateConversationMessageResponses,
  UpdateConversationResponses,
  UpdateExtensionProviderConfigData,
  UpdateExtensionProviderConfigErrors,
  UpdateExtensionProviderConfigResponses,
  UpdateExtensionToolConfigData,
  UpdateExtensionToolConfigErrors,
  UpdateExtensionToolConfigResponses,
  UpdateGenerationParamsData,
  UpdateGenerationParamsErrors,
  UpdateGenerationParamsResponses,
  UpdateHumanTaskData,
  UpdateHumanTaskErrors,
  UpdateHumanTaskResponses,
  UpdateLlmModelPricingData,
  UpdateLlmModelPricingErrors,
  UpdateLlmModelPricingResponses,
  UpdateLlmProviderEnabledData,
  UpdateLlmProviderEnabledErrors,
  UpdateLlmProviderEnabledResponses,
  UpdateLlmProviderModelCurationData,
  UpdateLlmProviderModelCurationErrors,
  UpdateLlmProviderModelCurationResponses,
  UpdateLlmProviderModelEnabledData,
  UpdateLlmProviderModelEnabledErrors,
  UpdateLlmProviderModelEnabledResponses,
  UpdateLlmTierBoundariesData,
  UpdateLlmTierBoundariesErrors,
  UpdateLlmTierBoundariesResponses,
  UpdateMcpData,
  UpdateMcpErrors,
  UpdateMcpResponses,
  UpdatePatternData,
  UpdatePatternErrors,
  UpdatePatternGuardrailData,
  UpdatePatternGuardrailErrors,
  UpdatePatternGuardrailResponses,
  UpdatePatternInstructionData,
  UpdatePatternInstructionErrors,
  UpdatePatternInstructionResponses,
  UpdatePatternResponses,
  UpdatePromotionApiAdminPromotionsPromotionIdPatchData,
  UpdatePromotionApiAdminPromotionsPromotionIdPatchErrors,
  UpdatePromotionApiAdminPromotionsPromotionIdPatchResponses,
  UpdateReferralSettingsData,
  UpdateReferralSettingsErrors,
  UpdateReferralSettingsResponses,
  UpdateReferralTemplateData,
  UpdateReferralTemplateErrors,
  UpdateReferralTemplateResponses,
  UpdateReferrerStatusData,
  UpdateReferrerStatusErrors,
  UpdateReferrerStatusResponses,
  UpdateRouterModelsData,
  UpdateRouterModelsErrors,
  UpdateRouterModelsResponses,
  UpdateTicketApiSupportTicketsTicketIdPatchData,
  UpdateTicketApiSupportTicketsTicketIdPatchErrors,
  UpdateTicketApiSupportTicketsTicketIdPatchResponses,
  UpdateToolData,
  UpdateToolErrors,
  UpdateToolResponses,
  UploadAndIndexData,
  UploadAndIndexErrors,
  UploadAndIndexResponses,
  UploadAuthMeAvatarData,
  UploadAuthMeAvatarErrors,
  UploadAuthMeAvatarResponses,
  ValidateToolSettingsData,
  ValidateToolSettingsErrors,
  ValidateToolSettingsResponses,
  WhatsappCloudEmbeddedSignupCompleteData,
  WhatsappCloudEmbeddedSignupCompleteErrors,
  WhatsappCloudEmbeddedSignupCompleteResponses,
  WhatsappCloudEmbeddedSignupConfigData,
  WhatsappCloudEmbeddedSignupConfigErrors,
  WhatsappCloudEmbeddedSignupConfigResponses,
  WhatsappCloudWebhookPostApiWhatsappCloudWebhookPostData,
  WhatsappCloudWebhookPostApiWhatsappCloudWebhookPostResponses,
  WhatsappCloudWebhookVerifyApiWhatsappCloudWebhookGetData,
  WhatsappCloudWebhookVerifyApiWhatsappCloudWebhookGetResponses,
} from "./types.gen";

export type Options<
  TData extends TDataShape = TDataShape,
  ThrowOnError extends boolean = boolean,
  TResponse = unknown,
> = Options2<TData, ThrowOnError, TResponse> & {
  /**
   * You can provide a client instance returned by `createClient()` instead of
   * individual options. This might be also useful if you want to implement a
   * custom client.
   */
  client?: Client;
  /**
   * You can pass arbitrary values through the `meta` object. This can be
   * used to access values that aren't defined as part of the SDK function.
   */
  meta?: keyof ClientMeta extends never ? Record<string, unknown> : ClientMeta;
};

/**
 * Login
 *
 * Login with email/password; sets session cookie. Requires email to be confirmed.
 */
export const login = <ThrowOnError extends boolean = false>(
  options: Options<LoginData, ThrowOnError>,
): RequestResult<LoginResponses, LoginErrors, ThrowOnError> =>
  (options.client ?? client).post<LoginResponses, LoginErrors, ThrowOnError>({
    responseType: "json",
    url: "/auth/login",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Register
 *
 * Register a new user. Sends confirmation email; no session until email is confirmed.
 */
export const register = <ThrowOnError extends boolean = false>(
  options: Options<RegisterData, ThrowOnError>,
): RequestResult<RegisterResponses, RegisterErrors, ThrowOnError> =>
  (options.client ?? client).post<
    RegisterResponses,
    RegisterErrors,
    ThrowOnError
  >({
    responseType: "json",
    url: "/auth/register",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Confirm email
 *
 * Confirm email with token from link; marks user verified and sends welcome email. Sets session cookie for auto sign-in.
 */
export const confirmEmail = <ThrowOnError extends boolean = false>(
  options: Options<ConfirmEmailData, ThrowOnError>,
): RequestResult<ConfirmEmailResponses, ConfirmEmailErrors, ThrowOnError> =>
  (options.client ?? client).post<
    ConfirmEmailResponses,
    ConfirmEmailErrors,
    ThrowOnError
  >({
    responseType: "json",
    url: "/auth/confirm-email",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Resend confirmation email
 *
 * Send a new confirmation link if the account exists and is not yet verified.
 */
export const resendConfirmation = <ThrowOnError extends boolean = false>(
  options: Options<ResendConfirmationData, ThrowOnError>,
): RequestResult<
  ResendConfirmationResponses,
  ResendConfirmationErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    ResendConfirmationResponses,
    ResendConfirmationErrors,
    ThrowOnError
  >({
    responseType: "json",
    url: "/auth/resend-confirmation",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Logout
 *
 * Clear session and cookie.
 */
export const logout = <ThrowOnError extends boolean = false>(
  options?: Options<LogoutData, ThrowOnError>,
): RequestResult<LogoutResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).post<LogoutResponses, unknown, ThrowOnError>({
    responseType: "json",
    url: "/auth/logout",
    ...options,
  });

/**
 * Current user
 *
 * Return current user (requires cookie or Bearer).
 */
export const getAuthMe = <ThrowOnError extends boolean = false>(
  options?: Options<GetAuthMeData, ThrowOnError>,
): RequestResult<GetAuthMeResponses, GetAuthMeErrors, ThrowOnError> =>
  (options?.client ?? client).get<
    GetAuthMeResponses,
    GetAuthMeErrors,
    ThrowOnError
  >({
    responseType: "json",
    url: "/auth/me",
    ...options,
  });

/**
 * Update current user profile
 *
 * Update name, email, and/or image. When changing email, current_password is required.
 */
export const patchAuthMe = <ThrowOnError extends boolean = false>(
  options: Options<PatchAuthMeData, ThrowOnError>,
): RequestResult<PatchAuthMeResponses, PatchAuthMeErrors, ThrowOnError> =>
  (options.client ?? client).patch<
    PatchAuthMeResponses,
    PatchAuthMeErrors,
    ThrowOnError
  >({
    responseType: "json",
    url: "/auth/me",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Public referral cookie settings
 */
export const getReferralPublicConfig = <ThrowOnError extends boolean = false>(
  options?: Options<GetReferralPublicConfigData, ThrowOnError>,
): RequestResult<GetReferralPublicConfigResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).get<
    GetReferralPublicConfigResponses,
    unknown,
    ThrowOnError
  >({
    responseType: "json",
    url: "/auth/referral-config",
    ...options,
  });

/**
 * Upload current user profile image
 *
 * Validate and store a sanitized avatar image for the current user.
 */
export const uploadAuthMeAvatar = <ThrowOnError extends boolean = false>(
  options: Options<UploadAuthMeAvatarData, ThrowOnError>,
): RequestResult<
  UploadAuthMeAvatarResponses,
  UploadAuthMeAvatarErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    UploadAuthMeAvatarResponses,
    UploadAuthMeAvatarErrors,
    ThrowOnError
  >({
    ...formDataBodySerializer,
    responseType: "json",
    url: "/auth/me/avatar",
    ...options,
    headers: {
      "Content-Type": null,
      ...options.headers,
    },
  });

/**
 * Request password change OTP
 *
 * Verify current password and send a 6-digit OTP to the user's email.
 */
export const changePasswordRequest = <ThrowOnError extends boolean = false>(
  options: Options<ChangePasswordRequestData, ThrowOnError>,
): RequestResult<
  ChangePasswordRequestResponses,
  ChangePasswordRequestErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    ChangePasswordRequestResponses,
    ChangePasswordRequestErrors,
    ThrowOnError
  >({
    responseType: "json",
    url: "/auth/me/change-password/request",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Confirm password change with OTP
 *
 * Verify the 6-digit OTP and update the password.
 */
export const changePasswordConfirm = <ThrowOnError extends boolean = false>(
  options: Options<ChangePasswordConfirmData, ThrowOnError>,
): RequestResult<
  ChangePasswordConfirmResponses,
  ChangePasswordConfirmErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    ChangePasswordConfirmResponses,
    ChangePasswordConfirmErrors,
    ThrowOnError
  >({
    responseType: "json",
    url: "/auth/me/change-password/confirm",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Forgot password
 *
 * Send a password reset link to the user email if the account exists.
 */
export const forgotPassword = <ThrowOnError extends boolean = false>(
  options: Options<ForgotPasswordData, ThrowOnError>,
): RequestResult<ForgotPasswordResponses, ForgotPasswordErrors, ThrowOnError> =>
  (options.client ?? client).post<
    ForgotPasswordResponses,
    ForgotPasswordErrors,
    ThrowOnError
  >({
    responseType: "json",
    url: "/auth/forgot-password",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Reset password
 *
 * Reset password with a valid one-time token.
 */
export const resetPassword = <ThrowOnError extends boolean = false>(
  options: Options<ResetPasswordData, ThrowOnError>,
): RequestResult<ResetPasswordResponses, ResetPasswordErrors, ThrowOnError> =>
  (options.client ?? client).post<
    ResetPasswordResponses,
    ResetPasswordErrors,
    ThrowOnError
  >({
    responseType: "json",
    url: "/auth/reset-password",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Check a password against known breaches
 *
 * Live hint for the sign-up and change-password forms. Enforcement happens in the routes that set a password; this never stores or logs the value and only a 5-character hash prefix leaves the server.
 */
export const passwordBreachCheck = <ThrowOnError extends boolean = false>(
  options: Options<PasswordBreachCheckData, ThrowOnError>,
): RequestResult<
  PasswordBreachCheckResponses,
  PasswordBreachCheckErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    PasswordBreachCheckResponses,
    PasswordBreachCheckErrors,
    ThrowOnError
  >({
    responseType: "json",
    url: "/auth/password/breach-check",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Two-factor status
 */
export const mfaStatus = <ThrowOnError extends boolean = false>(
  options?: Options<MfaStatusData, ThrowOnError>,
): RequestResult<MfaStatusResponses, MfaStatusErrors, ThrowOnError> =>
  (options?.client ?? client).get<
    MfaStatusResponses,
    MfaStatusErrors,
    ThrowOnError
  >({
    responseType: "json",
    url: "/auth/mfa/status",
    ...options,
  });

/**
 * Start authenticator-app enrolment
 *
 * Returns the secret and otpauth URI once.  Nothing is enforced until /totp/confirm succeeds.
 */
export const mfaTotpEnroll = <ThrowOnError extends boolean = false>(
  options?: Options<MfaTotpEnrollData, ThrowOnError>,
): RequestResult<MfaTotpEnrollResponses, MfaTotpEnrollErrors, ThrowOnError> =>
  (options?.client ?? client).post<
    MfaTotpEnrollResponses,
    MfaTotpEnrollErrors,
    ThrowOnError
  >({
    responseType: "json",
    url: "/auth/mfa/totp/enroll",
    ...options,
  });

/**
 * Confirm authenticator-app enrolment
 *
 * Proves the first code, turns two-factor on and returns the recovery codes, shown only this once. Every other session is signed out.
 */
export const mfaTotpConfirm = <ThrowOnError extends boolean = false>(
  options: Options<MfaTotpConfirmData, ThrowOnError>,
): RequestResult<MfaTotpConfirmResponses, MfaTotpConfirmErrors, ThrowOnError> =>
  (options.client ?? client).post<
    MfaTotpConfirmResponses,
    MfaTotpConfirmErrors,
    ThrowOnError
  >({
    responseType: "json",
    url: "/auth/mfa/totp/confirm",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Turn off two-factor
 *
 * Needs a current authenticator code or an unused recovery code.  Every other session is signed out.
 */
export const mfaTotpDisable = <ThrowOnError extends boolean = false>(
  options: Options<MfaTotpDisableData, ThrowOnError>,
): RequestResult<MfaTotpDisableResponses, MfaTotpDisableErrors, ThrowOnError> =>
  (options.client ?? client).post<
    MfaTotpDisableResponses,
    MfaTotpDisableErrors,
    ThrowOnError
  >({
    url: "/auth/mfa/totp/disable",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Replace the recovery codes
 *
 * Needs a current authenticator code.  The old codes stop working.
 */
export const mfaRecoveryRegenerate = <ThrowOnError extends boolean = false>(
  options: Options<MfaRecoveryRegenerateData, ThrowOnError>,
): RequestResult<
  MfaRecoveryRegenerateResponses,
  MfaRecoveryRegenerateErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    MfaRecoveryRegenerateResponses,
    MfaRecoveryRegenerateErrors,
    ThrowOnError
  >({
    responseType: "json",
    url: "/auth/mfa/recovery/regenerate",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Finish a two-factor login
 *
 * Trades the pending-login token (body or cookie) and a code for a session.
 */
export const mfaVerify = <ThrowOnError extends boolean = false>(
  options: Options<MfaVerifyData, ThrowOnError>,
): RequestResult<MfaVerifyResponses, MfaVerifyErrors, ThrowOnError> =>
  (options.client ?? client).post<
    MfaVerifyResponses,
    MfaVerifyErrors,
    ThrowOnError
  >({
    responseType: "json",
    url: "/auth/mfa/verify",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Whether passkeys are available
 */
export const passkeyConfig = <ThrowOnError extends boolean = false>(
  options?: Options<PasskeyConfigData, ThrowOnError>,
): RequestResult<PasskeyConfigResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).get<
    PasskeyConfigResponses,
    unknown,
    ThrowOnError
  >({
    responseType: "json",
    url: "/auth/passkeys/config",
    ...options,
  });

/**
 * List the account's passkeys
 */
export const passkeyList = <ThrowOnError extends boolean = false>(
  options?: Options<PasskeyListData, ThrowOnError>,
): RequestResult<PasskeyListResponses, PasskeyListErrors, ThrowOnError> =>
  (options?.client ?? client).get<
    PasskeyListResponses,
    PasskeyListErrors,
    ThrowOnError
  >({
    responseTransformer: passkeyListResponseTransformer,
    responseType: "json",
    url: "/auth/passkeys",
    ...options,
  });

/**
 * Start registering a passkey
 */
export const passkeyRegisterOptions = <ThrowOnError extends boolean = false>(
  options?: Options<PasskeyRegisterOptionsData, ThrowOnError>,
): RequestResult<
  PasskeyRegisterOptionsResponses,
  PasskeyRegisterOptionsErrors,
  ThrowOnError
> =>
  (options?.client ?? client).post<
    PasskeyRegisterOptionsResponses,
    PasskeyRegisterOptionsErrors,
    ThrowOnError
  >({
    responseType: "json",
    url: "/auth/passkeys/register/options",
    ...options,
  });

/**
 * Finish registering a passkey
 */
export const passkeyRegisterVerify = <ThrowOnError extends boolean = false>(
  options: Options<PasskeyRegisterVerifyData, ThrowOnError>,
): RequestResult<
  PasskeyRegisterVerifyResponses,
  PasskeyRegisterVerifyErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    PasskeyRegisterVerifyResponses,
    PasskeyRegisterVerifyErrors,
    ThrowOnError
  >({
    responseTransformer: passkeyRegisterVerifyResponseTransformer,
    responseType: "json",
    url: "/auth/passkeys/register/verify",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Delete a passkey
 */
export const passkeyDelete = <ThrowOnError extends boolean = false>(
  options: Options<PasskeyDeleteData, ThrowOnError>,
): RequestResult<PasskeyDeleteResponses, PasskeyDeleteErrors, ThrowOnError> =>
  (options.client ?? client).delete<
    PasskeyDeleteResponses,
    PasskeyDeleteErrors,
    ThrowOnError
  >({ url: "/auth/passkeys/{passkey_id}", ...options });

/**
 * Rename a passkey
 */
export const passkeyRename = <ThrowOnError extends boolean = false>(
  options: Options<PasskeyRenameData, ThrowOnError>,
): RequestResult<PasskeyRenameResponses, PasskeyRenameErrors, ThrowOnError> =>
  (options.client ?? client).patch<
    PasskeyRenameResponses,
    PasskeyRenameErrors,
    ThrowOnError
  >({
    responseTransformer: passkeyRenameResponseTransformer,
    responseType: "json",
    url: "/auth/passkeys/{passkey_id}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Start a passkey sign-in
 *
 * Usernameless: the authenticator offers the passkeys it holds for this site.
 */
export const passkeyLoginOptions = <ThrowOnError extends boolean = false>(
  options?: Options<PasskeyLoginOptionsData, ThrowOnError>,
): RequestResult<PasskeyLoginOptionsResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).post<
    PasskeyLoginOptionsResponses,
    unknown,
    ThrowOnError
  >({
    responseType: "json",
    url: "/auth/passkeys/login/options",
    ...options,
  });

/**
 * Finish a passkey sign-in
 *
 * A passkey checked with user verification is both factors, so it does not ask for a second code.
 */
export const passkeyLoginVerify = <ThrowOnError extends boolean = false>(
  options: Options<PasskeyLoginVerifyData, ThrowOnError>,
): RequestResult<
  PasskeyLoginVerifyResponses,
  PasskeyLoginVerifyErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    PasskeyLoginVerifyResponses,
    PasskeyLoginVerifyErrors,
    ThrowOnError
  >({
    responseType: "json",
    url: "/auth/passkeys/login/verify",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * List the account's active sessions
 */
export const sessionList = <ThrowOnError extends boolean = false>(
  options?: Options<SessionListData, ThrowOnError>,
): RequestResult<SessionListResponses, SessionListErrors, ThrowOnError> =>
  (options?.client ?? client).get<
    SessionListResponses,
    SessionListErrors,
    ThrowOnError
  >({
    responseTransformer: sessionListResponseTransformer,
    responseType: "json",
    url: "/auth/sessions",
    ...options,
  });

/**
 * Sign out every other session
 */
export const sessionRevokeOthers = <ThrowOnError extends boolean = false>(
  options?: Options<SessionRevokeOthersData, ThrowOnError>,
): RequestResult<
  SessionRevokeOthersResponses,
  SessionRevokeOthersErrors,
  ThrowOnError
> =>
  (options?.client ?? client).post<
    SessionRevokeOthersResponses,
    SessionRevokeOthersErrors,
    ThrowOnError
  >({ url: "/auth/sessions/revoke-others", ...options });

/**
 * Sign out one session
 *
 * The session making the request cannot be revoked here; use logout.
 */
export const sessionRevoke = <ThrowOnError extends boolean = false>(
  options: Options<SessionRevokeData, ThrowOnError>,
): RequestResult<SessionRevokeResponses, SessionRevokeErrors, ThrowOnError> =>
  (options.client ?? client).delete<
    SessionRevokeResponses,
    SessionRevokeErrors,
    ThrowOnError
  >({ url: "/auth/sessions/{session_id}", ...options });

/**
 * Whether the session may do a sensitive action now
 */
export const stepUpStatus = <ThrowOnError extends boolean = false>(
  options?: Options<StepUpStatusData, ThrowOnError>,
): RequestResult<StepUpStatusResponses, StepUpStatusErrors, ThrowOnError> =>
  (options?.client ?? client).get<
    StepUpStatusResponses,
    StepUpStatusErrors,
    ThrowOnError
  >({
    responseType: "json",
    url: "/auth/step-up/status",
    ...options,
  });

/**
 * Prove who you are again
 *
 * Needs an authenticator or recovery code when the account has one, otherwise the password.
 */
export const stepUp = <ThrowOnError extends boolean = false>(
  options: Options<StepUpData, ThrowOnError>,
): RequestResult<StepUpResponses, StepUpErrors, ThrowOnError> =>
  (options.client ?? client).post<StepUpResponses, StepUpErrors, ThrowOnError>({
    url: "/auth/step-up",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * List ready-to-ship system agents (public)
 *
 * Marketing-safe catalog: card fields only, no prompts or guardrails. Published templates only.
 */
export const listPublicSystemAgents = <ThrowOnError extends boolean = false>(
  options?: Options<ListPublicSystemAgentsData, ThrowOnError>,
): RequestResult<
  ListPublicSystemAgentsResponses,
  ListPublicSystemAgentsErrors,
  ThrowOnError
> =>
  (options?.client ?? client).get<
    ListPublicSystemAgentsResponses,
    ListPublicSystemAgentsErrors,
    ThrowOnError
  >({
    responseType: "json",
    url: "/api/public/system-agents",
    ...options,
  });

/**
 * List ready-to-ship system agent categories (public)
 */
export const listPublicSystemAgentCategories = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<ListPublicSystemAgentCategoriesData, ThrowOnError>,
): RequestResult<
  ListPublicSystemAgentCategoriesResponses,
  ListPublicSystemAgentCategoriesErrors,
  ThrowOnError
> =>
  (options?.client ?? client).get<
    ListPublicSystemAgentCategoriesResponses,
    ListPublicSystemAgentCategoriesErrors,
    ThrowOnError
  >({
    responseType: "json",
    url: "/api/public/system-agents/categories",
    ...options,
  });

/**
 * Current user (session)
 *
 * Returns the authenticated user's id and display fields. Used to verify cookie/API token sessions.
 */
export const getUsersMe = <ThrowOnError extends boolean = false>(
  options?: Options<GetUsersMeData, ThrowOnError>,
): RequestResult<GetUsersMeResponses, GetUsersMeErrors, ThrowOnError> =>
  (options?.client ?? client).get<
    GetUsersMeResponses,
    GetUsersMeErrors,
    ThrowOnError
  >({
    responseType: "json",
    url: "/api/users/me",
    ...options,
  });

/**
 * Current user usage (cost history)
 *
 * Paginated list of recent model_queries for the current user's agents (timestamp, agent_id, agent_name, credits_used).
 */
export const getUsersMeUsage = <ThrowOnError extends boolean = false>(
  options?: Options<GetUsersMeUsageData, ThrowOnError>,
): RequestResult<
  GetUsersMeUsageResponses,
  GetUsersMeUsageErrors,
  ThrowOnError
> =>
  (options?.client ?? client).get<
    GetUsersMeUsageResponses,
    GetUsersMeUsageErrors,
    ThrowOnError
  >({
    responseType: "json",
    url: "/api/users/me/usage",
    ...options,
  });

/**
 * Plan limits for current user
 *
 * Returns plan, agent count, and creation limits for sidebar (free: 1 agent, 5/month; pro: 5/day).
 */
export const getUsersMePlanLimits = <ThrowOnError extends boolean = false>(
  options?: Options<GetUsersMePlanLimitsData, ThrowOnError>,
): RequestResult<
  GetUsersMePlanLimitsResponses,
  GetUsersMePlanLimitsErrors,
  ThrowOnError
> =>
  (options?.client ?? client).get<
    GetUsersMePlanLimitsResponses,
    GetUsersMePlanLimitsErrors,
    ThrowOnError
  >({
    responseType: "json",
    url: "/api/users/me/plan-limits",
    ...options,
  });

/**
 * Current billing and plan status
 *
 * Returns the user's full billing status: plan, credit balance, feature limits, blocking conditions, and pre-computed capability flags. Check this endpoint before gating sensitive or paid actions. Returns the source-of-truth for Low Balance, Expired Plan, Agent Limit, and Creation Limit dialogs.
 */
export const getUsersMeBillingStatus = <ThrowOnError extends boolean = false>(
  options?: Options<GetUsersMeBillingStatusData, ThrowOnError>,
): RequestResult<
  GetUsersMeBillingStatusResponses,
  GetUsersMeBillingStatusErrors,
  ThrowOnError
> =>
  (options?.client ?? client).get<
    GetUsersMeBillingStatusResponses,
    GetUsersMeBillingStatusErrors,
    ThrowOnError
  >({
    responseType: "json",
    url: "/api/users/me/billing-status",
    ...options,
  });

/**
 * Personalized home-screen suggestions
 *
 * AI-generated topic chips and starter-prompt cards personalized from the user's agents, tools, and recent conversation titles. Generated at most once per user per UTC day (cached in home_suggestion_cache); the generating call is billed like any other auxiliary completion, so a cache miss requires sufficient credit balance (402 LOW_BALANCE otherwise). Returns 503 when generation is unavailable or already in flight — clients should fall back to locally generated suggestions.
 */
export const getUsersMeHomeSuggestions = <ThrowOnError extends boolean = false>(
  options?: Options<GetUsersMeHomeSuggestionsData, ThrowOnError>,
): RequestResult<
  GetUsersMeHomeSuggestionsResponses,
  GetUsersMeHomeSuggestionsErrors,
  ThrowOnError
> =>
  (options?.client ?? client).get<
    GetUsersMeHomeSuggestionsResponses,
    GetUsersMeHomeSuggestionsErrors,
    ThrowOnError
  >({
    responseType: "json",
    url: "/api/users/me/home-suggestions",
    ...options,
  });

/**
 * Current agent selection for finite-plan downgrades
 */
export const getUsersMeAgentPlanSelection = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<GetUsersMeAgentPlanSelectionData, ThrowOnError>,
): RequestResult<
  GetUsersMeAgentPlanSelectionResponses,
  GetUsersMeAgentPlanSelectionErrors,
  ThrowOnError
> =>
  (options?.client ?? client).get<
    GetUsersMeAgentPlanSelectionResponses,
    GetUsersMeAgentPlanSelectionErrors,
    ThrowOnError
  >({
    responseType: "json",
    url: "/api/users/me/agent-plan-selection",
    ...options,
  });

/**
 * Save active agents for a finite plan
 */
export const saveUsersMeAgentPlanSelection = <
  ThrowOnError extends boolean = false,
>(
  options: Options<SaveUsersMeAgentPlanSelectionData, ThrowOnError>,
): RequestResult<
  SaveUsersMeAgentPlanSelectionResponses,
  SaveUsersMeAgentPlanSelectionErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    SaveUsersMeAgentPlanSelectionResponses,
    SaveUsersMeAgentPlanSelectionErrors,
    ThrowOnError
  >({
    responseType: "json",
    url: "/api/users/me/agent-plan-selection",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Export all my data (JSON archive)
 *
 * Streams a JSON archive of the current user's profile, agents, instructions, knowledge document metadata, conversations, messages, memories and credit ledger. Credentials are never included.
 */
export const getUsersMeExport = <ThrowOnError extends boolean = false>(
  options?: Options<GetUsersMeExportData, ThrowOnError>,
): RequestResult<
  GetUsersMeExportResponses,
  GetUsersMeExportErrors,
  ThrowOnError
> =>
  (options?.client ?? client).get<
    GetUsersMeExportResponses,
    GetUsersMeExportErrors,
    ThrowOnError
  >({
    responseType: "json",
    url: "/api/users/me/export",
    ...options,
  });

/**
 * Permanently delete my account
 *
 * Cancels the Stripe subscription, deletes agents (including vectors and stored files), conversations, memories, sessions and API tokens, and removes the user. Billing records are kept, anonymised. Requires confirm_email to match the account email. Irreversible.
 */
export const postUsersMeDelete = <ThrowOnError extends boolean = false>(
  options: Options<PostUsersMeDeleteData, ThrowOnError>,
): RequestResult<
  PostUsersMeDeleteResponses,
  PostUsersMeDeleteErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    PostUsersMeDeleteResponses,
    PostUsersMeDeleteErrors,
    ThrowOnError
  >({
    url: "/api/users/me/delete",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Create Stripe Checkout session for credit top-up
 *
 * Create a Stripe Checkout session; frontend redirects user to returned URL.
 */
export const createCheckoutSessionApiBillingCheckoutSessionPost = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<
    CreateCheckoutSessionApiBillingCheckoutSessionPostData,
    ThrowOnError
  >,
): RequestResult<
  CreateCheckoutSessionApiBillingCheckoutSessionPostResponses,
  CreateCheckoutSessionApiBillingCheckoutSessionPostErrors,
  ThrowOnError
> =>
  (options?.client ?? client).post<
    CreateCheckoutSessionApiBillingCheckoutSessionPostResponses,
    CreateCheckoutSessionApiBillingCheckoutSessionPostErrors,
    ThrowOnError
  >({
    responseType: "json",
    url: "/api/billing/checkout-session",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });

/**
 * Create a SetupIntent to save a card
 *
 * Return a SetupIntent client secret so the frontend can save an off-session card.
 */
export const createSetupIntentApiBillingSetupIntentPost = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<
    CreateSetupIntentApiBillingSetupIntentPostData,
    ThrowOnError
  >,
): RequestResult<
  CreateSetupIntentApiBillingSetupIntentPostResponses,
  CreateSetupIntentApiBillingSetupIntentPostErrors,
  ThrowOnError
> =>
  (options?.client ?? client).post<
    CreateSetupIntentApiBillingSetupIntentPostResponses,
    CreateSetupIntentApiBillingSetupIntentPostErrors,
    ThrowOnError
  >({
    responseType: "json",
    url: "/api/billing/setup-intent",
    ...options,
  });

/**
 * Set the saved card used for auto-recharge
 *
 * Attach a payment method as the customer default and store it on the auto-recharge config.
 */
export const setDefaultPaymentMethodApiBillingDefaultPaymentMethodPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    SetDefaultPaymentMethodApiBillingDefaultPaymentMethodPostData,
    ThrowOnError
  >,
): RequestResult<
  SetDefaultPaymentMethodApiBillingDefaultPaymentMethodPostResponses,
  SetDefaultPaymentMethodApiBillingDefaultPaymentMethodPostErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    SetDefaultPaymentMethodApiBillingDefaultPaymentMethodPostResponses,
    SetDefaultPaymentMethodApiBillingDefaultPaymentMethodPostErrors,
    ThrowOnError
  >({
    responseType: "json",
    url: "/api/billing/default-payment-method",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Get auto-recharge settings
 */
export const getAutoRechargeConfigApiBillingAutoRechargeGet = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<
    GetAutoRechargeConfigApiBillingAutoRechargeGetData,
    ThrowOnError
  >,
): RequestResult<
  GetAutoRechargeConfigApiBillingAutoRechargeGetResponses,
  GetAutoRechargeConfigApiBillingAutoRechargeGetErrors,
  ThrowOnError
> =>
  (options?.client ?? client).get<
    GetAutoRechargeConfigApiBillingAutoRechargeGetResponses,
    GetAutoRechargeConfigApiBillingAutoRechargeGetErrors,
    ThrowOnError
  >({
    responseType: "json",
    url: "/api/billing/auto-recharge",
    ...options,
  });

/**
 * Update auto-recharge settings
 *
 * Update the user's auto-recharge settings. Enabling clears any paused state.
 */
export const updateAutoRechargeConfigApiBillingAutoRechargePut = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    UpdateAutoRechargeConfigApiBillingAutoRechargePutData,
    ThrowOnError
  >,
): RequestResult<
  UpdateAutoRechargeConfigApiBillingAutoRechargePutResponses,
  UpdateAutoRechargeConfigApiBillingAutoRechargePutErrors,
  ThrowOnError
> =>
  (options.client ?? client).put<
    UpdateAutoRechargeConfigApiBillingAutoRechargePutResponses,
    UpdateAutoRechargeConfigApiBillingAutoRechargePutErrors,
    ThrowOnError
  >({
    responseType: "json",
    url: "/api/billing/auto-recharge",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Create Stripe Customer Portal session
 *
 * Create a Stripe Customer Portal session for payment methods and invoices.
 */
export const createPortalSessionApiBillingPortalSessionPost = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<
    CreatePortalSessionApiBillingPortalSessionPostData,
    ThrowOnError
  >,
): RequestResult<
  CreatePortalSessionApiBillingPortalSessionPostResponses,
  CreatePortalSessionApiBillingPortalSessionPostErrors,
  ThrowOnError
> =>
  (options?.client ?? client).post<
    CreatePortalSessionApiBillingPortalSessionPostResponses,
    CreatePortalSessionApiBillingPortalSessionPostErrors,
    ThrowOnError
  >({
    responseType: "json",
    url: "/api/billing/portal-session",
    ...options,
  });

/**
 * Preview discount for a promo token or code before checkout
 *
 * Validate and preview the discount without starting checkout.
 */
export const promoPreviewApiBillingPromoPreviewGet = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<PromoPreviewApiBillingPromoPreviewGetData, ThrowOnError>,
): RequestResult<
  PromoPreviewApiBillingPromoPreviewGetResponses,
  PromoPreviewApiBillingPromoPreviewGetErrors,
  ThrowOnError
> =>
  (options?.client ?? client).get<
    PromoPreviewApiBillingPromoPreviewGetResponses,
    PromoPreviewApiBillingPromoPreviewGetErrors,
    ThrowOnError
  >({
    responseType: "json",
    url: "/api/billing/promo-preview",
    ...options,
  });

/**
 * List current user's payment history
 *
 * Paginated list of billing transactions, optionally filtered by history kind.
 */
export const getTransactionsApiBillingTransactionsGet = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<GetTransactionsApiBillingTransactionsGetData, ThrowOnError>,
): RequestResult<
  GetTransactionsApiBillingTransactionsGetResponses,
  GetTransactionsApiBillingTransactionsGetErrors,
  ThrowOnError
> =>
  (options?.client ?? client).get<
    GetTransactionsApiBillingTransactionsGetResponses,
    GetTransactionsApiBillingTransactionsGetErrors,
    ThrowOnError
  >({
    responseType: "json",
    url: "/api/billing/transactions",
    ...options,
  });

/**
 * Current account plan, credits, and creation limits
 *
 * Single endpoint combining plan, credit balance, and usage counters. Use this to gate UI actions like agent creation.
 */
export const getBillingAccountStatus = <ThrowOnError extends boolean = false>(
  options?: Options<GetBillingAccountStatusData, ThrowOnError>,
): RequestResult<
  GetBillingAccountStatusResponses,
  GetBillingAccountStatusErrors,
  ThrowOnError
> =>
  (options?.client ?? client).get<
    GetBillingAccountStatusResponses,
    GetBillingAccountStatusErrors,
    ThrowOnError
  >({
    responseType: "json",
    url: "/api/billing/account-status",
    ...options,
  });

/**
 * Aggregated stats (all agents)
 *
 * Daily aggregates across all agents owned by the current user, plus per-agent period summary.
 */
export const listAggregateStats = <ThrowOnError extends boolean = false>(
  options?: Options<ListAggregateStatsData, ThrowOnError>,
): RequestResult<
  ListAggregateStatsResponses,
  ListAggregateStatsErrors,
  ThrowOnError
> =>
  (options?.client ?? client).get<
    ListAggregateStatsResponses,
    ListAggregateStatsErrors,
    ThrowOnError
  >({
    responseType: "json",
    url: "/api/stats",
    ...options,
  });

/**
 * List agent instructions
 *
 * Paginated list of instructions for an agent.
 */
export const listAgentInstructions = <ThrowOnError extends boolean = false>(
  options: Options<ListAgentInstructionsData, ThrowOnError>,
): RequestResult<
  ListAgentInstructionsResponses,
  ListAgentInstructionsErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    ListAgentInstructionsResponses,
    ListAgentInstructionsErrors,
    ThrowOnError
  >({
    responseType: "json",
    url: "/api/agents/{agent_id}/instructions",
    ...options,
  });

/**
 * Create instruction
 *
 * Add a new instruction to an agent.
 */
export const createAgentInstruction = <ThrowOnError extends boolean = false>(
  options: Options<CreateAgentInstructionData, ThrowOnError>,
): RequestResult<
  CreateAgentInstructionResponses,
  CreateAgentInstructionErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    CreateAgentInstructionResponses,
    CreateAgentInstructionErrors,
    ThrowOnError
  >({
    responseType: "json",
    url: "/api/agents/{agent_id}/instructions",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Delete instruction
 *
 * Soft-delete an instruction.
 */
export const deleteAgentInstruction = <ThrowOnError extends boolean = false>(
  options: Options<DeleteAgentInstructionData, ThrowOnError>,
): RequestResult<
  DeleteAgentInstructionResponses,
  DeleteAgentInstructionErrors,
  ThrowOnError
> =>
  (options.client ?? client).delete<
    DeleteAgentInstructionResponses,
    DeleteAgentInstructionErrors,
    ThrowOnError
  >({ url: "/api/agents/{agent_id}/instructions/{id}", ...options });

/**
 * Get instruction by ID
 *
 * Return a single instruction for an agent.
 */
export const getAgentInstruction = <ThrowOnError extends boolean = false>(
  options: Options<GetAgentInstructionData, ThrowOnError>,
): RequestResult<
  GetAgentInstructionResponses,
  GetAgentInstructionErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetAgentInstructionResponses,
    GetAgentInstructionErrors,
    ThrowOnError
  >({
    responseType: "json",
    url: "/api/agents/{agent_id}/instructions/{id}",
    ...options,
  });

/**
 * Update instruction
 *
 * Update content or order of an instruction.
 */
export const updateAgentInstruction = <ThrowOnError extends boolean = false>(
  options: Options<UpdateAgentInstructionData, ThrowOnError>,
): RequestResult<
  UpdateAgentInstructionResponses,
  UpdateAgentInstructionErrors,
  ThrowOnError
> =>
  (options.client ?? client).patch<
    UpdateAgentInstructionResponses,
    UpdateAgentInstructionErrors,
    ThrowOnError
  >({
    responseType: "json",
    url: "/api/agents/{agent_id}/instructions/{id}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * List pending sync conflicts
 *
 * List unresolved conflicts where the pattern was updated but the agent had overridden the item.
 */
export const listAgentSyncConflicts = <ThrowOnError extends boolean = false>(
  options: Options<ListAgentSyncConflictsData, ThrowOnError>,
): RequestResult<
  ListAgentSyncConflictsResponses,
  ListAgentSyncConflictsErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    ListAgentSyncConflictsResponses,
    ListAgentSyncConflictsErrors,
    ThrowOnError
  >({
    responseType: "json",
    url: "/api/agents/{agent_id}/sync-conflicts",
    ...options,
  });

/**
 * Get sync conflict detail
 *
 * Get one pending conflict with pattern and agent versions for diff UI.
 */
export const getAgentSyncConflict = <ThrowOnError extends boolean = false>(
  options: Options<GetAgentSyncConflictData, ThrowOnError>,
): RequestResult<
  GetAgentSyncConflictResponses,
  GetAgentSyncConflictErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetAgentSyncConflictResponses,
    GetAgentSyncConflictErrors,
    ThrowOnError
  >({
    responseType: "json",
    url: "/api/agents/{agent_id}/sync-conflicts/{conflict_id}",
    ...options,
  });

/**
 * Resolve sync conflict
 *
 * Resolve by keeping agent's version or accepting the pattern's new version.
 */
export const resolveAgentSyncConflict = <ThrowOnError extends boolean = false>(
  options: Options<ResolveAgentSyncConflictData, ThrowOnError>,
): RequestResult<
  ResolveAgentSyncConflictResponses,
  ResolveAgentSyncConflictErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    ResolveAgentSyncConflictResponses,
    ResolveAgentSyncConflictErrors,
    ThrowOnError
  >({
    responseType: "json",
    url: "/api/agents/{agent_id}/sync-conflicts/{conflict_id}/resolve",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * List agent guardrails
 *
 * Paginated list of guardrails for an agent (instruction + 3–4 examples each). Includes guardrails from the agent's pattern first, then agent-owned guardrails.
 */
export const listAgentGuardrails = <ThrowOnError extends boolean = false>(
  options: Options<ListAgentGuardrailsData, ThrowOnError>,
): RequestResult<
  ListAgentGuardrailsResponses,
  ListAgentGuardrailsErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    ListAgentGuardrailsResponses,
    ListAgentGuardrailsErrors,
    ThrowOnError
  >({
    responseType: "json",
    url: "/api/agents/{agent_id}/guardrails",
    ...options,
  });

/**
 * Create guardrail
 *
 * Add a new guardrail (instruction + 3–4 examples) to an agent.
 */
export const createAgentGuardrail = <ThrowOnError extends boolean = false>(
  options: Options<CreateAgentGuardrailData, ThrowOnError>,
): RequestResult<
  CreateAgentGuardrailResponses,
  CreateAgentGuardrailErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    CreateAgentGuardrailResponses,
    CreateAgentGuardrailErrors,
    ThrowOnError
  >({
    responseType: "json",
    url: "/api/agents/{agent_id}/guardrails",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Delete guardrail
 *
 * Soft-delete a guardrail.
 */
export const deleteAgentGuardrail = <ThrowOnError extends boolean = false>(
  options: Options<DeleteAgentGuardrailData, ThrowOnError>,
): RequestResult<
  DeleteAgentGuardrailResponses,
  DeleteAgentGuardrailErrors,
  ThrowOnError
> =>
  (options.client ?? client).delete<
    DeleteAgentGuardrailResponses,
    DeleteAgentGuardrailErrors,
    ThrowOnError
  >({ url: "/api/agents/{agent_id}/guardrails/{id}", ...options });

/**
 * Get guardrail by ID
 *
 * Return a single guardrail for an agent.
 */
export const getAgentGuardrail = <ThrowOnError extends boolean = false>(
  options: Options<GetAgentGuardrailData, ThrowOnError>,
): RequestResult<
  GetAgentGuardrailResponses,
  GetAgentGuardrailErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetAgentGuardrailResponses,
    GetAgentGuardrailErrors,
    ThrowOnError
  >({
    responseType: "json",
    url: "/api/agents/{agent_id}/guardrails/{id}",
    ...options,
  });

/**
 * Update guardrail
 *
 * Update instruction, examples, or order of a guardrail.
 */
export const updateAgentGuardrail = <ThrowOnError extends boolean = false>(
  options: Options<UpdateAgentGuardrailData, ThrowOnError>,
): RequestResult<
  UpdateAgentGuardrailResponses,
  UpdateAgentGuardrailErrors,
  ThrowOnError
> =>
  (options.client ?? client).patch<
    UpdateAgentGuardrailResponses,
    UpdateAgentGuardrailErrors,
    ThrowOnError
  >({
    responseType: "json",
    url: "/api/agents/{agent_id}/guardrails/{id}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Create guardrail from file
 *
 * Upload a file (txt, pdf, docx, csv). Same format as Add guardrail: Instruction block, blank line, then examples one per line (content to block).
 */
export const createAgentGuardrailFromFile = <
  ThrowOnError extends boolean = false,
>(
  options: Options<CreateAgentGuardrailFromFileData, ThrowOnError>,
): RequestResult<
  CreateAgentGuardrailFromFileResponses,
  CreateAgentGuardrailFromFileErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    CreateAgentGuardrailFromFileResponses,
    CreateAgentGuardrailFromFileErrors,
    ThrowOnError
  >({
    ...formDataBodySerializer,
    responseType: "json",
    url: "/api/agents/{agent_id}/guardrails/upload",
    ...options,
    headers: {
      "Content-Type": null,
      ...options.headers,
    },
  });

/**
 * List agent tools
 *
 * Paginated list of tools linked to an agent.
 */
export const listAgentTools = <ThrowOnError extends boolean = false>(
  options: Options<ListAgentToolsData, ThrowOnError>,
): RequestResult<ListAgentToolsResponses, ListAgentToolsErrors, ThrowOnError> =>
  (options.client ?? client).get<
    ListAgentToolsResponses,
    ListAgentToolsErrors,
    ThrowOnError
  >({
    responseType: "json",
    url: "/api/agents/{agent_id}/tools",
    ...options,
  });

/**
 * Add tool to agent
 *
 * Link a tool to an agent by name (creates tool if missing).
 */
export const addAgentTool = <ThrowOnError extends boolean = false>(
  options: Options<AddAgentToolData, ThrowOnError>,
): RequestResult<AddAgentToolResponses, AddAgentToolErrors, ThrowOnError> =>
  (options.client ?? client).post<
    AddAgentToolResponses,
    AddAgentToolErrors,
    ThrowOnError
  >({
    responseType: "json",
    url: "/api/agents/{agent_id}/tools",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * List catalog tools assignable to this agent
 *
 * Returns registry tools this agent may be given in the editor: excludes connection-only names, applies Thyra Shift visibility for Recall Interactions, and omits Long Memory when Thyra Shift external (non-empty connection_triggered) is enabled. Optional `draft_metadata` is a JSON object with `execution_archetype` and/or `input_source_config` to preview eligibility before save.
 */
export const listEligibleToolsForAgentEdit = <
  ThrowOnError extends boolean = false,
>(
  options: Options<ListEligibleToolsForAgentEditData, ThrowOnError>,
): RequestResult<
  ListEligibleToolsForAgentEditResponses,
  ListEligibleToolsForAgentEditErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    ListEligibleToolsForAgentEditResponses,
    ListEligibleToolsForAgentEditErrors,
    ThrowOnError
  >({
    responseType: "json",
    url: "/api/agents/{agent_id}/tools/eligible-for-edit",
    ...options,
  });

/**
 * Remove tool from agent
 *
 * Unlink a tool from an agent.
 */
export const removeAgentTool = <ThrowOnError extends boolean = false>(
  options: Options<RemoveAgentToolData, ThrowOnError>,
): RequestResult<
  RemoveAgentToolResponses,
  RemoveAgentToolErrors,
  ThrowOnError
> =>
  (options.client ?? client).delete<
    RemoveAgentToolResponses,
    RemoveAgentToolErrors,
    ThrowOnError
  >({ url: "/api/agents/{agent_id}/tools/{tool_id}", ...options });

/**
 * Update tool settings
 *
 * Update per-tool settings for a tool linked to the agent.
 */
export const updateAgentToolSettings = <ThrowOnError extends boolean = false>(
  options: Options<UpdateAgentToolSettingsData, ThrowOnError>,
): RequestResult<
  UpdateAgentToolSettingsResponses,
  UpdateAgentToolSettingsErrors,
  ThrowOnError
> =>
  (options.client ?? client).patch<
    UpdateAgentToolSettingsResponses,
    UpdateAgentToolSettingsErrors,
    ThrowOnError
  >({
    responseType: "json",
    url: "/api/agents/{agent_id}/tools/{tool_id}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * List agent queries
 *
 * Paginated list of model queries for an agent.
 */
export const listAgentQueries = <ThrowOnError extends boolean = false>(
  options: Options<ListAgentQueriesData, ThrowOnError>,
): RequestResult<
  ListAgentQueriesResponses,
  ListAgentQueriesErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    ListAgentQueriesResponses,
    ListAgentQueriesErrors,
    ThrowOnError
  >({
    responseType: "json",
    url: "/api/agents/{agent_id}/queries",
    ...options,
  });

/**
 * Create model query
 *
 * Record a user query and optional model response for an agent.
 */
export const createAgentQuery = <ThrowOnError extends boolean = false>(
  options: Options<CreateAgentQueryData, ThrowOnError>,
): RequestResult<
  CreateAgentQueryResponses,
  CreateAgentQueryErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    CreateAgentQueryResponses,
    CreateAgentQueryErrors,
    ThrowOnError
  >({
    responseType: "json",
    url: "/api/agents/{agent_id}/queries",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * List trigger activity events
 *
 * Paginated feed of trigger runs (scheduled, manual, connections) including failures and skips.
 */
export const listAgentTriggerEvents = <ThrowOnError extends boolean = false>(
  options: Options<ListAgentTriggerEventsData, ThrowOnError>,
): RequestResult<
  ListAgentTriggerEventsResponses,
  ListAgentTriggerEventsErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    ListAgentTriggerEventsResponses,
    ListAgentTriggerEventsErrors,
    ThrowOnError
  >({
    responseType: "json",
    url: "/api/agents/{agent_id}/trigger-events",
    ...options,
  });

/**
 * Unified execution trace log
 *
 * Paginated log of all agent executions across every trigger source (chat, email, Telegram, auto-run, scheduled task, webhooks). Each entry includes trigger context, response preview, ordered tool calls, and the sender identity for channel-triggered runs. Supports filtering by channel source and sender identity substring.
 */
export const listAgentExecutionTrace = <ThrowOnError extends boolean = false>(
  options: Options<ListAgentExecutionTraceData, ThrowOnError>,
): RequestResult<
  ListAgentExecutionTraceResponses,
  ListAgentExecutionTraceErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    ListAgentExecutionTraceResponses,
    ListAgentExecutionTraceErrors,
    ThrowOnError
  >({
    responseType: "json",
    url: "/api/agents/{agent_id}/execution-trace",
    ...options,
  });

/**
 * Delete model query
 *
 * Soft-delete a model query.
 */
export const deleteAgentQuery = <ThrowOnError extends boolean = false>(
  options: Options<DeleteAgentQueryData, ThrowOnError>,
): RequestResult<
  DeleteAgentQueryResponses,
  DeleteAgentQueryErrors,
  ThrowOnError
> =>
  (options.client ?? client).delete<
    DeleteAgentQueryResponses,
    DeleteAgentQueryErrors,
    ThrowOnError
  >({ url: "/api/agents/{agent_id}/queries/{id}", ...options });

/**
 * Get query by ID
 *
 * Return a single model query for an agent.
 */
export const getAgentQuery = <ThrowOnError extends boolean = false>(
  options: Options<GetAgentQueryData, ThrowOnError>,
): RequestResult<GetAgentQueryResponses, GetAgentQueryErrors, ThrowOnError> =>
  (options.client ?? client).get<
    GetAgentQueryResponses,
    GetAgentQueryErrors,
    ThrowOnError
  >({
    responseType: "json",
    url: "/api/agents/{agent_id}/queries/{id}",
    ...options,
  });

/**
 * Update model query
 *
 * Update user query, model response, or method used.
 */
export const updateAgentQuery = <ThrowOnError extends boolean = false>(
  options: Options<UpdateAgentQueryData, ThrowOnError>,
): RequestResult<
  UpdateAgentQueryResponses,
  UpdateAgentQueryErrors,
  ThrowOnError
> =>
  (options.client ?? client).patch<
    UpdateAgentQueryResponses,
    UpdateAgentQueryErrors,
    ThrowOnError
  >({
    responseType: "json",
    url: "/api/agents/{agent_id}/queries/{id}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * List agent daily stats
 *
 * Daily aggregates of model queries for this agent (totalQueries per day). Optional days=30 or from/to.
 */
export const listAgentStats = <ThrowOnError extends boolean = false>(
  options: Options<ListAgentStatsData, ThrowOnError>,
): RequestResult<ListAgentStatsResponses, ListAgentStatsErrors, ThrowOnError> =>
  (options.client ?? client).get<
    ListAgentStatsResponses,
    ListAgentStatsErrors,
    ThrowOnError
  >({
    responseType: "json",
    url: "/api/agents/{agent_id}/stats",
    ...options,
  });

/**
 * Router usage summary
 *
 * Aggregated usage for the router page: total queries, tokens, avg duration, and count by method (EFFICIENCY/PERFORMANCE).
 */
export const getAgentRouterSummary = <ThrowOnError extends boolean = false>(
  options: Options<GetAgentRouterSummaryData, ThrowOnError>,
): RequestResult<
  GetAgentRouterSummaryResponses,
  GetAgentRouterSummaryErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetAgentRouterSummaryResponses,
    GetAgentRouterSummaryErrors,
    ThrowOnError
  >({
    responseType: "json",
    url: "/api/agents/{agent_id}/router-summary",
    ...options,
  });

/**
 * Ingest document for agent RAG
 *
 * Upload a document (base64); content is chunked and added to the agent's RAG index. When queue is configured, returns 202 with job_id.
 */
export const ingestAgentDocument = <ThrowOnError extends boolean = false>(
  options: Options<IngestAgentDocumentData, ThrowOnError>,
): RequestResult<
  IngestAgentDocumentResponses,
  IngestAgentDocumentErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    IngestAgentDocumentResponses,
    IngestAgentDocumentErrors,
    ThrowOnError
  >({
    responseType: "json",
    url: "/api/agents/{agent_id}/documents/ingest",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Ingest URL for agent RAG
 *
 * Fetch URL, extract main content (ignore nav/ads), chunk and add to the agent's RAG index. When queue is configured, returns 202 with job_id.
 */
export const ingestAgentDocumentUrl = <ThrowOnError extends boolean = false>(
  options: Options<IngestAgentDocumentUrlData, ThrowOnError>,
): RequestResult<
  IngestAgentDocumentUrlResponses,
  IngestAgentDocumentUrlErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    IngestAgentDocumentUrlResponses,
    IngestAgentDocumentUrlErrors,
    ThrowOnError
  >({
    responseType: "json",
    url: "/api/agents/{agent_id}/documents/ingest-url",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * List agent documents
 *
 * Paginated list of documents in the agent's RAG index (requires database).
 */
export const listAgentDocuments = <ThrowOnError extends boolean = false>(
  options: Options<ListAgentDocumentsData, ThrowOnError>,
): RequestResult<
  ListAgentDocumentsResponses,
  ListAgentDocumentsErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    ListAgentDocumentsResponses,
    ListAgentDocumentsErrors,
    ThrowOnError
  >({
    responseType: "json",
    url: "/api/agents/{agent_id}/documents",
    ...options,
  });

/**
 * Add document
 *
 * Add a single document by content (and optional id/metadata). When queue is configured, returns 202 with job_id.
 */
export const addAgentDocument = <ThrowOnError extends boolean = false>(
  options: Options<AddAgentDocumentData, ThrowOnError>,
): RequestResult<
  AddAgentDocumentResponses,
  AddAgentDocumentErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    AddAgentDocumentResponses,
    AddAgentDocumentErrors,
    ThrowOnError
  >({
    responseType: "json",
    url: "/api/agents/{agent_id}/documents",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Knowledge upload policy (fast)
 *
 * Lightweight gate for the Knowledge Base UI: RAG tool assignment and knowledge document quota only. Does not reconcile the vector index (use documents/health for drift/reindex).
 */
export const getAgentKnowledgeUploadPolicy = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetAgentKnowledgeUploadPolicyData, ThrowOnError>,
): RequestResult<
  GetAgentKnowledgeUploadPolicyResponses,
  GetAgentKnowledgeUploadPolicyErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetAgentKnowledgeUploadPolicyResponses,
    GetAgentKnowledgeUploadPolicyErrors,
    ThrowOnError
  >({
    responseType: "json",
    url: "/api/agents/{agent_id}/documents/upload-policy",
    ...options,
  });

/**
 * Documents health (reconciliation)
 *
 * Compare DB document count vs RAG chunk count; returns needs_reindex when mismatch.
 */
export const getAgentDocumentsHealth = <ThrowOnError extends boolean = false>(
  options: Options<GetAgentDocumentsHealthData, ThrowOnError>,
): RequestResult<
  GetAgentDocumentsHealthResponses,
  GetAgentDocumentsHealthErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetAgentDocumentsHealthResponses,
    GetAgentDocumentsHealthErrors,
    ThrowOnError
  >({
    responseType: "json",
    url: "/api/agents/{agent_id}/documents/health",
    ...options,
  });

/**
 * Re-index from sources
 *
 * Re-fetch file/URL documents and re-add to RAG. Returns 202 with job_id when queue configured.
 */
export const reindexAgentDocuments = <ThrowOnError extends boolean = false>(
  options: Options<ReindexAgentDocumentsData, ThrowOnError>,
): RequestResult<
  ReindexAgentDocumentsResponses,
  ReindexAgentDocumentsErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    ReindexAgentDocumentsResponses,
    ReindexAgentDocumentsErrors,
    ThrowOnError
  >({
    responseType: "json",
    url: "/api/agents/{agent_id}/documents/reindex",
    ...options,
  });

/**
 * Delete document
 *
 * Remove a document from the agent's RAG index and DB.
 */
export const deleteAgentDocument = <ThrowOnError extends boolean = false>(
  options: Options<DeleteAgentDocumentData, ThrowOnError>,
): RequestResult<
  DeleteAgentDocumentResponses,
  DeleteAgentDocumentErrors,
  ThrowOnError
> =>
  (options.client ?? client).delete<
    DeleteAgentDocumentResponses,
    DeleteAgentDocumentErrors,
    ThrowOnError
  >({ url: "/api/agents/{agent_id}/documents/{document_id}", ...options });

/**
 * Get document by ID
 *
 * Get a single document by id (UUID or RAG document_id).
 */
export const getAgentDocument = <ThrowOnError extends boolean = false>(
  options: Options<GetAgentDocumentData, ThrowOnError>,
): RequestResult<
  GetAgentDocumentResponses,
  GetAgentDocumentErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetAgentDocumentResponses,
    GetAgentDocumentErrors,
    ThrowOnError
  >({
    responseType: "json",
    url: "/api/agents/{agent_id}/documents/{document_id}",
    ...options,
  });

/**
 * Update document
 *
 * Update document usage type (knowledge | instructions). File/URL docs are re-indexed to the new namespace; text docs cannot be changed.
 */
export const updateAgentDocument = <ThrowOnError extends boolean = false>(
  options: Options<UpdateAgentDocumentData, ThrowOnError>,
): RequestResult<
  UpdateAgentDocumentResponses,
  UpdateAgentDocumentErrors,
  ThrowOnError
> =>
  (options.client ?? client).patch<
    UpdateAgentDocumentResponses,
    UpdateAgentDocumentErrors,
    ThrowOnError
  >({
    responseType: "json",
    url: "/api/agents/{agent_id}/documents/{document_id}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Get chat-knowledge preference
 *
 * Return the requesting user's 'Never ask again' preference for the chat-knowledge popup on this agent. Defaults to false when no preference has been saved.
 */
export const getAgentChatKnowledgePreference = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetAgentChatKnowledgePreferenceData, ThrowOnError>,
): RequestResult<
  GetAgentChatKnowledgePreferenceResponses,
  GetAgentChatKnowledgePreferenceErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetAgentChatKnowledgePreferenceResponses,
    GetAgentChatKnowledgePreferenceErrors,
    ThrowOnError
  >({
    responseType: "json",
    url: "/api/agents/{agent_id}/chat-knowledge/preference",
    ...options,
  });

/**
 * Update chat-knowledge preference
 *
 * Upsert the requesting user's 'Never ask again' preference for the chat-knowledge popup on this agent. Set prompt_disabled=true to suppress future prompts.
 */
export const putAgentChatKnowledgePreference = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PutAgentChatKnowledgePreferenceData, ThrowOnError>,
): RequestResult<
  PutAgentChatKnowledgePreferenceResponses,
  PutAgentChatKnowledgePreferenceErrors,
  ThrowOnError
> =>
  (options.client ?? client).put<
    PutAgentChatKnowledgePreferenceResponses,
    PutAgentChatKnowledgePreferenceErrors,
    ThrowOnError
  >({
    responseType: "json",
    url: "/api/agents/{agent_id}/chat-knowledge/preference",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Accept a sub-agent keep offer
 *
 * Consume a single-use 'Keep this sub-agent?' offer (from the `sub_agent_keep_offer` stream line) and promote the temporary child to a permanent linked child. 404 `sub_agent_keep_offer_not_found` when the offer is unknown, expired, already used or belongs to another user; 409 `kept_sub_agent_cap_reached` at the limit.
 */
export const acceptSubAgentKeepOffer = <ThrowOnError extends boolean = false>(
  options: Options<AcceptSubAgentKeepOfferData, ThrowOnError>,
): RequestResult<
  AcceptSubAgentKeepOfferResponses,
  AcceptSubAgentKeepOfferErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    AcceptSubAgentKeepOfferResponses,
    AcceptSubAgentKeepOfferErrors,
    ThrowOnError
  >({
    responseType: "json",
    url: "/api/chat/sub-agent-keep-offers/{offer_id}/accept",
    ...options,
  });

/**
 * Dismiss a sub-agent keep offer
 *
 * Consume the offer and mark the temporary child dismissed (it is never offered again; the manual Keep button stays). With `never_ask`, also disable future offers for the parent agent.
 */
export const dismissSubAgentKeepOffer = <ThrowOnError extends boolean = false>(
  options: Options<DismissSubAgentKeepOfferData, ThrowOnError>,
): RequestResult<
  DismissSubAgentKeepOfferResponses,
  DismissSubAgentKeepOfferErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    DismissSubAgentKeepOfferResponses,
    DismissSubAgentKeepOfferErrors,
    ThrowOnError
  >({
    responseType: "json",
    url: "/api/chat/sub-agent-keep-offers/{offer_id}/dismiss",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Get sub-agent keep preference
 *
 * Whether the requesting user disabled the 'Keep this sub-agent?' offer for this agent (default false).
 */
export const getAgentSubAgentKeepPreference = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetAgentSubAgentKeepPreferenceData, ThrowOnError>,
): RequestResult<
  GetAgentSubAgentKeepPreferenceResponses,
  GetAgentSubAgentKeepPreferenceErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetAgentSubAgentKeepPreferenceResponses,
    GetAgentSubAgentKeepPreferenceErrors,
    ThrowOnError
  >({
    responseType: "json",
    url: "/api/agents/{agent_id}/sub-agent-keep-preference",
    ...options,
  });

/**
 * Update sub-agent keep preference
 *
 * Upsert the requesting user's choice for this (parent) agent; `disabled=false` resets 'Never ask again'.
 */
export const putAgentSubAgentKeepPreference = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PutAgentSubAgentKeepPreferenceData, ThrowOnError>,
): RequestResult<
  PutAgentSubAgentKeepPreferenceResponses,
  PutAgentSubAgentKeepPreferenceErrors,
  ThrowOnError
> =>
  (options.client ?? client).put<
    PutAgentSubAgentKeepPreferenceResponses,
    PutAgentSubAgentKeepPreferenceErrors,
    ThrowOnError
  >({
    responseType: "json",
    url: "/api/agents/{agent_id}/sub-agent-keep-preference",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * List an Extension toolkit's tools for one agent
 *
 * A keyset page of the toolkit's tools, including admin-disabled and deprecated ones (shown as locked), each flagged with whether this agent has it switched off, plus counts over the whole toolkit.
 */
export const listAgentExtensionTools = <ThrowOnError extends boolean = false>(
  options: Options<ListAgentExtensionToolsData, ThrowOnError>,
): RequestResult<
  ListAgentExtensionToolsResponses,
  ListAgentExtensionToolsErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    ListAgentExtensionToolsResponses,
    ListAgentExtensionToolsErrors,
    ThrowOnError
  >({
    responseType: "json",
    url: "/api/agents/{agent_id}/extension-tools/{provider_key}",
    ...options,
  });

/**
 * Switch one Extension tool on or off for an agent
 *
 * Idempotent. 404 for a tool that is not in the toolkit; 409 when enabling a tool an admin disabled or the vendor deprecated (those can only be off).
 */
export const setAgentExtensionTool = <ThrowOnError extends boolean = false>(
  options: Options<SetAgentExtensionToolData, ThrowOnError>,
): RequestResult<
  SetAgentExtensionToolResponses,
  SetAgentExtensionToolErrors,
  ThrowOnError
> =>
  (options.client ?? client).put<
    SetAgentExtensionToolResponses,
    SetAgentExtensionToolErrors,
    ThrowOnError
  >({
    responseType: "json",
    url: "/api/agents/{agent_id}/extension-tools/{provider_key}/{tool_name}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Switch many Extension tools on or off for an agent
 *
 * Applies to all tools, only read-only ones, only the ones that change data, or a list of names, in one transaction. Admin-disabled and deprecated tools are skipped and reported in skipped_locked.
 */
export const bulkSetAgentExtensionTools = <
  ThrowOnError extends boolean = false,
>(
  options: Options<BulkSetAgentExtensionToolsData, ThrowOnError>,
): RequestResult<
  BulkSetAgentExtensionToolsResponses,
  BulkSetAgentExtensionToolsErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    BulkSetAgentExtensionToolsResponses,
    BulkSetAgentExtensionToolsErrors,
    ThrowOnError
  >({
    responseType: "json",
    url: "/api/agents/{agent_id}/extension-tools/{provider_key}/bulk",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * List the triggers an Extension toolkit offers, and which this agent listens to
 */
export const listAgentExtensionTriggers = <
  ThrowOnError extends boolean = false,
>(
  options: Options<ListAgentExtensionTriggersData, ThrowOnError>,
): RequestResult<
  ListAgentExtensionTriggersResponses,
  ListAgentExtensionTriggersErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    ListAgentExtensionTriggersResponses,
    ListAgentExtensionTriggersErrors,
    ThrowOnError
  >({
    responseTransformer: listAgentExtensionTriggersResponseTransformer,
    responseType: "json",
    url: "/api/agents/{agent_id}/extension-triggers/{provider_key}",
    ...options,
  });

/**
 * Stop running this agent on the trigger
 *
 * Idempotent: 204 whether or not the trigger was on.
 */
export const disableAgentExtensionTrigger = <
  ThrowOnError extends boolean = false,
>(
  options: Options<DisableAgentExtensionTriggerData, ThrowOnError>,
): RequestResult<
  DisableAgentExtensionTriggerResponses,
  DisableAgentExtensionTriggerErrors,
  ThrowOnError
> =>
  (options.client ?? client).delete<
    DisableAgentExtensionTriggerResponses,
    DisableAgentExtensionTriggerErrors,
    ThrowOnError
  >({
    url: "/api/agents/{agent_id}/extension-triggers/{provider_key}/{trigger_slug}",
    ...options,
  });

/**
 * Run this agent whenever the trigger fires
 *
 * Creates the vendor trigger on the agent's connected account. Events from before this call are ignored. 409 when the integration is not connected or the vendor refuses the trigger.
 */
export const enableAgentExtensionTrigger = <
  ThrowOnError extends boolean = false,
>(
  options: Options<EnableAgentExtensionTriggerData, ThrowOnError>,
): RequestResult<
  EnableAgentExtensionTriggerResponses,
  EnableAgentExtensionTriggerErrors,
  ThrowOnError
> =>
  (options.client ?? client).put<
    EnableAgentExtensionTriggerResponses,
    EnableAgentExtensionTriggerErrors,
    ThrowOnError
  >({
    responseTransformer: enableAgentExtensionTriggerResponseTransformer,
    responseType: "json",
    url: "/api/agents/{agent_id}/extension-triggers/{provider_key}/{trigger_slug}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * List Orchestration Events
 */
export const listOrchestrationEventsApiAgentsAgentIdOrchestrationEventsGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    ListOrchestrationEventsApiAgentsAgentIdOrchestrationEventsGetData,
    ThrowOnError
  >,
): RequestResult<
  ListOrchestrationEventsApiAgentsAgentIdOrchestrationEventsGetResponses,
  ListOrchestrationEventsApiAgentsAgentIdOrchestrationEventsGetErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    ListOrchestrationEventsApiAgentsAgentIdOrchestrationEventsGetResponses,
    ListOrchestrationEventsApiAgentsAgentIdOrchestrationEventsGetErrors,
    ThrowOnError
  >({
    responseType: "json",
    url: "/api/agents/{agent_id}/orchestration/events",
    ...options,
  });

/**
 * List Delegation Events
 */
export const listDelegationEventsApiAgentsAgentIdOrchestrationDelegationsGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    ListDelegationEventsApiAgentsAgentIdOrchestrationDelegationsGetData,
    ThrowOnError
  >,
): RequestResult<
  ListDelegationEventsApiAgentsAgentIdOrchestrationDelegationsGetResponses,
  ListDelegationEventsApiAgentsAgentIdOrchestrationDelegationsGetErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    ListDelegationEventsApiAgentsAgentIdOrchestrationDelegationsGetResponses,
    ListDelegationEventsApiAgentsAgentIdOrchestrationDelegationsGetErrors,
    ThrowOnError
  >({
    responseType: "json",
    url: "/api/agents/{agent_id}/orchestration/delegations",
    ...options,
  });

/**
 * List Agent Shared Memory
 */
export const listAgentSharedMemoryApiAgentsAgentIdSharedMemoryGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    ListAgentSharedMemoryApiAgentsAgentIdSharedMemoryGetData,
    ThrowOnError
  >,
): RequestResult<
  ListAgentSharedMemoryApiAgentsAgentIdSharedMemoryGetResponses,
  ListAgentSharedMemoryApiAgentsAgentIdSharedMemoryGetErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    ListAgentSharedMemoryApiAgentsAgentIdSharedMemoryGetResponses,
    ListAgentSharedMemoryApiAgentsAgentIdSharedMemoryGetErrors,
    ThrowOnError
  >({
    responseType: "json",
    url: "/api/agents/{agent_id}/shared-memory",
    ...options,
  });

/**
 * Get Relationship Tree
 */
export const getRelationshipTreeApiAgentsAgentIdRelationshipsTreeGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetRelationshipTreeApiAgentsAgentIdRelationshipsTreeGetData,
    ThrowOnError
  >,
): RequestResult<
  GetRelationshipTreeApiAgentsAgentIdRelationshipsTreeGetResponses,
  GetRelationshipTreeApiAgentsAgentIdRelationshipsTreeGetErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetRelationshipTreeApiAgentsAgentIdRelationshipsTreeGetResponses,
    GetRelationshipTreeApiAgentsAgentIdRelationshipsTreeGetErrors,
    ThrowOnError
  >({
    responseType: "json",
    url: "/api/agents/{agent_id}/relationships/tree",
    ...options,
  });

/**
 * Get System Agent Monitoring
 */
export const getSystemAgentMonitoringApiAgentsSystemMonitoringGet = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<
    GetSystemAgentMonitoringApiAgentsSystemMonitoringGetData,
    ThrowOnError
  >,
): RequestResult<
  GetSystemAgentMonitoringApiAgentsSystemMonitoringGetResponses,
  GetSystemAgentMonitoringApiAgentsSystemMonitoringGetErrors,
  ThrowOnError
> =>
  (options?.client ?? client).get<
    GetSystemAgentMonitoringApiAgentsSystemMonitoringGetResponses,
    GetSystemAgentMonitoringApiAgentsSystemMonitoringGetErrors,
    ThrowOnError
  >({
    responseType: "json",
    url: "/api/agents/system/monitoring",
    ...options,
  });

/**
 * Get System Agent Orchestration Health
 */
export const getSystemAgentOrchestrationHealthApiAgentsSystemAgentIdOrchestrationHealthGet =
  <ThrowOnError extends boolean = false>(
    options: Options<
      GetSystemAgentOrchestrationHealthApiAgentsSystemAgentIdOrchestrationHealthGetData,
      ThrowOnError
    >,
  ): RequestResult<
    GetSystemAgentOrchestrationHealthApiAgentsSystemAgentIdOrchestrationHealthGetResponses,
    GetSystemAgentOrchestrationHealthApiAgentsSystemAgentIdOrchestrationHealthGetErrors,
    ThrowOnError
  > =>
    (options.client ?? client).get<
      GetSystemAgentOrchestrationHealthApiAgentsSystemAgentIdOrchestrationHealthGetResponses,
      GetSystemAgentOrchestrationHealthApiAgentsSystemAgentIdOrchestrationHealthGetErrors,
      ThrowOnError
    >({
      responseType: "json",
      url: "/api/agents/system/{agent_id}/orchestration-health",
      ...options,
    });

/**
 * Analyze and design sub-agent orchestration
 *
 * Runs a dedicated LLM pass to determine whether sub-agents are needed and returns detailed role/instruction/tool design for each specialist.
 */
export const designSubAgents = <ThrowOnError extends boolean = false>(
  options: Options<DesignSubAgentsData, ThrowOnError>,
): RequestResult<
  DesignSubAgentsResponses,
  DesignSubAgentsErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    DesignSubAgentsResponses,
    DesignSubAgentsErrors,
    ThrowOnError
  >({
    responseType: "json",
    url: "/api/agents/design-sub-agents",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Get contextual questions for step 3
 *
 * Returns 4–8 questions tailored to the agent name/role or to pattern instructions when pattern is selected.
 */
export const getAgentQuestionnaireContextualQuestions = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetAgentQuestionnaireContextualQuestionsData, ThrowOnError>,
): RequestResult<
  GetAgentQuestionnaireContextualQuestionsResponses,
  GetAgentQuestionnaireContextualQuestionsErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    GetAgentQuestionnaireContextualQuestionsResponses,
    GetAgentQuestionnaireContextualQuestionsErrors,
    ThrowOnError
  >({
    responseType: "json",
    url: "/api/agents/questionnaire/contextual-questions",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Get optional follow-up questions for step 3
 *
 * Given questions asked and user answers, returns 0 or more follow-up questions (or empty array).
 */
export const getAgentQuestionnaireFollowUpQuestions = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetAgentQuestionnaireFollowUpQuestionsData, ThrowOnError>,
): RequestResult<
  GetAgentQuestionnaireFollowUpQuestionsResponses,
  GetAgentQuestionnaireFollowUpQuestionsErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    GetAgentQuestionnaireFollowUpQuestionsResponses,
    GetAgentQuestionnaireFollowUpQuestionsErrors,
    ThrowOnError
  >({
    responseType: "json",
    url: "/api/agents/questionnaire/follow-up-questions",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Get tool capability questions for questionnaire
 *
 * Generates multiple-choice questions based on a tool's capability schema.
 */
export const getAgentQuestionnaireToolQuestions = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetAgentQuestionnaireToolQuestionsData, ThrowOnError>,
): RequestResult<
  GetAgentQuestionnaireToolQuestionsResponses,
  GetAgentQuestionnaireToolQuestionsErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    GetAgentQuestionnaireToolQuestionsResponses,
    GetAgentQuestionnaireToolQuestionsErrors,
    ThrowOnError
  >({
    responseType: "json",
    url: "/api/agents/questionnaire/tool-questions",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Get connection configuration questions for questionnaire
 *
 * Generates multiple-choice questions based on a connection's configuration schema.
 */
export const getAgentQuestionnaireConnectionQuestions = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetAgentQuestionnaireConnectionQuestionsData, ThrowOnError>,
): RequestResult<
  GetAgentQuestionnaireConnectionQuestionsResponses,
  GetAgentQuestionnaireConnectionQuestionsErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    GetAgentQuestionnaireConnectionQuestionsResponses,
    GetAgentQuestionnaireConnectionQuestionsErrors,
    ThrowOnError
  >({
    responseType: "json",
    url: "/api/agents/questionnaire/connection-questions",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Get tool configuration proposals
 *
 * Generate configuration proposals for selected tools based on agent purpose and mode.
 */
export const getToolConfigurationProposals = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetToolConfigurationProposalsData, ThrowOnError>,
): RequestResult<
  GetToolConfigurationProposalsResponses,
  GetToolConfigurationProposalsErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    GetToolConfigurationProposalsResponses,
    GetToolConfigurationProposalsErrors,
    ThrowOnError
  >({
    responseType: "json",
    url: "/api/agents/tool-configuration-proposals",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Validate tool settings against agent purpose
 *
 * Check if tool settings proposals are appropriate for the agent's stated purpose.
 */
export const validateToolSettings = <ThrowOnError extends boolean = false>(
  options: Options<ValidateToolSettingsData, ThrowOnError>,
): RequestResult<
  ValidateToolSettingsResponses,
  ValidateToolSettingsErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    ValidateToolSettingsResponses,
    ValidateToolSettingsErrors,
    ThrowOnError
  >({
    responseType: "json",
    url: "/api/agents/validate-tool-settings",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Delete create-agent wizard draft
 *
 * Delete the current user's saved wizard draft.
 */
export const deleteAgentWizardDraft = <ThrowOnError extends boolean = false>(
  options?: Options<DeleteAgentWizardDraftData, ThrowOnError>,
): RequestResult<
  DeleteAgentWizardDraftResponses,
  DeleteAgentWizardDraftErrors,
  ThrowOnError
> =>
  (options?.client ?? client).delete<
    DeleteAgentWizardDraftResponses,
    DeleteAgentWizardDraftErrors,
    ThrowOnError
  >({
    responseType: "json",
    url: "/api/agents/wizard-draft",
    ...options,
  });

/**
 * Get create-agent wizard draft
 *
 * Get the current user's saved wizard draft from DB.
 */
export const getAgentWizardDraft = <ThrowOnError extends boolean = false>(
  options?: Options<GetAgentWizardDraftData, ThrowOnError>,
): RequestResult<
  GetAgentWizardDraftResponses,
  GetAgentWizardDraftErrors,
  ThrowOnError
> =>
  (options?.client ?? client).get<
    GetAgentWizardDraftResponses,
    GetAgentWizardDraftErrors,
    ThrowOnError
  >({
    responseTransformer: getAgentWizardDraftResponseTransformer,
    responseType: "json",
    url: "/api/agents/wizard-draft",
    ...options,
  });

/**
 * Save create-agent wizard draft
 *
 * Persist or replace the current user's wizard draft in DB (one row per user).
 */
export const saveAgentWizardDraft = <ThrowOnError extends boolean = false>(
  options: Options<SaveAgentWizardDraftData, ThrowOnError>,
): RequestResult<
  SaveAgentWizardDraftResponses,
  SaveAgentWizardDraftErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    SaveAgentWizardDraftResponses,
    SaveAgentWizardDraftErrors,
    ThrowOnError
  >({
    responseTransformer: saveAgentWizardDraftResponseTransformer,
    responseType: "json",
    url: "/api/agents/wizard-draft",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Stream wizard chat response
 *
 * Stream the next assistant turn for the agent builder chat step. Returns NDJSON: text chunks, then phase/suggestions/can_proceed.
 */
export const streamWizardChat = <ThrowOnError extends boolean = false>(
  options: Options<StreamWizardChatData, ThrowOnError>,
): RequestResult<
  StreamWizardChatResponses,
  StreamWizardChatErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    StreamWizardChatResponses,
    StreamWizardChatErrors,
    ThrowOnError
  >({
    responseType: "json",
    url: "/api/agents/wizard-chat/stream",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Extract structured data from wizard chat
 *
 * Extract q3_rules, connection_settings, tool_settings from the full chat history.
 */
export const extractWizardChatData = <ThrowOnError extends boolean = false>(
  options: Options<ExtractWizardChatDataData, ThrowOnError>,
): RequestResult<
  ExtractWizardChatDataResponses,
  ExtractWizardChatDataErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    ExtractWizardChatDataResponses,
    ExtractWizardChatDataErrors,
    ThrowOnError
  >({
    responseType: "json",
    url: "/api/agents/wizard-chat/extract",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Stream agent edit chat
 *
 * Stream the next assistant turn for editing an existing agent via chat. NDJSON: text chunks, then phase/suggestions/can_proceed.
 */
export const streamAgentEditChat = <ThrowOnError extends boolean = false>(
  options: Options<StreamAgentEditChatData, ThrowOnError>,
): RequestResult<
  StreamAgentEditChatResponses,
  StreamAgentEditChatErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    StreamAgentEditChatResponses,
    StreamAgentEditChatErrors,
    ThrowOnError
  >({
    responseType: "json",
    url: "/api/agents/{agent_id}/edit-chat/stream",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Extract edit delta from agent edit chat
 *
 * Structured preview for PATCH /api/agents/{id} (no DB write).
 */
export const extractAgentEditChat = <ThrowOnError extends boolean = false>(
  options: Options<ExtractAgentEditChatData, ThrowOnError>,
): RequestResult<
  ExtractAgentEditChatResponses,
  ExtractAgentEditChatErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    ExtractAgentEditChatResponses,
    ExtractAgentEditChatErrors,
    ThrowOnError
  >({
    responseType: "json",
    url: "/api/agents/{agent_id}/edit-chat/extract",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Fields that cannot be changed via agent edit chat
 *
 * Static, registry-derived list for upfront UI disclosure of the edit-chat read-only fence.
 */
export const getAgentEditChatReadOnlyFields = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<GetAgentEditChatReadOnlyFieldsData, ThrowOnError>,
): RequestResult<
  GetAgentEditChatReadOnlyFieldsResponses,
  GetAgentEditChatReadOnlyFieldsErrors,
  ThrowOnError
> =>
  (options?.client ?? client).get<
    GetAgentEditChatReadOnlyFieldsResponses,
    GetAgentEditChatReadOnlyFieldsErrors,
    ThrowOnError
  >({
    responseType: "json",
    url: "/api/agents/edit-chat/read-only-fields",
    ...options,
  });

/**
 * Convert step 3 Q&A to agent instructions
 *
 * Convert structured behavior Q&A and additional rules into the agent instruction pattern (ordered list of imperative strings).
 */
export const convertBehaviorToInstructions = <
  ThrowOnError extends boolean = false,
>(
  options: Options<ConvertBehaviorToInstructionsData, ThrowOnError>,
): RequestResult<
  ConvertBehaviorToInstructionsResponses,
  ConvertBehaviorToInstructionsErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    ConvertBehaviorToInstructionsResponses,
    ConvertBehaviorToInstructionsErrors,
    ThrowOnError
  >({
    responseType: "json",
    url: "/api/agents/questionnaire/behavior-to-instructions",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Convert step 3 Q&A to dual-mode instructions (Thyra Shift)
 *
 * Two LLM passes: external (connection-triggered) and owner chat instructions, merged into shared instructions plus input_source_config deltas.
 */
export const convertBehaviorToInstructionsDual = <
  ThrowOnError extends boolean = false,
>(
  options: Options<ConvertBehaviorToInstructionsDualData, ThrowOnError>,
): RequestResult<
  ConvertBehaviorToInstructionsDualResponses,
  ConvertBehaviorToInstructionsDualErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    ConvertBehaviorToInstructionsDualResponses,
    ConvertBehaviorToInstructionsDualErrors,
    ThrowOnError
  >({
    responseType: "json",
    url: "/api/agents/questionnaire/behavior-to-instructions-dual",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Preview the agent's instructions before creating it
 *
 * Same payload as POST /agents/from-questionnaire. Runs the creation-time extraction and returns the instructions the agent would receive, without creating anything. The review page shows these for editing; the edited list is sent back as q3_instructions on create.
 */
export const synthesizeAgentPreview = <ThrowOnError extends boolean = false>(
  options: Options<SynthesizeAgentPreviewData, ThrowOnError>,
): RequestResult<
  SynthesizeAgentPreviewResponses,
  SynthesizeAgentPreviewErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    SynthesizeAgentPreviewResponses,
    SynthesizeAgentPreviewErrors,
    ThrowOnError
  >({
    responseType: "json",
    url: "/api/agents/questionnaire/synthesize",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Create agent from questionnaire
 *
 * Create agent from Q1–Q6 answers via LLM extraction; creates guardrails and returns ingestion_list for document upload. The leak-risk advisory review runs after this response is sent and is never part of it — read metadata.leak_risk_review from GET /agents/{agent_id} once the agent exists.
 */
export const createAgentFromQuestionnaire = <
  ThrowOnError extends boolean = false,
>(
  options: Options<CreateAgentFromQuestionnaireData, ThrowOnError>,
): RequestResult<
  CreateAgentFromQuestionnaireResponses,
  CreateAgentFromQuestionnaireErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    CreateAgentFromQuestionnaireResponses,
    CreateAgentFromQuestionnaireErrors,
    ThrowOnError
  >({
    responseType: "json",
    url: "/api/agents/from-questionnaire",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Enqueue create agent from questionnaire
 *
 * Same payload as POST /agents/from-questionnaire; returns 202 with a job id. Poll GET /agents/creation-jobs/{job_id} until status is succeeded or failed. Requires Redis (queue) to be configured.
 */
export const createAgentFromQuestionnaireAsync = <
  ThrowOnError extends boolean = false,
>(
  options: Options<CreateAgentFromQuestionnaireAsyncData, ThrowOnError>,
): RequestResult<
  CreateAgentFromQuestionnaireAsyncResponses,
  CreateAgentFromQuestionnaireAsyncErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    CreateAgentFromQuestionnaireAsyncResponses,
    CreateAgentFromQuestionnaireAsyncErrors,
    ThrowOnError
  >({
    responseType: "json",
    url: "/api/agents/from-questionnaire/async",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Retry endpoint (GET does not run retry)
 *
 * Opening this URL in a browser issues GET, which cannot enqueue a job. Use POST (e.g. in-app Retry button) to re-run failed creation.
 */
export const retryAgentCreationJobGetHint = <
  ThrowOnError extends boolean = false,
>(
  options: Options<RetryAgentCreationJobGetHintData, ThrowOnError>,
): RequestResult<
  RetryAgentCreationJobGetHintResponses,
  RetryAgentCreationJobGetHintErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    RetryAgentCreationJobGetHintResponses,
    RetryAgentCreationJobGetHintErrors,
    ThrowOnError
  >({
    responseType: "json",
    url: "/api/agents/creation-jobs/{job_id}/retry",
    ...options,
  });

/**
 * Retry failed background agent creation
 *
 * Enqueue a new job using the stored request_payload from a failed creation job. If the job is still ``running`` but has had no progress for several minutes (e.g. worker restart during creation), it is marked ``failed`` first so retry can proceed. Creates a new agent_creation_jobs row and returns 202 with that new job id (same shape as POST /agents/from-questionnaire/async); the original failed job row is not updated to succeeded. Requires Redis and a failed job row with a valid saved payload.
 */
export const retryAgentCreationJob = <ThrowOnError extends boolean = false>(
  options: Options<RetryAgentCreationJobData, ThrowOnError>,
): RequestResult<
  RetryAgentCreationJobResponses,
  RetryAgentCreationJobErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    RetryAgentCreationJobResponses,
    RetryAgentCreationJobErrors,
    ThrowOnError
  >({
    responseType: "json",
    url: "/api/agents/creation-jobs/{job_id}/retry",
    ...options,
  });

/**
 * Get agent creation job status
 *
 * Poll background agent creation enqueued via POST /agents/from-questionnaire/async.
 */
export const getAgentCreationJob = <ThrowOnError extends boolean = false>(
  options: Options<GetAgentCreationJobData, ThrowOnError>,
): RequestResult<
  GetAgentCreationJobResponses,
  GetAgentCreationJobErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetAgentCreationJobResponses,
    GetAgentCreationJobErrors,
    ThrowOnError
  >({
    responseType: "json",
    url: "/api/agents/creation-jobs/{job_id}",
    ...options,
  });

/**
 * Stream background agent creation job status (SSE)
 *
 * 1-second DB poll rendered as text/event-stream; closes on terminal status.
 */
export const streamAgentCreationJob = <ThrowOnError extends boolean = false>(
  options: Options<StreamAgentCreationJobData, ThrowOnError>,
): RequestResult<
  StreamAgentCreationJobResponses,
  StreamAgentCreationJobErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    StreamAgentCreationJobResponses,
    StreamAgentCreationJobErrors,
    ThrowOnError
  >({
    responseType: "json",
    url: "/api/agents/creation-jobs/{job_id}/events",
    ...options,
  });

/**
 * Clone ready-to-ship system agent
 */
export const cloneSystemAgent = <ThrowOnError extends boolean = false>(
  options: Options<CloneSystemAgentData, ThrowOnError>,
): RequestResult<
  CloneSystemAgentResponses,
  CloneSystemAgentErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    CloneSystemAgentResponses,
    CloneSystemAgentErrors,
    ThrowOnError
  >({
    responseTransformer: cloneSystemAgentResponseTransformer,
    responseType: "json",
    url: "/api/agents/{agent_id}/clone",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * List all agents
 *
 * From DB when configured (optionally by user_id), else from RAG registry. Includes RAG doc count.
 */
export const listAgents = <ThrowOnError extends boolean = false>(
  options?: Options<ListAgentsData, ThrowOnError>,
): RequestResult<ListAgentsResponses, ListAgentsErrors, ThrowOnError> =>
  (options?.client ?? client).get<
    ListAgentsResponses,
    ListAgentsErrors,
    ThrowOnError
  >({
    responseTransformer: listAgentsResponseTransformer,
    responseType: "json",
    url: "/api/agents",
    ...options,
  });

/**
 * Create a new agent
 *
 * Create agent in DB (and init RAG). Agent ID is always server-generated.
 */
export const createAgent = <ThrowOnError extends boolean = false>(
  options: Options<CreateAgentData, ThrowOnError>,
): RequestResult<CreateAgentResponses, CreateAgentErrors, ThrowOnError> =>
  (options.client ?? client).post<
    CreateAgentResponses,
    CreateAgentErrors,
    ThrowOnError
  >({
    responseTransformer: createAgentResponseTransformer,
    responseType: "json",
    url: "/api/agents",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * List ready-to-ship system agents
 */
export const listSystemAgents = <ThrowOnError extends boolean = false>(
  options?: Options<ListSystemAgentsData, ThrowOnError>,
): RequestResult<
  ListSystemAgentsResponses,
  ListSystemAgentsErrors,
  ThrowOnError
> =>
  (options?.client ?? client).get<
    ListSystemAgentsResponses,
    ListSystemAgentsErrors,
    ThrowOnError
  >({
    responseType: "json",
    url: "/api/agents/system",
    ...options,
  });

/**
 * List the categories of ready-to-ship system agents
 */
export const listSystemAgentCategories = <ThrowOnError extends boolean = false>(
  options?: Options<ListSystemAgentCategoriesData, ThrowOnError>,
): RequestResult<
  ListSystemAgentCategoriesResponses,
  ListSystemAgentCategoriesErrors,
  ThrowOnError
> =>
  (options?.client ?? client).get<
    ListSystemAgentCategoriesResponses,
    ListSystemAgentCategoriesErrors,
    ThrowOnError
  >({
    responseType: "json",
    url: "/api/agents/system/categories",
    ...options,
  });

/**
 * Get ready-to-ship system agent detail
 */
export const getSystemAgent = <ThrowOnError extends boolean = false>(
  options: Options<GetSystemAgentData, ThrowOnError>,
): RequestResult<GetSystemAgentResponses, GetSystemAgentErrors, ThrowOnError> =>
  (options.client ?? client).get<
    GetSystemAgentResponses,
    GetSystemAgentErrors,
    ThrowOnError
  >({
    responseType: "json",
    url: "/api/agents/system/{agent_id}",
    ...options,
  });

/**
 * Delete agent
 *
 * Soft delete: the agent is hidden and its data is kept. Requires owner.
 */
export const deleteAgent = <ThrowOnError extends boolean = false>(
  options: Options<DeleteAgentData, ThrowOnError>,
): RequestResult<DeleteAgentResponses, DeleteAgentErrors, ThrowOnError> =>
  (options.client ?? client).delete<
    DeleteAgentResponses,
    DeleteAgentErrors,
    ThrowOnError
  >({ url: "/api/agents/{agent_id}", ...options });

/**
 * Get agent by ID
 *
 * Get agent by id (from DB when configured). Support can read with admin:support_read (no chat logs).
 */
export const getAgent = <ThrowOnError extends boolean = false>(
  options: Options<GetAgentData, ThrowOnError>,
): RequestResult<GetAgentResponses, GetAgentErrors, ThrowOnError> =>
  (options.client ?? client).get<
    GetAgentResponses,
    GetAgentErrors,
    ThrowOnError
  >({
    responseTransformer: getAgentResponseTransformer,
    responseType: "json",
    url: "/api/agents/{agent_id}",
    ...options,
  });

/**
 * Update agent by ID
 *
 * Update name, mode, prompt, instructions, or tools. Support can use admin:support_write.
 */
export const updateAgent = <ThrowOnError extends boolean = false>(
  options: Options<UpdateAgentData, ThrowOnError>,
): RequestResult<UpdateAgentResponses, UpdateAgentErrors, ThrowOnError> =>
  (options.client ?? client).patch<
    UpdateAgentResponses,
    UpdateAgentErrors,
    ThrowOnError
  >({
    responseType: "json",
    url: "/api/agents/{agent_id}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Get background agent update job status
 *
 * Poll background status for PATCH /agents/{id}?background=true.
 */
export const getAgentUpdateJob = <ThrowOnError extends boolean = false>(
  options: Options<GetAgentUpdateJobData, ThrowOnError>,
): RequestResult<
  GetAgentUpdateJobResponses,
  GetAgentUpdateJobErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetAgentUpdateJobResponses,
    GetAgentUpdateJobErrors,
    ThrowOnError
  >({
    responseType: "json",
    url: "/api/agents/update-jobs/{job_id}",
    ...options,
  });

/**
 * Stream background agent update job status (SSE)
 */
export const streamAgentUpdateJob = <ThrowOnError extends boolean = false>(
  options: Options<StreamAgentUpdateJobData, ThrowOnError>,
): RequestResult<
  StreamAgentUpdateJobResponses,
  StreamAgentUpdateJobErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    StreamAgentUpdateJobResponses,
    StreamAgentUpdateJobErrors,
    ThrowOnError
  >({
    responseType: "json",
    url: "/api/agents/update-jobs/{job_id}/events",
    ...options,
  });

/**
 * Retry a failed agent update job
 *
 * Re-enqueue a failed_terminal agent update job so it is re-processed by the worker.
 */
export const retryAgentUpdateJob = <ThrowOnError extends boolean = false>(
  options: Options<RetryAgentUpdateJobData, ThrowOnError>,
): RequestResult<
  RetryAgentUpdateJobResponses,
  RetryAgentUpdateJobErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    RetryAgentUpdateJobResponses,
    RetryAgentUpdateJobErrors,
    ThrowOnError
  >({
    responseType: "json",
    url: "/api/agents/update-jobs/{job_id}/retry",
    ...options,
  });

/**
 * Get agent LLM info
 *
 * Returns router model, default generator model, and tier choices the router can pick for this agent.
 */
export const getAgentLlmInfo = <ThrowOnError extends boolean = false>(
  options: Options<GetAgentLlmInfoData, ThrowOnError>,
): RequestResult<
  GetAgentLlmInfoResponses,
  GetAgentLlmInfoErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetAgentLlmInfoResponses,
    GetAgentLlmInfoErrors,
    ThrowOnError
  >({
    responseType: "json",
    url: "/api/agents/{agent_id}/llm-info",
    ...options,
  });

/**
 * Get agent system prompt
 *
 * Returns the effective system prompt for this agent (as used in chat). Admin-only.
 */
export const getAgentSystemPrompt = <ThrowOnError extends boolean = false>(
  options: Options<GetAgentSystemPromptData, ThrowOnError>,
): RequestResult<
  GetAgentSystemPromptResponses,
  GetAgentSystemPromptErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetAgentSystemPromptResponses,
    GetAgentSystemPromptErrors,
    ThrowOnError
  >({
    responseType: "json",
    url: "/api/agents/{agent_id}/system-prompt",
    ...options,
  });

/**
 * Regenerate agent prompt
 *
 * Regenerate the agent's system prompt using LLM optimization. Admin-only. When queue is configured, returns 202 with job_id. Otherwise runs synchronously.
 */
export const regenerateAgentPrompt = <ThrowOnError extends boolean = false>(
  options: Options<RegenerateAgentPromptData, ThrowOnError>,
): RequestResult<
  RegenerateAgentPromptResponses,
  RegenerateAgentPromptErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    RegenerateAgentPromptResponses,
    RegenerateAgentPromptErrors,
    ThrowOnError
  >({
    responseType: "json",
    url: "/api/agents/{agent_id}/regenerate-prompt",
    ...options,
  });

/**
 * Dry-run agent behavior checks
 *
 * Run non-persistent sandbox checks for guardrails, delegation policy, and shared-memory write preview.
 */
export const runAgentTestSandbox = <ThrowOnError extends boolean = false>(
  options: Options<RunAgentTestSandboxData, ThrowOnError>,
): RequestResult<
  RunAgentTestSandboxResponses,
  RunAgentTestSandboxErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    RunAgentTestSandboxResponses,
    RunAgentTestSandboxErrors,
    ThrowOnError
  >({
    responseType: "json",
    url: "/api/agents/{agent_id}/test-sandbox",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Acknowledge a leak-risk advisory finding
 *
 * Marks the agent's outstanding high-severity leak-risk advisory (Phase 2.5) as acknowledged. This is a soft, advisory action -- it does not change any runtime enforcement, which is handled entirely by the read-side scope filter regardless of acknowledgment. Idempotent: acknowledging an already-acknowledged (or since-cleared) finding returns its current state rather than erroring.
 */
export const acknowledgeAgentLeakRiskReview = <
  ThrowOnError extends boolean = false,
>(
  options: Options<AcknowledgeAgentLeakRiskReviewData, ThrowOnError>,
): RequestResult<
  AcknowledgeAgentLeakRiskReviewResponses,
  AcknowledgeAgentLeakRiskReviewErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    AcknowledgeAgentLeakRiskReviewResponses,
    AcknowledgeAgentLeakRiskReviewErrors,
    ThrowOnError
  >({
    responseType: "json",
    url: "/api/agents/{agent_id}/leak-risk-review/acknowledge",
    ...options,
  });

/**
 * Get model migration entries for current user
 *
 * Return per-agent migration entries from a sync log, filtered to the calling user's agents.
 */
export const getUserModelMigration = <ThrowOnError extends boolean = false>(
  options: Options<GetUserModelMigrationData, ThrowOnError>,
): RequestResult<
  GetUserModelMigrationResponses,
  GetUserModelMigrationErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetUserModelMigrationResponses,
    GetUserModelMigrationErrors,
    ThrowOnError
  >({
    responseType: "json",
    url: "/api/model-migration/{sync_log_id}",
    ...options,
  });

/**
 * Manually trigger unsubscribe scan
 */
export const triggerUnsubscribeScan = <ThrowOnError extends boolean = false>(
  options: Options<TriggerUnsubscribeScanData, ThrowOnError>,
): RequestResult<
  TriggerUnsubscribeScanResponses,
  TriggerUnsubscribeScanErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    TriggerUnsubscribeScanResponses,
    TriggerUnsubscribeScanErrors,
    ThrowOnError
  >({
    responseType: "json",
    url: "/api/agents/{agent_id}/unsubscribe/trigger",
    ...options,
  });

/**
 * Preview unsubscribe candidates without executing
 */
export const previewUnsubscribeCandidates = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PreviewUnsubscribeCandidatesData, ThrowOnError>,
): RequestResult<
  PreviewUnsubscribeCandidatesResponses,
  PreviewUnsubscribeCandidatesErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    PreviewUnsubscribeCandidatesResponses,
    PreviewUnsubscribeCandidatesErrors,
    ThrowOnError
  >({
    responseType: "json",
    url: "/api/agents/{agent_id}/unsubscribe/preview",
    ...options,
  });

/**
 * Execute unsubscribe for selected preview candidates
 */
export const executeUnsubscribeSelection = <
  ThrowOnError extends boolean = false,
>(
  options: Options<ExecuteUnsubscribeSelectionData, ThrowOnError>,
): RequestResult<
  ExecuteUnsubscribeSelectionResponses,
  ExecuteUnsubscribeSelectionErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    ExecuteUnsubscribeSelectionResponses,
    ExecuteUnsubscribeSelectionErrors,
    ThrowOnError
  >({
    responseType: "json",
    url: "/api/agents/{agent_id}/unsubscribe/execute",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Load interactive approval session payload for in-chat table UI
 */
export const getInteractiveApprovalSession = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetInteractiveApprovalSessionData, ThrowOnError>,
): RequestResult<
  GetInteractiveApprovalSessionResponses,
  GetInteractiveApprovalSessionErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetInteractiveApprovalSessionResponses,
    GetInteractiveApprovalSessionErrors,
    ThrowOnError
  >({
    responseType: "json",
    url: "/api/agents/{agent_id}/interactive-approval/sessions/{session_id}",
    ...options,
  });

/**
 * Mark interactive approval session as user-engaged (cancels email fallback)
 */
export const claimInteractiveApprovalSession = <
  ThrowOnError extends boolean = false,
>(
  options: Options<ClaimInteractiveApprovalSessionData, ThrowOnError>,
): RequestResult<
  ClaimInteractiveApprovalSessionResponses,
  ClaimInteractiveApprovalSessionErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    ClaimInteractiveApprovalSessionResponses,
    ClaimInteractiveApprovalSessionErrors,
    ThrowOnError
  >({
    responseType: "json",
    url: "/api/agents/{agent_id}/interactive-approval/sessions/{session_id}/claim",
    ...options,
  });

/**
 * Trigger auto-run now
 *
 * Run the agent's auto-run once immediately (agent must have auto_run_enabled and auto_run_prompt).
 */
export const triggerAgentAutoRun = <ThrowOnError extends boolean = false>(
  options: Options<TriggerAgentAutoRunData, ThrowOnError>,
): RequestResult<
  TriggerAgentAutoRunResponses,
  TriggerAgentAutoRunErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    TriggerAgentAutoRunResponses,
    TriggerAgentAutoRunErrors,
    ThrowOnError
  >({
    responseType: "json",
    url: "/api/agents/{agent_id}/trigger-auto-run",
    ...options,
  });

/**
 * List sub-agent relationships
 */
export const listAgentSubAgents = <ThrowOnError extends boolean = false>(
  options: Options<ListAgentSubAgentsData, ThrowOnError>,
): RequestResult<
  ListAgentSubAgentsResponses,
  ListAgentSubAgentsErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    ListAgentSubAgentsResponses,
    ListAgentSubAgentsErrors,
    ThrowOnError
  >({
    responseTransformer: listAgentSubAgentsResponseTransformer,
    responseType: "json",
    url: "/api/agents/{agent_id}/sub-agents",
    ...options,
  });

/**
 * Remove sub-agent relationship
 */
export const deleteAgentSubAgentRelationship = <
  ThrowOnError extends boolean = false,
>(
  options: Options<DeleteAgentSubAgentRelationshipData, ThrowOnError>,
): RequestResult<
  DeleteAgentSubAgentRelationshipResponses,
  DeleteAgentSubAgentRelationshipErrors,
  ThrowOnError
> =>
  (options.client ?? client).delete<
    DeleteAgentSubAgentRelationshipResponses,
    DeleteAgentSubAgentRelationshipErrors,
    ThrowOnError
  >({
    responseType: "json",
    url: "/api/agents/{agent_id}/sub-agents/{child_agent_id}",
    ...options,
  });

/**
 * Create sub-agent relationship
 */
export const createAgentSubAgentRelationship = <
  ThrowOnError extends boolean = false,
>(
  options: Options<CreateAgentSubAgentRelationshipData, ThrowOnError>,
): RequestResult<
  CreateAgentSubAgentRelationshipResponses,
  CreateAgentSubAgentRelationshipErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    CreateAgentSubAgentRelationshipResponses,
    CreateAgentSubAgentRelationshipErrors,
    ThrowOnError
  >({
    responseType: "json",
    url: "/api/agents/{agent_id}/sub-agents/{child_agent_id}",
    ...options,
  });

/**
 * Keep a temporary sub-agent
 *
 * Promote a temporary (runtime-spawned) sub-agent into a permanent linked child of this agent: it is no longer removed with its conversation or run. Idempotent. 409 `sub_agent_not_temporary` when the child was never temporary, 409 `kept_sub_agent_cap_reached` at the per-parent limit.
 */
export const keepAgentSubAgent = <ThrowOnError extends boolean = false>(
  options: Options<KeepAgentSubAgentData, ThrowOnError>,
): RequestResult<
  KeepAgentSubAgentResponses,
  KeepAgentSubAgentErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    KeepAgentSubAgentResponses,
    KeepAgentSubAgentErrors,
    ThrowOnError
  >({
    responseType: "json",
    url: "/api/agents/{agent_id}/sub-agents/{child_agent_id}/keep",
    ...options,
  });

/**
 * Abandon pending integration setup
 *
 * End the pending session. If the session used deferred apply (changes not yet on the agent row), the agent is left unchanged. Otherwise the agent is restored from the snapshot taken before the patch that required new integrations.
 */
export const abandonPendingIntegrationSetup = <
  ThrowOnError extends boolean = false,
>(
  options: Options<AbandonPendingIntegrationSetupData, ThrowOnError>,
): RequestResult<
  AbandonPendingIntegrationSetupResponses,
  AbandonPendingIntegrationSetupErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    AbandonPendingIntegrationSetupResponses,
    AbandonPendingIntegrationSetupErrors,
    ThrowOnError
  >({
    responseTransformer: abandonPendingIntegrationSetupResponseTransformer,
    responseType: "json",
    url: "/api/agents/{agent_id}/pending-integration-setup/abandon",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * List long memories for an agent
 */
export const listAgentMemories = <ThrowOnError extends boolean = false>(
  options: Options<ListAgentMemoriesData, ThrowOnError>,
): RequestResult<
  ListAgentMemoriesResponses,
  ListAgentMemoriesErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    ListAgentMemoriesResponses,
    ListAgentMemoriesErrors,
    ThrowOnError
  >({
    responseType: "json",
    url: "/api/agents/{agent_id}/memories",
    ...options,
  });

/**
 * Add a memory entry
 */
export const addAgentMemory = <ThrowOnError extends boolean = false>(
  options: Options<AddAgentMemoryData, ThrowOnError>,
): RequestResult<AddAgentMemoryResponses, AddAgentMemoryErrors, ThrowOnError> =>
  (options.client ?? client).post<
    AddAgentMemoryResponses,
    AddAgentMemoryErrors,
    ThrowOnError
  >({
    responseType: "json",
    url: "/api/agents/{agent_id}/memories",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Delete a memory entry
 */
export const deleteAgentMemory = <ThrowOnError extends boolean = false>(
  options: Options<DeleteAgentMemoryData, ThrowOnError>,
): RequestResult<
  DeleteAgentMemoryResponses,
  DeleteAgentMemoryErrors,
  ThrowOnError
> =>
  (options.client ?? client).delete<
    DeleteAgentMemoryResponses,
    DeleteAgentMemoryErrors,
    ThrowOnError
  >({
    responseType: "json",
    url: "/api/agents/{agent_id}/memories/{memory_id}",
    ...options,
  });

/**
 * AI-powered memory organization
 */
export const organizeAgentMemories = <ThrowOnError extends boolean = false>(
  options: Options<OrganizeAgentMemoriesData, ThrowOnError>,
): RequestResult<
  OrganizeAgentMemoriesResponses,
  OrganizeAgentMemoriesErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    OrganizeAgentMemoriesResponses,
    OrganizeAgentMemoriesErrors,
    ThrowOnError
  >({
    responseType: "json",
    url: "/api/agents/{agent_id}/memories/organize",
    ...options,
  });

/**
 * Apply AI-organized memories (replace all)
 */
export const applyOrganizedAgentMemories = <
  ThrowOnError extends boolean = false,
>(
  options: Options<ApplyOrganizedAgentMemoriesData, ThrowOnError>,
): RequestResult<
  ApplyOrganizedAgentMemoriesResponses,
  ApplyOrganizedAgentMemoriesErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    ApplyOrganizedAgentMemoriesResponses,
    ApplyOrganizedAgentMemoriesErrors,
    ThrowOnError
  >({
    responseType: "json",
    url: "/api/agents/{agent_id}/memories/apply-organized",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Dismiss an open loop
 */
export const dismissAgentOpenLoop = <ThrowOnError extends boolean = false>(
  options: Options<DismissAgentOpenLoopData, ThrowOnError>,
): RequestResult<
  DismissAgentOpenLoopResponses,
  DismissAgentOpenLoopErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    DismissAgentOpenLoopResponses,
    DismissAgentOpenLoopErrors,
    ThrowOnError
  >({
    responseType: "json",
    url: "/api/agents/{agent_id}/open-loops/{loop_id}/dismiss",
    ...options,
  });

/**
 * List conversations
 *
 * List conversations for the current user, optionally filtered by agent_id. Newest first.
 */
export const listConversations = <ThrowOnError extends boolean = false>(
  options?: Options<ListConversationsData, ThrowOnError>,
): RequestResult<
  ListConversationsResponses,
  ListConversationsErrors,
  ThrowOnError
> =>
  (options?.client ?? client).get<
    ListConversationsResponses,
    ListConversationsErrors,
    ThrowOnError
  >({
    responseTransformer: listConversationsResponseTransformer,
    responseType: "json",
    url: "/api/conversations",
    ...options,
  });

/**
 * Create conversation
 *
 * Create a new conversation for an agent.
 */
export const createConversation = <ThrowOnError extends boolean = false>(
  options: Options<CreateConversationData, ThrowOnError>,
): RequestResult<
  CreateConversationResponses,
  CreateConversationErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    CreateConversationResponses,
    CreateConversationErrors,
    ThrowOnError
  >({
    responseTransformer: createConversationResponseTransformer,
    responseType: "json",
    url: "/api/conversations",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Get last used conversation
 *
 * Return the most recently active conversation for the current user.
 */
export const getLastUsedConversation = <ThrowOnError extends boolean = false>(
  options?: Options<GetLastUsedConversationData, ThrowOnError>,
): RequestResult<
  GetLastUsedConversationResponses,
  GetLastUsedConversationErrors,
  ThrowOnError
> =>
  (options?.client ?? client).get<
    GetLastUsedConversationResponses,
    GetLastUsedConversationErrors,
    ThrowOnError
  >({
    responseTransformer: getLastUsedConversationResponseTransformer,
    responseType: "json",
    url: "/api/conversations/last-used",
    ...options,
  });

/**
 * Delete conversation
 *
 * Soft delete: the conversation is hidden and its messages are kept.
 */
export const deleteConversation = <ThrowOnError extends boolean = false>(
  options: Options<DeleteConversationData, ThrowOnError>,
): RequestResult<
  DeleteConversationResponses,
  DeleteConversationErrors,
  ThrowOnError
> =>
  (options.client ?? client).delete<
    DeleteConversationResponses,
    DeleteConversationErrors,
    ThrowOnError
  >({ url: "/api/conversations/{conversation_id}", ...options });

/**
 * Get conversation
 *
 * Get a conversation with all messages.
 */
export const getConversation = <ThrowOnError extends boolean = false>(
  options: Options<GetConversationData, ThrowOnError>,
): RequestResult<
  GetConversationResponses,
  GetConversationErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetConversationResponses,
    GetConversationErrors,
    ThrowOnError
  >({
    responseTransformer: getConversationResponseTransformer,
    responseType: "json",
    url: "/api/conversations/{conversation_id}",
    ...options,
  });

/**
 * Update conversation
 *
 * Update conversation title.
 */
export const updateConversation = <ThrowOnError extends boolean = false>(
  options: Options<UpdateConversationData, ThrowOnError>,
): RequestResult<
  UpdateConversationResponses,
  UpdateConversationErrors,
  ThrowOnError
> =>
  (options.client ?? client).patch<
    UpdateConversationResponses,
    UpdateConversationErrors,
    ThrowOnError
  >({
    responseTransformer: updateConversationResponseTransformer,
    responseType: "json",
    url: "/api/conversations/{conversation_id}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Get conversation context usage
 *
 * Token usage and USD cost of the conversation's most recent real assistant turn.
 */
export const getConversationContextUsage = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetConversationContextUsageData, ThrowOnError>,
): RequestResult<
  GetConversationContextUsageResponses,
  GetConversationContextUsageErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetConversationContextUsageResponses,
    GetConversationContextUsageErrors,
    ThrowOnError
  >({
    responseType: "json",
    url: "/api/conversations/{conversation_id}/context-usage",
    ...options,
  });

/**
 * Save conversation draft
 *
 * Store the unsent composer text for a conversation. Blank text clears it.
 */
export const updateConversationDraft = <ThrowOnError extends boolean = false>(
  options: Options<UpdateConversationDraftData, ThrowOnError>,
): RequestResult<
  UpdateConversationDraftResponses,
  UpdateConversationDraftErrors,
  ThrowOnError
> =>
  (options.client ?? client).put<
    UpdateConversationDraftResponses,
    UpdateConversationDraftErrors,
    ThrowOnError
  >({
    url: "/api/conversations/{conversation_id}/draft",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Append messages
 *
 * Append one or more messages to a conversation.
 */
export const appendConversationMessages = <
  ThrowOnError extends boolean = false,
>(
  options: Options<AppendConversationMessagesData, ThrowOnError>,
): RequestResult<
  AppendConversationMessagesResponses,
  AppendConversationMessagesErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    AppendConversationMessagesResponses,
    AppendConversationMessagesErrors,
    ThrowOnError
  >({
    responseType: "json",
    url: "/api/conversations/{conversation_id}/messages",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Update message
 *
 * Update a message (e.g. content after stream).
 */
export const updateConversationMessage = <ThrowOnError extends boolean = false>(
  options: Options<UpdateConversationMessageData, ThrowOnError>,
): RequestResult<
  UpdateConversationMessageResponses,
  UpdateConversationMessageErrors,
  ThrowOnError
> =>
  (options.client ?? client).patch<
    UpdateConversationMessageResponses,
    UpdateConversationMessageErrors,
    ThrowOnError
  >({
    responseType: "json",
    url: "/api/conversations/{conversation_id}/messages/{message_id}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Manually trigger compaction
 *
 * Owner-initiated compaction (§C10). Summarises the conversation history up to the current message and stores the resulting marker. Returns 409 if compaction cannot proceed (backoff, lock held, or nothing to compact). Rate-limited to 5/minute.
 */
export const compactConversation = <ThrowOnError extends boolean = false>(
  options: Options<CompactConversationData, ThrowOnError>,
): RequestResult<
  CompactConversationResponses,
  CompactConversationErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    CompactConversationResponses,
    CompactConversationErrors,
    ThrowOnError
  >({
    responseType: "json",
    url: "/api/conversations/{conversation_id}/compact",
    ...options,
  });

/**
 * Get the chat run in progress in a conversation
 *
 * The run a reader can rejoin after leaving the chat mid-answer, or run_id null when nothing is running. Read its lines with /generate_stream/{run_id}/lines.
 */
export const getConversationActiveRun = <ThrowOnError extends boolean = false>(
  options: Options<GetConversationActiveRunData, ThrowOnError>,
): RequestResult<
  GetConversationActiveRunResponses,
  GetConversationActiveRunErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetConversationActiveRunResponses,
    GetConversationActiveRunErrors,
    ThrowOnError
  >({
    responseType: "json",
    url: "/api/conversations/{conversation_id}/active-run",
    ...options,
  });

/**
 * Get email tier policy
 *
 * Returns which email tiers each provider can actually classify a message into, plus the action-mode strictness ordering. Use this on the frontend to offer only tier rules a connected provider can reach, and to explain that an agent rule may only tighten the connection's value, never loosen it.
 */
export const getEmailTierPolicy = <ThrowOnError extends boolean = false>(
  options?: Options<GetEmailTierPolicyData, ThrowOnError>,
): RequestResult<
  GetEmailTierPolicyResponses,
  GetEmailTierPolicyErrors,
  ThrowOnError
> =>
  (options?.client ?? client).get<
    GetEmailTierPolicyResponses,
    GetEmailTierPolicyErrors,
    ThrowOnError
  >({
    responseType: "json",
    url: "/api/connections/email-tier-policy",
    ...options,
  });

/**
 * Get isolation policy
 *
 * Returns the set of protected connection keys and restricted LLM provider keys as defined in provider_isolation.py. Use this on the frontend to dynamically filter or disable connections based on the current provider selection.
 */
export const getIsolationPolicy = <ThrowOnError extends boolean = false>(
  options?: Options<GetIsolationPolicyData, ThrowOnError>,
): RequestResult<
  GetIsolationPolicyResponses,
  GetIsolationPolicyErrors,
  ThrowOnError
> =>
  (options?.client ?? client).get<
    GetIsolationPolicyResponses,
    GetIsolationPolicyErrors,
    ThrowOnError
  >({
    responseType: "json",
    url: "/api/connections/isolation-policy",
    ...options,
  });

/**
 * Check connection policy
 *
 * Returns whether the given connection type is allowed for the current agent/user. Google connections (gmail, calendar) are blocked when the agent uses a restricted LLM provider (currently DeepSeek). Call this before opening the OAuth consent flow.
 */
export const checkConnectionPolicy = <ThrowOnError extends boolean = false>(
  options: Options<CheckConnectionPolicyData, ThrowOnError>,
): RequestResult<
  CheckConnectionPolicyResponses,
  CheckConnectionPolicyErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    CheckConnectionPolicyResponses,
    CheckConnectionPolicyErrors,
    ThrowOnError
  >({
    responseType: "json",
    url: "/api/connections/policy-check",
    ...options,
  });

/**
 * Search connectable accounts
 *
 * Accounts the current user could connect, independent of any agent: native providers that are available plus Extension toolkits an admin enabled. Used to pick extra accounts before an agent exists. Every word of `q` must appear in the name, key or description.
 */
export const listConnectionCatalog = <ThrowOnError extends boolean = false>(
  options?: Options<ListConnectionCatalogData, ThrowOnError>,
): RequestResult<
  ListConnectionCatalogResponses,
  ListConnectionCatalogErrors,
  ThrowOnError
> =>
  (options?.client ?? client).get<
    ListConnectionCatalogResponses,
    ListConnectionCatalogErrors,
    ThrowOnError
  >({
    responseType: "json",
    url: "/api/connections/catalog",
    ...options,
  });

/**
 * List connections
 *
 * List supported connection types with connected status and auth type for the given agent (agent must belong to current user).
 */
export const listConnections = <ThrowOnError extends boolean = false>(
  options: Options<ListConnectionsData, ThrowOnError>,
): RequestResult<
  ListConnectionsResponses,
  ListConnectionsErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    ListConnectionsResponses,
    ListConnectionsErrors,
    ThrowOnError
  >({
    responseType: "json",
    url: "/api/connections",
    ...options,
  });

/**
 * List all connections (settings)
 *
 * List all connection instances for the current user with agent info (for settings overview).
 */
export const listAllConnections = <ThrowOnError extends boolean = false>(
  options?: Options<ListAllConnectionsData, ThrowOnError>,
): RequestResult<
  ListAllConnectionsResponses,
  ListAllConnectionsErrors,
  ThrowOnError
> =>
  (options?.client ?? client).get<
    ListAllConnectionsResponses,
    ListAllConnectionsErrors,
    ThrowOnError
  >({
    responseType: "json",
    url: "/api/connections/all",
    ...options,
  });

/**
 * Store pre-connection settings
 *
 * Validate and persist draft connection settings in Redis before OAuth or credential connect.
 */
export const storePreConnectionSettings = <
  ThrowOnError extends boolean = false,
>(
  options: Options<StorePreConnectionSettingsData2, ThrowOnError>,
): RequestResult<
  StorePreConnectionSettingsResponses,
  StorePreConnectionSettingsErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    StorePreConnectionSettingsResponses,
    StorePreConnectionSettingsErrors,
    ThrowOnError
  >({
    responseType: "json",
    url: "/api/connections/pre-connection-settings",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Apply pre-connection settings
 *
 * Merge stored pre-connection settings onto an existing user connection.
 */
export const applyPreConnectionSettings = <
  ThrowOnError extends boolean = false,
>(
  options: Options<ApplyPreConnectionSettingsData2, ThrowOnError>,
): RequestResult<
  ApplyPreConnectionSettingsResponses,
  ApplyPreConnectionSettingsErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    ApplyPreConnectionSettingsResponses,
    ApplyPreConnectionSettingsErrors,
    ThrowOnError
  >({
    responseType: "json",
    url: "/api/connections/pre-connection-settings/apply",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * List a provider's real tools
 *
 * Full per-tool list for a connection type -- native curated tools or a Extension-activated toolkit's real registered tools.
 */
export const listConnectionProviderTools = <
  ThrowOnError extends boolean = false,
>(
  options: Options<ListConnectionProviderToolsData, ThrowOnError>,
): RequestResult<
  ListConnectionProviderToolsResponses,
  ListConnectionProviderToolsErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    ListConnectionProviderToolsResponses,
    ListConnectionProviderToolsErrors,
    ThrowOnError
  >({
    responseType: "json",
    url: "/api/connections/{provider_key}/tools",
    ...options,
  });

/**
 * List ICS Feed URLs
 *
 * List stored ICS feed URLs for the given agent (for ICS Feed connection page).
 */
export const listIcsFeedUrls = <ThrowOnError extends boolean = false>(
  options?: Options<ListIcsFeedUrlsData, ThrowOnError>,
): RequestResult<
  ListIcsFeedUrlsResponses,
  ListIcsFeedUrlsErrors,
  ThrowOnError
> =>
  (options?.client ?? client).get<
    ListIcsFeedUrlsResponses,
    ListIcsFeedUrlsErrors,
    ThrowOnError
  >({
    responseType: "json",
    url: "/api/connections/ics-feed/urls",
    ...options,
  });

/**
 * Get connection settings
 *
 * Return settings for a user connection (owned by current user).
 */
export const getConnectionSettings = <ThrowOnError extends boolean = false>(
  options: Options<GetConnectionSettingsData, ThrowOnError>,
): RequestResult<
  GetConnectionSettingsResponses,
  GetConnectionSettingsErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetConnectionSettingsResponses,
    GetConnectionSettingsErrors,
    ThrowOnError
  >({
    responseType: "json",
    url: "/api/connections/{user_connection_id}/settings",
    ...options,
  });

/**
 * Update connection settings
 *
 * Update settings for a user connection. Validates schema per provider.
 */
export const updateConnectionSettings = <ThrowOnError extends boolean = false>(
  options: Options<UpdateConnectionSettingsData, ThrowOnError>,
): RequestResult<
  UpdateConnectionSettingsResponses,
  UpdateConnectionSettingsErrors,
  ThrowOnError
> =>
  (options.client ?? client).patch<
    UpdateConnectionSettingsResponses,
    UpdateConnectionSettingsErrors,
    ThrowOnError
  >({
    responseType: "json",
    url: "/api/connections/{user_connection_id}/settings",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Get connection handoff policy
 *
 * Return whether this agent/provider lifecycle event should redirect to edit-chat.
 */
export const getConnectionHandoffPolicy = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetConnectionHandoffPolicyData, ThrowOnError>,
): RequestResult<
  GetConnectionHandoffPolicyResponses,
  GetConnectionHandoffPolicyErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetConnectionHandoffPolicyResponses,
    GetConnectionHandoffPolicyErrors,
    ThrowOnError
  >({
    responseType: "json",
    url: "/api/connections/handoff/policy",
    ...options,
  });

/**
 * Consume connection handoff policy
 *
 * Mark a connection lifecycle state as consumed so redirect happens once per state hash.
 */
export const consumeConnectionHandoffPolicy = <
  ThrowOnError extends boolean = false,
>(
  options: Options<ConsumeConnectionHandoffPolicyData, ThrowOnError>,
): RequestResult<
  ConsumeConnectionHandoffPolicyResponses,
  ConsumeConnectionHandoffPolicyErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    ConsumeConnectionHandoffPolicyResponses,
    ConsumeConnectionHandoffPolicyErrors,
    ThrowOnError
  >({
    responseType: "json",
    url: "/api/connections/handoff/consume",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Connect CalDAV Calendar
 *
 * Store CalDAV credentials for CalDAV Calendar.
 */
export const connectCalDav = <ThrowOnError extends boolean = false>(
  options: Options<ConnectCalDavData, ThrowOnError>,
): RequestResult<ConnectCalDavResponses, ConnectCalDavErrors, ThrowOnError> =>
  (options.client ?? client).post<
    ConnectCalDavResponses,
    ConnectCalDavErrors,
    ThrowOnError
  >({
    responseType: "json",
    url: "/api/connections/credentials/caldav",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Connect Twilio WhatsApp
 *
 * Store Twilio credentials and WhatsApp number for incoming messages.
 */
export const connectTwilioWhatsApp = <ThrowOnError extends boolean = false>(
  options: Options<ConnectTwilioWhatsAppData, ThrowOnError>,
): RequestResult<
  ConnectTwilioWhatsAppResponses,
  ConnectTwilioWhatsAppErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    ConnectTwilioWhatsAppResponses,
    ConnectTwilioWhatsAppErrors,
    ThrowOnError
  >({
    responseType: "json",
    url: "/api/connections/credentials/twilio-whatsapp",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Test Twilio WhatsApp credentials
 *
 * Validate Twilio Account SID and Auth Token without storing a connection.
 */
export const testTwilioWhatsAppCredentials = <
  ThrowOnError extends boolean = false,
>(
  options: Options<TestTwilioWhatsAppCredentialsData, ThrowOnError>,
): RequestResult<
  TestTwilioWhatsAppCredentialsResponses,
  TestTwilioWhatsAppCredentialsErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    TestTwilioWhatsAppCredentialsResponses,
    TestTwilioWhatsAppCredentialsErrors,
    ThrowOnError
  >({
    responseType: "json",
    url: "/api/connections/credentials/twilio-whatsapp/test",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Connect Mattermost
 *
 * Store Mattermost outgoing webhook token. Set the webhook callback URL to the returned requestUrl.
 */
export const connectMattermost = <ThrowOnError extends boolean = false>(
  options: Options<ConnectMattermostData, ThrowOnError>,
): RequestResult<
  ConnectMattermostResponses,
  ConnectMattermostErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    ConnectMattermostResponses,
    ConnectMattermostErrors,
    ThrowOnError
  >({
    responseType: "json",
    url: "/api/connections/credentials/mattermost",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Connect Google Chat
 *
 * Store Google Chat service account JSON. Set the Chat app HTTP endpoint URL to the returned requestUrl.
 */
export const connectGoogleChat = <ThrowOnError extends boolean = false>(
  options: Options<ConnectGoogleChatData, ThrowOnError>,
): RequestResult<
  ConnectGoogleChatResponses,
  ConnectGoogleChatErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    ConnectGoogleChatResponses,
    ConnectGoogleChatErrors,
    ThrowOnError
  >({
    responseType: "json",
    url: "/api/connections/credentials/google-chat",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Connect Telegram
 *
 * Store Telegram bot token + webhook secret. Set Telegram bot webhook URL to returned requestUrl.
 */
export const connectTelegram = <ThrowOnError extends boolean = false>(
  options: Options<ConnectTelegramData, ThrowOnError>,
): RequestResult<
  ConnectTelegramResponses,
  ConnectTelegramErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    ConnectTelegramResponses,
    ConnectTelegramErrors,
    ThrowOnError
  >({
    responseType: "json",
    url: "/api/connections/credentials/telegram",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Create shared Telegram bot link code
 *
 * Generate one-time code to link a Telegram DM user to this agent via the platform-managed shared bot.
 */
export const createTelegramSharedLinkCode = <
  ThrowOnError extends boolean = false,
>(
  options: Options<CreateTelegramSharedLinkCodeData, ThrowOnError>,
): RequestResult<
  CreateTelegramSharedLinkCodeResponses,
  CreateTelegramSharedLinkCodeErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    CreateTelegramSharedLinkCodeResponses,
    CreateTelegramSharedLinkCodeErrors,
    ThrowOnError
  >({
    responseType: "json",
    url: "/api/connections/credentials/telegram/shared/link-code",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Get shared Telegram bot link status
 *
 * Return whether the current user has an active shared Telegram binding for the specified agent.
 */
export const getTelegramSharedStatus = <ThrowOnError extends boolean = false>(
  options: Options<GetTelegramSharedStatusData, ThrowOnError>,
): RequestResult<
  GetTelegramSharedStatusResponses,
  GetTelegramSharedStatusErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetTelegramSharedStatusResponses,
    GetTelegramSharedStatusErrors,
    ThrowOnError
  >({
    responseType: "json",
    url: "/api/connections/credentials/telegram/shared/status",
    ...options,
  });

/**
 * Unlink shared Telegram bot
 *
 * Revoke shared Telegram binding for current user and agent.
 */
export const unlinkTelegramShared = <ThrowOnError extends boolean = false>(
  options: Options<UnlinkTelegramSharedData, ThrowOnError>,
): RequestResult<
  UnlinkTelegramSharedResponses,
  UnlinkTelegramSharedErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    UnlinkTelegramSharedResponses,
    UnlinkTelegramSharedErrors,
    ThrowOnError
  >({
    responseType: "json",
    url: "/api/connections/credentials/telegram/shared/unlink",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Add ICS Feed URL
 *
 * Add an ICS calendar feed URL. Can add many; stored per agent.
 */
export const connectIcsFeed = <ThrowOnError extends boolean = false>(
  options: Options<ConnectIcsFeedData, ThrowOnError>,
): RequestResult<ConnectIcsFeedResponses, ConnectIcsFeedErrors, ThrowOnError> =>
  (options.client ?? client).post<
    ConnectIcsFeedResponses,
    ConnectIcsFeedErrors,
    ThrowOnError
  >({
    responseType: "json",
    url: "/api/connections/credentials/ics-feed",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Remove ICS Feed URL
 *
 * Remove one URL from an ICS Feed connection.
 */
export const removeIcsFeedUrl = <ThrowOnError extends boolean = false>(
  options: Options<RemoveIcsFeedUrlData, ThrowOnError>,
): RequestResult<
  RemoveIcsFeedUrlResponses,
  RemoveIcsFeedUrlErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    RemoveIcsFeedUrlResponses,
    RemoveIcsFeedUrlErrors,
    ThrowOnError
  >({
    responseType: "json",
    url: "/api/connections/credentials/ics-feed/remove",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Connect Email (IMAP/SMTP)
 *
 * Validate and store connected mailbox IMAP/SMTP credentials for agent-scoped usage.
 */
export const connectSmtp = <ThrowOnError extends boolean = false>(
  options: Options<ConnectSmtpData, ThrowOnError>,
): RequestResult<ConnectSmtpResponses, ConnectSmtpErrors, ThrowOnError> =>
  (options.client ?? client).post<
    ConnectSmtpResponses,
    ConnectSmtpErrors,
    ThrowOnError
  >({
    responseType: "json",
    url: "/api/connections/credentials/smtp",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Probe CalDAV/CardDAV capabilities
 *
 * Best-effort probe for CalDAV/CardDAV endpoints after mail setup.
 */
export const probeSmtpDavCapabilities = <ThrowOnError extends boolean = false>(
  options: Options<ProbeSmtpDavCapabilitiesData, ThrowOnError>,
): RequestResult<
  ProbeSmtpDavCapabilitiesResponses,
  ProbeSmtpDavCapabilitiesErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    ProbeSmtpDavCapabilitiesResponses,
    ProbeSmtpDavCapabilitiesErrors,
    ThrowOnError
  >({
    responseType: "json",
    url: "/api/connections/credentials/smtp/dav-probe",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * List connected mailbox folders
 *
 * List the folders this IMAP server actually reports, and which one deleted mail would go to, with how that was determined. Read-only.
 */
export const listSmtpFolders = <ThrowOnError extends boolean = false>(
  options: Options<ListSmtpFoldersData, ThrowOnError>,
): RequestResult<
  ListSmtpFoldersResponses,
  ListSmtpFoldersErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    ListSmtpFoldersResponses,
    ListSmtpFoldersErrors,
    ThrowOnError
  >({
    responseType: "json",
    url: "/api/connections/credentials/smtp/folders",
    ...options,
  });

/**
 * WhatsApp Cloud Embedded Signup config
 *
 * Return Meta Embedded Signup IDs (appId, configId, graphVersion) for the browser-side JS SDK.
 */
export const whatsappCloudEmbeddedSignupConfig = <
  ThrowOnError extends boolean = false,
>(
  options: Options<WhatsappCloudEmbeddedSignupConfigData, ThrowOnError>,
): RequestResult<
  WhatsappCloudEmbeddedSignupConfigResponses,
  WhatsappCloudEmbeddedSignupConfigErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    WhatsappCloudEmbeddedSignupConfigResponses,
    WhatsappCloudEmbeddedSignupConfigErrors,
    ThrowOnError
  >({
    responseType: "json",
    url: "/api/connections/whatsapp-cloud/embedded-signup/config",
    ...options,
  });

/**
 * WhatsApp Cloud Embedded Signup completion
 *
 * Server-side completion: exchange exchangeableCode for a business token, subscribe WABA to webhooks, register phone number, then store credentials for the provided agent.
 */
export const whatsappCloudEmbeddedSignupComplete = <
  ThrowOnError extends boolean = false,
>(
  options: Options<WhatsappCloudEmbeddedSignupCompleteData, ThrowOnError>,
): RequestResult<
  WhatsappCloudEmbeddedSignupCompleteResponses,
  WhatsappCloudEmbeddedSignupCompleteErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    WhatsappCloudEmbeddedSignupCompleteResponses,
    WhatsappCloudEmbeddedSignupCompleteErrors,
    ThrowOnError
  >({
    responseType: "json",
    url: "/api/connections/whatsapp-cloud/embedded-signup/complete",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Disconnect
 *
 * Remove current user's connection.
 */
export const disconnectUserConnection = <ThrowOnError extends boolean = false>(
  options: Options<DisconnectUserConnectionData, ThrowOnError>,
): RequestResult<
  DisconnectUserConnectionResponses,
  DisconnectUserConnectionErrors,
  ThrowOnError
> =>
  (options.client ?? client).delete<
    DisconnectUserConnectionResponses,
    DisconnectUserConnectionErrors,
    ThrowOnError
  >({ url: "/api/connections/user/{user_connection_id}", ...options });

/**
 * List shared links
 *
 * List shared links for a conversation.
 */
export const listSharedLinks = <ThrowOnError extends boolean = false>(
  options: Options<ListSharedLinksData, ThrowOnError>,
): RequestResult<
  ListSharedLinksResponses,
  ListSharedLinksErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    ListSharedLinksResponses,
    ListSharedLinksErrors,
    ThrowOnError
  >({
    responseTransformer: listSharedLinksResponseTransformer,
    responseType: "json",
    url: "/api/shared-links",
    ...options,
  });

/**
 * Create shared link
 *
 * Create a shareable link for a conversation (TTL and viewer limit).
 */
export const createSharedLink = <ThrowOnError extends boolean = false>(
  options: Options<CreateSharedLinkData, ThrowOnError>,
): RequestResult<
  CreateSharedLinkResponses,
  CreateSharedLinkErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    CreateSharedLinkResponses,
    CreateSharedLinkErrors,
    ThrowOnError
  >({
    responseTransformer: createSharedLinkResponseTransformer,
    responseType: "json",
    url: "/api/shared-links",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Revoke shared link
 *
 * Revoke a shared link by ID.
 */
export const revokeSharedLink = <ThrowOnError extends boolean = false>(
  options: Options<RevokeSharedLinkData, ThrowOnError>,
): RequestResult<
  RevokeSharedLinkResponses,
  RevokeSharedLinkErrors,
  ThrowOnError
> =>
  (options.client ?? client).delete<
    RevokeSharedLinkResponses,
    RevokeSharedLinkErrors,
    ThrowOnError
  >({ url: "/api/shared-links/{link_id}", ...options });

/**
 * List patterns
 *
 * List patterns for the current user. Include system defaults with include_system=true.
 */
export const listPatterns = <ThrowOnError extends boolean = false>(
  options?: Options<ListPatternsData, ThrowOnError>,
): RequestResult<ListPatternsResponses, ListPatternsErrors, ThrowOnError> =>
  (options?.client ?? client).get<
    ListPatternsResponses,
    ListPatternsErrors,
    ThrowOnError
  >({
    responseType: "json",
    url: "/api/patterns",
    ...options,
  });

/**
 * Create pattern
 *
 * Create a new user-owned pattern. Optionally copy from source_pattern_id (e.g. system default).
 */
export const createPattern = <ThrowOnError extends boolean = false>(
  options: Options<CreatePatternData, ThrowOnError>,
): RequestResult<CreatePatternResponses, CreatePatternErrors, ThrowOnError> =>
  (options.client ?? client).post<
    CreatePatternResponses,
    CreatePatternErrors,
    ThrowOnError
  >({
    responseType: "json",
    url: "/api/patterns",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * List connected agents with sync status
 *
 * Agents using this pattern with health: synced, customized, or action_required.
 */
export const listPatternConnectedAgents = <
  ThrowOnError extends boolean = false,
>(
  options: Options<ListPatternConnectedAgentsData, ThrowOnError>,
): RequestResult<
  ListPatternConnectedAgentsResponses,
  ListPatternConnectedAgentsErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    ListPatternConnectedAgentsResponses,
    ListPatternConnectedAgentsErrors,
    ThrowOnError
  >({
    responseType: "json",
    url: "/api/patterns/{pattern_id}/connected-agents",
    ...options,
  });

/**
 * Delete pattern
 *
 * Delete a user-owned pattern. Any agents using it are unlinked (pattern_id set to null), then the pattern is removed.
 */
export const deletePattern = <ThrowOnError extends boolean = false>(
  options: Options<DeletePatternData, ThrowOnError>,
): RequestResult<DeletePatternResponses, DeletePatternErrors, ThrowOnError> =>
  (options.client ?? client).delete<
    DeletePatternResponses,
    DeletePatternErrors,
    ThrowOnError
  >({ url: "/api/patterns/{pattern_id}", ...options });

/**
 * Get pattern
 *
 * Get a pattern by ID (user's or system).
 */
export const getPattern = <ThrowOnError extends boolean = false>(
  options: Options<GetPatternData, ThrowOnError>,
): RequestResult<GetPatternResponses, GetPatternErrors, ThrowOnError> =>
  (options.client ?? client).get<
    GetPatternResponses,
    GetPatternErrors,
    ThrowOnError
  >({
    responseType: "json",
    url: "/api/patterns/{pattern_id}",
    ...options,
  });

/**
 * Update pattern
 *
 * Update a user-owned pattern (name, description, icon, pre-selected connections, tool defaults). System patterns are read-only.
 */
export const updatePattern = <ThrowOnError extends boolean = false>(
  options: Options<UpdatePatternData, ThrowOnError>,
): RequestResult<UpdatePatternResponses, UpdatePatternErrors, ThrowOnError> =>
  (options.client ?? client).patch<
    UpdatePatternResponses,
    UpdatePatternErrors,
    ThrowOnError
  >({
    responseType: "json",
    url: "/api/patterns/{pattern_id}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Copy pattern
 *
 * Copy a pattern (e.g. system default) into the current user's account. Returns the new pattern.
 */
export const copyPattern = <ThrowOnError extends boolean = false>(
  options: Options<CopyPatternData, ThrowOnError>,
): RequestResult<CopyPatternResponses, CopyPatternErrors, ThrowOnError> =>
  (options.client ?? client).post<
    CopyPatternResponses,
    CopyPatternErrors,
    ThrowOnError
  >({
    responseType: "json",
    url: "/api/patterns/{pattern_id}/copy",
    ...options,
  });

/**
 * List pattern instructions
 */
export const listPatternInstructions = <ThrowOnError extends boolean = false>(
  options: Options<ListPatternInstructionsData, ThrowOnError>,
): RequestResult<
  ListPatternInstructionsResponses,
  ListPatternInstructionsErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    ListPatternInstructionsResponses,
    ListPatternInstructionsErrors,
    ThrowOnError
  >({
    responseType: "json",
    url: "/api/patterns/{pattern_id}/instructions",
    ...options,
  });

/**
 * Create pattern instruction
 */
export const createPatternInstruction = <ThrowOnError extends boolean = false>(
  options: Options<CreatePatternInstructionData, ThrowOnError>,
): RequestResult<
  CreatePatternInstructionResponses,
  CreatePatternInstructionErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    CreatePatternInstructionResponses,
    CreatePatternInstructionErrors,
    ThrowOnError
  >({
    responseType: "json",
    url: "/api/patterns/{pattern_id}/instructions",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Delete pattern instruction
 */
export const deletePatternInstruction = <ThrowOnError extends boolean = false>(
  options: Options<DeletePatternInstructionData, ThrowOnError>,
): RequestResult<
  DeletePatternInstructionResponses,
  DeletePatternInstructionErrors,
  ThrowOnError
> =>
  (options.client ?? client).delete<
    DeletePatternInstructionResponses,
    DeletePatternInstructionErrors,
    ThrowOnError
  >({
    url: "/api/patterns/{pattern_id}/instructions/{instruction_id}",
    ...options,
  });

/**
 * Update pattern instruction
 */
export const updatePatternInstruction = <ThrowOnError extends boolean = false>(
  options: Options<UpdatePatternInstructionData, ThrowOnError>,
): RequestResult<
  UpdatePatternInstructionResponses,
  UpdatePatternInstructionErrors,
  ThrowOnError
> =>
  (options.client ?? client).patch<
    UpdatePatternInstructionResponses,
    UpdatePatternInstructionErrors,
    ThrowOnError
  >({
    responseType: "json",
    url: "/api/patterns/{pattern_id}/instructions/{instruction_id}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * List pattern tools
 */
export const listPatternTools = <ThrowOnError extends boolean = false>(
  options: Options<ListPatternToolsData, ThrowOnError>,
): RequestResult<
  ListPatternToolsResponses,
  ListPatternToolsErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    ListPatternToolsResponses,
    ListPatternToolsErrors,
    ThrowOnError
  >({
    responseType: "json",
    url: "/api/patterns/{pattern_id}/tools",
    ...options,
  });

/**
 * Add tool to pattern
 */
export const addPatternTool = <ThrowOnError extends boolean = false>(
  options: Options<AddPatternToolData, ThrowOnError>,
): RequestResult<AddPatternToolResponses, AddPatternToolErrors, ThrowOnError> =>
  (options.client ?? client).post<
    AddPatternToolResponses,
    AddPatternToolErrors,
    ThrowOnError
  >({
    responseType: "json",
    url: "/api/patterns/{pattern_id}/tools",
    ...options,
  });

/**
 * Remove tool from pattern
 */
export const removePatternTool = <ThrowOnError extends boolean = false>(
  options: Options<RemovePatternToolData, ThrowOnError>,
): RequestResult<
  RemovePatternToolResponses,
  RemovePatternToolErrors,
  ThrowOnError
> =>
  (options.client ?? client).delete<
    RemovePatternToolResponses,
    RemovePatternToolErrors,
    ThrowOnError
  >({ url: "/api/patterns/{pattern_id}/tools/{tool_id}", ...options });

/**
 * List pattern guardrails
 */
export const listPatternGuardrails = <ThrowOnError extends boolean = false>(
  options: Options<ListPatternGuardrailsData, ThrowOnError>,
): RequestResult<
  ListPatternGuardrailsResponses,
  ListPatternGuardrailsErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    ListPatternGuardrailsResponses,
    ListPatternGuardrailsErrors,
    ThrowOnError
  >({
    responseType: "json",
    url: "/api/patterns/{pattern_id}/guardrails",
    ...options,
  });

/**
 * Create pattern guardrail
 */
export const createPatternGuardrail = <ThrowOnError extends boolean = false>(
  options: Options<CreatePatternGuardrailData, ThrowOnError>,
): RequestResult<
  CreatePatternGuardrailResponses,
  CreatePatternGuardrailErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    CreatePatternGuardrailResponses,
    CreatePatternGuardrailErrors,
    ThrowOnError
  >({
    responseType: "json",
    url: "/api/patterns/{pattern_id}/guardrails",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Delete pattern guardrail
 */
export const deletePatternGuardrail = <ThrowOnError extends boolean = false>(
  options: Options<DeletePatternGuardrailData, ThrowOnError>,
): RequestResult<
  DeletePatternGuardrailResponses,
  DeletePatternGuardrailErrors,
  ThrowOnError
> =>
  (options.client ?? client).delete<
    DeletePatternGuardrailResponses,
    DeletePatternGuardrailErrors,
    ThrowOnError
  >({
    url: "/api/patterns/{pattern_id}/guardrails/{guardrail_id}",
    ...options,
  });

/**
 * Update pattern guardrail
 */
export const updatePatternGuardrail = <ThrowOnError extends boolean = false>(
  options: Options<UpdatePatternGuardrailData, ThrowOnError>,
): RequestResult<
  UpdatePatternGuardrailResponses,
  UpdatePatternGuardrailErrors,
  ThrowOnError
> =>
  (options.client ?? client).patch<
    UpdatePatternGuardrailResponses,
    UpdatePatternGuardrailErrors,
    ThrowOnError
  >({
    responseType: "json",
    url: "/api/patterns/{pattern_id}/guardrails/{guardrail_id}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Ingest document for pattern knowledge
 */
export const ingestPatternDocument = <ThrowOnError extends boolean = false>(
  options: Options<IngestPatternDocumentData, ThrowOnError>,
): RequestResult<
  IngestPatternDocumentResponses,
  IngestPatternDocumentErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    IngestPatternDocumentResponses,
    IngestPatternDocumentErrors,
    ThrowOnError
  >({
    responseType: "json",
    url: "/api/patterns/{pattern_id}/documents/ingest",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Ingest URL for pattern knowledge
 */
export const ingestPatternDocumentUrl = <ThrowOnError extends boolean = false>(
  options: Options<IngestPatternDocumentUrlData, ThrowOnError>,
): RequestResult<
  IngestPatternDocumentUrlResponses,
  IngestPatternDocumentUrlErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    IngestPatternDocumentUrlResponses,
    IngestPatternDocumentUrlErrors,
    ThrowOnError
  >({
    responseType: "json",
    url: "/api/patterns/{pattern_id}/documents/ingest-url",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Remove document from pattern
 */
export const deletePatternDocument = <ThrowOnError extends boolean = false>(
  options: Options<DeletePatternDocumentData, ThrowOnError>,
): RequestResult<
  DeletePatternDocumentResponses,
  DeletePatternDocumentErrors,
  ThrowOnError
> =>
  (options.client ?? client).delete<
    DeletePatternDocumentResponses,
    DeletePatternDocumentErrors,
    ThrowOnError
  >({ url: "/api/patterns/{pattern_id}/documents/{document_id}", ...options });

/**
 * List LLM providers and models
 *
 * Returns registered LLM providers with their models (tiers) for agent provider/model selection. Only includes providers that are configured (API key set).
 */
export const listLlmProviders = <ThrowOnError extends boolean = false>(
  options?: Options<ListLlmProvidersData, ThrowOnError>,
): RequestResult<
  ListLlmProvidersResponses,
  ListLlmProvidersErrors,
  ThrowOnError
> =>
  (options?.client ?? client).get<
    ListLlmProvidersResponses,
    ListLlmProvidersErrors,
    ThrowOnError
  >({
    responseType: "json",
    url: "/api/llm-providers",
    ...options,
  });

/**
 * List tier cost boundaries
 *
 * Returns tier list (key, label, cost_max_per_million) for display on agent create/edit. No admin required.
 */
export const listLlmProviderTiers = <ThrowOnError extends boolean = false>(
  options?: Options<ListLlmProviderTiersData, ThrowOnError>,
): RequestResult<
  ListLlmProviderTiersResponses,
  ListLlmProviderTiersErrors,
  ThrowOnError
> =>
  (options?.client ?? client).get<
    ListLlmProviderTiersResponses,
    ListLlmProviderTiersErrors,
    ThrowOnError
  >({
    responseType: "json",
    url: "/api/llm-providers/tiers",
    ...options,
  });

/**
 * Update tier boundaries and re-assign models
 *
 * Update cost_max_per_million for each tier and re-assign all provider models to tiers by combined cost. Requires admin:platform_config.
 */
export const updateLlmTierBoundaries = <ThrowOnError extends boolean = false>(
  options: Options<UpdateLlmTierBoundariesData, ThrowOnError>,
): RequestResult<
  UpdateLlmTierBoundariesResponses,
  UpdateLlmTierBoundariesErrors,
  ThrowOnError
> =>
  (options.client ?? client).patch<
    UpdateLlmTierBoundariesResponses,
    UpdateLlmTierBoundariesErrors,
    ThrowOnError
  >({
    responseType: "json",
    url: "/api/llm-providers/tiers",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Admin: tiers and provider models
 *
 * Return all tiers (with cost boundaries) and provider models for the admin UI. Requires admin:platform_config.
 */
export const getLlmProvidersAdmin = <ThrowOnError extends boolean = false>(
  options?: Options<GetLlmProvidersAdminData, ThrowOnError>,
): RequestResult<
  GetLlmProvidersAdminResponses,
  GetLlmProvidersAdminErrors,
  ThrowOnError
> =>
  (options?.client ?? client).get<
    GetLlmProvidersAdminResponses,
    GetLlmProvidersAdminErrors,
    ThrowOnError
  >({
    responseType: "json",
    url: "/api/llm-providers/admin",
    ...options,
  });

/**
 * Update provider enabled state
 *
 * Turn providers on/off. Only registered provider keys are accepted. Requires admin:platform_config.
 */
export const updateLlmProviderEnabled = <ThrowOnError extends boolean = false>(
  options: Options<UpdateLlmProviderEnabledData, ThrowOnError>,
): RequestResult<
  UpdateLlmProviderEnabledResponses,
  UpdateLlmProviderEnabledErrors,
  ThrowOnError
> =>
  (options.client ?? client).patch<
    UpdateLlmProviderEnabledResponses,
    UpdateLlmProviderEnabledErrors,
    ThrowOnError
  >({
    responseType: "json",
    url: "/api/llm-providers/providers",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Update provider model enabled state
 *
 * Enable or disable individual models. Disabled models are excluded from routing. Requires admin:platform_config.
 */
export const updateLlmProviderModelEnabled = <
  ThrowOnError extends boolean = false,
>(
  options: Options<UpdateLlmProviderModelEnabledData, ThrowOnError>,
): RequestResult<
  UpdateLlmProviderModelEnabledResponses,
  UpdateLlmProviderModelEnabledErrors,
  ThrowOnError
> =>
  (options.client ?? client).patch<
    UpdateLlmProviderModelEnabledResponses,
    UpdateLlmProviderModelEnabledErrors,
    ThrowOnError
  >({
    responseType: "json",
    url: "/api/llm-providers/models",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Admin: per-pass agent-creation model config
 *
 * Return the admin-selected model for each agent-creation pass (creator, editor, guardrails) plus the effective default used when a pass is unset. Requires admin:platform_config.
 */
export const getAgentCreationModels = <ThrowOnError extends boolean = false>(
  options?: Options<GetAgentCreationModelsData, ThrowOnError>,
): RequestResult<
  GetAgentCreationModelsResponses,
  GetAgentCreationModelsErrors,
  ThrowOnError
> =>
  (options?.client ?? client).get<
    GetAgentCreationModelsResponses,
    GetAgentCreationModelsErrors,
    ThrowOnError
  >({
    responseType: "json",
    url: "/api/llm-providers/agent-creation-models",
    ...options,
  });

/**
 * Admin: set per-pass agent-creation models
 *
 * Pin a primary and/or backup model per agent-creation pass (creator, editor, guardrails). Omitted fields are left unchanged. An explicit null on a primary field clears that pass (reverts to default). An explicit null on a backup field clears only the backup. Provider is resolved server-side from the model id. Requires admin:platform_config.
 */
export const updateAgentCreationModels = <ThrowOnError extends boolean = false>(
  options: Options<UpdateAgentCreationModelsData, ThrowOnError>,
): RequestResult<
  UpdateAgentCreationModelsResponses,
  UpdateAgentCreationModelsErrors,
  ThrowOnError
> =>
  (options.client ?? client).patch<
    UpdateAgentCreationModelsResponses,
    UpdateAgentCreationModelsErrors,
    ThrowOnError
  >({
    responseType: "json",
    url: "/api/llm-providers/agent-creation-models",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Admin: generation parameters per call slot
 *
 * Return admin-set generation parameters (output cap, reasoning effort, thinking budget, temperature, top_p) for every LLM call slot, plus the effective values used when a field is unset. Requires admin:platform_config.
 */
export const getGenerationParams = <ThrowOnError extends boolean = false>(
  options?: Options<GetGenerationParamsData, ThrowOnError>,
): RequestResult<
  GetGenerationParamsResponses,
  GetGenerationParamsErrors,
  ThrowOnError
> =>
  (options?.client ?? client).get<
    GetGenerationParamsResponses,
    GetGenerationParamsErrors,
    ThrowOnError
  >({
    responseType: "json",
    url: "/api/llm-providers/generation-params",
    ...options,
  });

/**
 * Admin: set generation parameters for a call slot
 *
 * Override generation parameters for one slot. Omitted fields are left unchanged; an explicit null clears that field and reverts it to the code default. Not every provider supports every parameter -- the GET response reports the effective value. Requires admin:platform_config.
 */
export const updateGenerationParams = <ThrowOnError extends boolean = false>(
  options: Options<UpdateGenerationParamsData, ThrowOnError>,
): RequestResult<
  UpdateGenerationParamsResponses,
  UpdateGenerationParamsErrors,
  ThrowOnError
> =>
  (options.client ?? client).patch<
    UpdateGenerationParamsResponses,
    UpdateGenerationParamsErrors,
    ThrowOnError
  >({
    responseType: "json",
    url: "/api/llm-providers/generation-params",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Admin: chat router model config
 *
 * Return the admin-selected primary and backup model for the chat router, plus the effective defaults used when a field is unset. Requires admin:platform_config.
 */
export const getRouterModels = <ThrowOnError extends boolean = false>(
  options?: Options<GetRouterModelsData, ThrowOnError>,
): RequestResult<
  GetRouterModelsResponses,
  GetRouterModelsErrors,
  ThrowOnError
> =>
  (options?.client ?? client).get<
    GetRouterModelsResponses,
    GetRouterModelsErrors,
    ThrowOnError
  >({
    responseType: "json",
    url: "/api/llm-providers/router-models",
    ...options,
  });

/**
 * Admin: set chat router models
 *
 * Override the chat router primary and/or backup model. Omitted fields are left unchanged. An explicit null clears that field (reverts to the UNIVERSAL_ROUTER_* constant). The backup may be on a DIFFERENT provider than the primary — it is identified by its model and runs on whichever provider owns it, so it stays reachable when the primary's provider is what failed. It must differ from the primary. Provider is resolved server-side from the model id. Requires admin:platform_config.
 */
export const updateRouterModels = <ThrowOnError extends boolean = false>(
  options: Options<UpdateRouterModelsData, ThrowOnError>,
): RequestResult<
  UpdateRouterModelsResponses,
  UpdateRouterModelsErrors,
  ThrowOnError
> =>
  (options.client ?? client).patch<
    UpdateRouterModelsResponses,
    UpdateRouterModelsErrors,
    ThrowOnError
  >({
    responseType: "json",
    url: "/api/llm-providers/router-models",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Sync provider models
 *
 * Fetch models from each configured provider's API and upsert into DB with tier assignment. Non-chat models (embeddings, audio, image-gen, moderation) are filtered out. New chat models are added with enabled=false and require admin review.
 */
export const syncLlmProviderModels = <ThrowOnError extends boolean = false>(
  options?: Options<SyncLlmProviderModelsData, ThrowOnError>,
): RequestResult<
  SyncLlmProviderModelsResponses,
  SyncLlmProviderModelsErrors,
  ThrowOnError
> =>
  (options?.client ?? client).post<
    SyncLlmProviderModelsResponses,
    SyncLlmProviderModelsErrors,
    ThrowOnError
  >({
    responseType: "json",
    url: "/api/llm-providers/sync",
    ...options,
  });

/**
 * Disable non-chat models
 *
 * Disable any DB rows that are not chat/completion models (embeddings, audio, image-gen, moderation, legacy completion). Run once after upgrading from a pre-filter sync to clean up existing rows.
 */
export const disableNonChatModels = <ThrowOnError extends boolean = false>(
  options?: Options<DisableNonChatModelsData, ThrowOnError>,
): RequestResult<
  DisableNonChatModelsResponses,
  DisableNonChatModelsErrors,
  ThrowOnError
> =>
  (options?.client ?? client).post<
    DisableNonChatModelsResponses,
    DisableNonChatModelsErrors,
    ThrowOnError
  >({
    responseType: "json",
    url: "/api/llm-providers/disable-non-chat",
    ...options,
  });

/**
 * Re-assign tiers for all models
 *
 * Recalculate tiers for all existing models based on their current pricing. Does NOT fetch from provider APIs. Useful when tier boundaries change.
 */
export const reassignLlmModelTiers = <ThrowOnError extends boolean = false>(
  options?: Options<ReassignLlmModelTiersData, ThrowOnError>,
): RequestResult<
  ReassignLlmModelTiersResponses,
  ReassignLlmModelTiersErrors,
  ThrowOnError
> =>
  (options?.client ?? client).post<
    ReassignLlmModelTiersResponses,
    ReassignLlmModelTiersErrors,
    ThrowOnError
  >({
    responseType: "json",
    url: "/api/llm-providers/reassign-tiers",
    ...options,
  });

/**
 * Update model pricing and recalculate tier
 *
 * Manually update pricing for a specific model and automatically recalculate its tier based on the new combined cost.
 */
export const updateLlmModelPricing = <ThrowOnError extends boolean = false>(
  options: Options<UpdateLlmModelPricingData, ThrowOnError>,
): RequestResult<
  UpdateLlmModelPricingResponses,
  UpdateLlmModelPricingErrors,
  ThrowOnError
> =>
  (options.client ?? client).patch<
    UpdateLlmModelPricingResponses,
    UpdateLlmModelPricingErrors,
    ThrowOnError
  >({
    responseType: "json",
    url: "/api/llm-providers/models/{provider_key}/{provider_model_id}/pricing",
    ...options,
  });

/**
 * List model sync logs
 *
 * Return the most recent model sync log entries (admin only).
 */
export const listModelSyncLogs = <ThrowOnError extends boolean = false>(
  options?: Options<ListModelSyncLogsData, ThrowOnError>,
): RequestResult<
  ListModelSyncLogsResponses,
  ListModelSyncLogsErrors,
  ThrowOnError
> =>
  (options?.client ?? client).get<
    ListModelSyncLogsResponses,
    ListModelSyncLogsErrors,
    ThrowOnError
  >({
    responseType: "json",
    url: "/api/llm-providers/sync-log",
    ...options,
  });

/**
 * Get model sync log entries
 *
 * Return all per-agent entries for a single sync log (admin only).
 */
export const getModelSyncLogEntries = <ThrowOnError extends boolean = false>(
  options: Options<GetModelSyncLogEntriesData, ThrowOnError>,
): RequestResult<
  GetModelSyncLogEntriesResponses,
  GetModelSyncLogEntriesErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetModelSyncLogEntriesResponses,
    GetModelSyncLogEntriesErrors,
    ThrowOnError
  >({
    responseType: "json",
    url: "/api/llm-providers/sync-log/{sync_log_id}",
    ...options,
  });

/**
 * Update model curation fields
 *
 * Set display_name, is_default, curated_rank, is_featured for one provider model. Omitted fields are left unchanged; explicit null clears display_name/curated_rank (is_default/is_featured have no null semantic and reject it). Setting is_default=true atomically clears any other row's default. Requires admin:platform_config.
 */
export const updateLlmProviderModelCuration = <
  ThrowOnError extends boolean = false,
>(
  options: Options<UpdateLlmProviderModelCurationData, ThrowOnError>,
): RequestResult<
  UpdateLlmProviderModelCurationResponses,
  UpdateLlmProviderModelCurationErrors,
  ThrowOnError
> =>
  (options.client ?? client).patch<
    UpdateLlmProviderModelCurationResponses,
    UpdateLlmProviderModelCurationErrors,
    ThrowOnError
  >({
    responseType: "json",
    url: "/api/llm-providers/models/{model_id}/curation",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * List all enabled models (provider-less)
 *
 * Flat catalog of every ENABLED model with derived display signals (stars, cost badge, good-at tags) and a featured shortlist. Provider is metadata, not a selection step. Used by the model-centric agent setup UI.
 */
export const listModels = <ThrowOnError extends boolean = false>(
  options?: Options<ListModelsData, ThrowOnError>,
): RequestResult<ListModelsResponses, ListModelsErrors, ThrowOnError> =>
  (options?.client ?? client).get<
    ListModelsResponses,
    ListModelsErrors,
    ThrowOnError
  >({
    responseType: "json",
    url: "/api/models",
    ...options,
  });

/**
 * List API tokens
 *
 * List current user's API tokens (token values are never returned).
 */
export const listApiTokens = <ThrowOnError extends boolean = false>(
  options?: Options<ListApiTokensData, ThrowOnError>,
): RequestResult<ListApiTokensResponses, ListApiTokensErrors, ThrowOnError> =>
  (options?.client ?? client).get<
    ListApiTokensResponses,
    ListApiTokensErrors,
    ThrowOnError
  >({
    responseType: "json",
    url: "/api/api-tokens",
    ...options,
  });

/**
 * Create API token
 *
 * Create an API token. The plain token is returned only in this response. Scopes must be a subset of your permissions (session) or of the caller token's scopes.
 */
export const createApiToken = <ThrowOnError extends boolean = false>(
  options: Options<CreateApiTokenData, ThrowOnError>,
): RequestResult<CreateApiTokenResponses, CreateApiTokenErrors, ThrowOnError> =>
  (options.client ?? client).post<
    CreateApiTokenResponses,
    CreateApiTokenErrors,
    ThrowOnError
  >({
    responseType: "json",
    url: "/api/api-tokens",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Revoke API token
 *
 * Revoke an API token by ID.
 */
export const revokeApiToken = <ThrowOnError extends boolean = false>(
  options: Options<RevokeApiTokenData, ThrowOnError>,
): RequestResult<RevokeApiTokenResponses, RevokeApiTokenErrors, ThrowOnError> =>
  (options.client ?? client).delete<
    RevokeApiTokenResponses,
    RevokeApiTokenErrors,
    ThrowOnError
  >({ url: "/api/api-tokens/{token_id}", ...options });

/**
 * List webhook endpoints
 *
 * List all webhook endpoints registered by the current user.
 */
export const listWebhookEndpoints = <ThrowOnError extends boolean = false>(
  options?: Options<ListWebhookEndpointsData, ThrowOnError>,
): RequestResult<
  ListWebhookEndpointsResponses,
  ListWebhookEndpointsErrors,
  ThrowOnError
> =>
  (options?.client ?? client).get<
    ListWebhookEndpointsResponses,
    ListWebhookEndpointsErrors,
    ThrowOnError
  >({
    responseTransformer: listWebhookEndpointsResponseTransformer,
    responseType: "json",
    url: "/api/webhooks/endpoints",
    ...options,
  });

/**
 * Create webhook endpoint
 *
 * Create a new webhook endpoint. The signing secret is returned only in this response and is never retrievable again — store it securely.
 */
export const createWebhookEndpoint = <ThrowOnError extends boolean = false>(
  options: Options<CreateWebhookEndpointData, ThrowOnError>,
): RequestResult<
  CreateWebhookEndpointResponses,
  CreateWebhookEndpointErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    CreateWebhookEndpointResponses,
    CreateWebhookEndpointErrors,
    ThrowOnError
  >({
    responseTransformer: createWebhookEndpointResponseTransformer,
    responseType: "json",
    url: "/api/webhooks/endpoints",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Delete webhook endpoint
 *
 * Permanently delete a webhook endpoint.
 */
export const deleteWebhookEndpoint = <ThrowOnError extends boolean = false>(
  options: Options<DeleteWebhookEndpointData, ThrowOnError>,
): RequestResult<
  DeleteWebhookEndpointResponses,
  DeleteWebhookEndpointErrors,
  ThrowOnError
> =>
  (options.client ?? client).delete<
    DeleteWebhookEndpointResponses,
    DeleteWebhookEndpointErrors,
    ThrowOnError
  >({
    responseType: "json",
    url: "/api/webhooks/endpoints/{endpoint_id}",
    ...options,
  });

/**
 * Get webhook endpoint
 *
 * Get a specific webhook endpoint by id.
 */
export const getWebhookEndpoint = <ThrowOnError extends boolean = false>(
  options: Options<GetWebhookEndpointData, ThrowOnError>,
): RequestResult<
  GetWebhookEndpointResponses,
  GetWebhookEndpointErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetWebhookEndpointResponses,
    GetWebhookEndpointErrors,
    ThrowOnError
  >({
    responseTransformer: getWebhookEndpointResponseTransformer,
    responseType: "json",
    url: "/api/webhooks/endpoints/{endpoint_id}",
    ...options,
  });

/**
 * Re-enable webhook endpoint
 *
 * Re-enable a webhook endpoint that was auto-disabled after repeated delivery failures. Resets the failure count and circuit-breaker state; idempotent if the endpoint is already enabled.
 */
export const reenableWebhookEndpoint = <ThrowOnError extends boolean = false>(
  options: Options<ReenableWebhookEndpointData, ThrowOnError>,
): RequestResult<
  ReenableWebhookEndpointResponses,
  ReenableWebhookEndpointErrors,
  ThrowOnError
> =>
  (options.client ?? client).patch<
    ReenableWebhookEndpointResponses,
    ReenableWebhookEndpointErrors,
    ThrowOnError
  >({
    responseTransformer: reenableWebhookEndpointResponseTransformer,
    responseType: "json",
    url: "/api/webhooks/endpoints/{endpoint_id}",
    ...options,
  });

/**
 * Rotate webhook secret
 *
 * Generate a new signing secret for the webhook endpoint. The new secret is returned once and replaces the previous secret immediately.
 */
export const rotateWebhookSecret = <ThrowOnError extends boolean = false>(
  options: Options<RotateWebhookSecretData, ThrowOnError>,
): RequestResult<
  RotateWebhookSecretResponses,
  RotateWebhookSecretErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    RotateWebhookSecretResponses,
    RotateWebhookSecretErrors,
    ThrowOnError
  >({
    responseType: "json",
    url: "/api/webhooks/endpoints/{endpoint_id}/rotate-secret",
    ...options,
  });

/**
 * Send test delivery
 *
 * Enqueue a test delivery job to verify the endpoint is reachable.
 */
export const testWebhookEndpoint = <ThrowOnError extends boolean = false>(
  options: Options<TestWebhookEndpointData, ThrowOnError>,
): RequestResult<
  TestWebhookEndpointResponses,
  TestWebhookEndpointErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    TestWebhookEndpointResponses,
    TestWebhookEndpointErrors,
    ThrowOnError
  >({
    responseType: "json",
    url: "/api/webhooks/endpoints/{endpoint_id}/test",
    ...options,
  });

/**
 * List delivery history
 *
 * List delivery attempts for a webhook endpoint, newest first.
 */
export const listWebhookDeliveries = <ThrowOnError extends boolean = false>(
  options: Options<ListWebhookDeliveriesData, ThrowOnError>,
): RequestResult<
  ListWebhookDeliveriesResponses,
  ListWebhookDeliveriesErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    ListWebhookDeliveriesResponses,
    ListWebhookDeliveriesErrors,
    ThrowOnError
  >({
    responseTransformer: listWebhookDeliveriesResponseTransformer,
    responseType: "json",
    url: "/api/webhooks/endpoints/{endpoint_id}/deliveries",
    ...options,
  });

/**
 * Manually redeliver a failed delivery
 *
 * Re-enqueue a dead_letter or failed_endpoint_disabled delivery immediately. Does not bypass the circuit breaker and does not count toward the auto-disable threshold.
 */
export const redeliverWebhookDelivery = <ThrowOnError extends boolean = false>(
  options: Options<RedeliverWebhookDeliveryData, ThrowOnError>,
): RequestResult<
  RedeliverWebhookDeliveryResponses,
  RedeliverWebhookDeliveryErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    RedeliverWebhookDeliveryResponses,
    RedeliverWebhookDeliveryErrors,
    ThrowOnError
  >({
    responseType: "json",
    url: "/api/webhooks/endpoints/{endpoint_id}/deliveries/{delivery_id}/redeliver",
    ...options,
  });

/**
 * List tools
 *
 * Paginated list of all tools in the registry.
 */
export const listTools = <ThrowOnError extends boolean = false>(
  options?: Options<ListToolsData, ThrowOnError>,
): RequestResult<ListToolsResponses, ListToolsErrors, ThrowOnError> =>
  (options?.client ?? client).get<
    ListToolsResponses,
    ListToolsErrors,
    ThrowOnError
  >({
    responseType: "json",
    url: "/api/tools",
    ...options,
  });

/**
 * Create tool
 *
 * Create a new tool in the registry by name. Requires admin:platform_config.
 */
export const createTool = <ThrowOnError extends boolean = false>(
  options: Options<CreateToolData, ThrowOnError>,
): RequestResult<CreateToolResponses, CreateToolErrors, ThrowOnError> =>
  (options.client ?? client).post<
    CreateToolResponses,
    CreateToolErrors,
    ThrowOnError
  >({
    responseType: "json",
    url: "/api/tools",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Delete tool
 *
 * Soft delete (default) or hard delete a tool. Requires admin:platform_config.
 */
export const deleteTool = <ThrowOnError extends boolean = false>(
  options: Options<DeleteToolData, ThrowOnError>,
): RequestResult<DeleteToolResponses, DeleteToolErrors, ThrowOnError> =>
  (options.client ?? client).delete<
    DeleteToolResponses,
    DeleteToolErrors,
    ThrowOnError
  >({ url: "/api/tools/{tool_id}", ...options });

/**
 * Get tool by ID
 *
 * Return a single tool by ID.
 */
export const getTool = <ThrowOnError extends boolean = false>(
  options: Options<GetToolData, ThrowOnError>,
): RequestResult<GetToolResponses, GetToolErrors, ThrowOnError> =>
  (options.client ?? client).get<GetToolResponses, GetToolErrors, ThrowOnError>(
    {
      responseType: "json",
      url: "/api/tools/{tool_id}",
      ...options,
    },
  );

/**
 * Update tool
 *
 * Update tool name by ID. Requires admin:platform_config.
 */
export const updateTool = <ThrowOnError extends boolean = false>(
  options: Options<UpdateToolData, ThrowOnError>,
): RequestResult<UpdateToolResponses, UpdateToolErrors, ThrowOnError> =>
  (options.client ?? client).patch<
    UpdateToolResponses,
    UpdateToolErrors,
    ThrowOnError
  >({
    responseType: "json",
    url: "/api/tools/{tool_id}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * List human tasks
 *
 * Paginated list of human-in-the-loop tasks; optional filter by PENDING and agent_id. Support users (admin:support_read) may pass user_id to list another user's tasks.
 */
export const listHumanTasks = <ThrowOnError extends boolean = false>(
  options?: Options<ListHumanTasksData, ThrowOnError>,
): RequestResult<ListHumanTasksResponses, ListHumanTasksErrors, ThrowOnError> =>
  (options?.client ?? client).get<
    ListHumanTasksResponses,
    ListHumanTasksErrors,
    ThrowOnError
  >({
    responseType: "json",
    url: "/api/human-tasks",
    ...options,
  });

/**
 * Create human task
 *
 * Create a human-in-the-loop task for a model query.
 */
export const createHumanTask = <ThrowOnError extends boolean = false>(
  options: Options<CreateHumanTaskData, ThrowOnError>,
): RequestResult<
  CreateHumanTaskResponses,
  CreateHumanTaskErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    CreateHumanTaskResponses,
    CreateHumanTaskErrors,
    ThrowOnError
  >({
    responseType: "json",
    url: "/api/human-tasks",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Get task by model query ID
 *
 * Return the human task linked to a model query.
 */
export const getHumanTaskByQuery = <ThrowOnError extends boolean = false>(
  options: Options<GetHumanTaskByQueryData, ThrowOnError>,
): RequestResult<
  GetHumanTaskByQueryResponses,
  GetHumanTaskByQueryErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetHumanTaskByQueryResponses,
    GetHumanTaskByQueryErrors,
    ThrowOnError
  >({
    responseType: "json",
    url: "/api/human-tasks/by-query/{model_query_id}",
    ...options,
  });

/**
 * Delete human task
 *
 * Delete a human task by ID.
 */
export const deleteHumanTask = <ThrowOnError extends boolean = false>(
  options: Options<DeleteHumanTaskData, ThrowOnError>,
): RequestResult<
  DeleteHumanTaskResponses,
  DeleteHumanTaskErrors,
  ThrowOnError
> =>
  (options.client ?? client).delete<
    DeleteHumanTaskResponses,
    DeleteHumanTaskErrors,
    ThrowOnError
  >({ url: "/api/human-tasks/{task_id}", ...options });

/**
 * Update human task
 *
 * Update reason, retrieved data, model message, or status.
 */
export const updateHumanTask = <ThrowOnError extends boolean = false>(
  options: Options<UpdateHumanTaskData, ThrowOnError>,
): RequestResult<
  UpdateHumanTaskResponses,
  UpdateHumanTaskErrors,
  ThrowOnError
> =>
  (options.client ?? client).patch<
    UpdateHumanTaskResponses,
    UpdateHumanTaskErrors,
    ThrowOnError
  >({
    responseType: "json",
    url: "/api/human-tasks/{task_id}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * List notifications
 *
 * Paginated list of notifications for the current user.
 */
export const listNotifications = <ThrowOnError extends boolean = false>(
  options?: Options<ListNotificationsData, ThrowOnError>,
): RequestResult<
  ListNotificationsResponses,
  ListNotificationsErrors,
  ThrowOnError
> =>
  (options?.client ?? client).get<
    ListNotificationsResponses,
    ListNotificationsErrors,
    ThrowOnError
  >({
    responseTransformer: listNotificationsResponseTransformer,
    responseType: "json",
    url: "/api/notifications",
    ...options,
  });

/**
 * Get unread count
 *
 * Lightweight unread count for badge.
 */
export const getNotificationsUnreadCount = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<GetNotificationsUnreadCountData, ThrowOnError>,
): RequestResult<
  GetNotificationsUnreadCountResponses,
  GetNotificationsUnreadCountErrors,
  ThrowOnError
> =>
  (options?.client ?? client).get<
    GetNotificationsUnreadCountResponses,
    GetNotificationsUnreadCountErrors,
    ThrowOnError
  >({
    responseType: "json",
    url: "/api/notifications/unread-count",
    ...options,
  });

/**
 * Mark as read
 *
 * Mark a single notification as read.
 */
export const markNotificationRead = <ThrowOnError extends boolean = false>(
  options: Options<MarkNotificationReadData, ThrowOnError>,
): RequestResult<
  MarkNotificationReadResponses,
  MarkNotificationReadErrors,
  ThrowOnError
> =>
  (options.client ?? client).patch<
    MarkNotificationReadResponses,
    MarkNotificationReadErrors,
    ThrowOnError
  >({
    responseType: "json",
    url: "/api/notifications/{notification_id}/read",
    ...options,
  });

/**
 * Mark all as read
 *
 * Mark all notifications for the current user as read.
 */
export const markAllNotificationsRead = <ThrowOnError extends boolean = false>(
  options?: Options<MarkAllNotificationsReadData, ThrowOnError>,
): RequestResult<
  MarkAllNotificationsReadResponses,
  MarkAllNotificationsReadErrors,
  ThrowOnError
> =>
  (options?.client ?? client).post<
    MarkAllNotificationsReadResponses,
    MarkAllNotificationsReadErrors,
    ThrowOnError
  >({
    responseType: "json",
    url: "/api/notifications/mark-all-read",
    ...options,
  });

/**
 * Run login-time account checks
 *
 * Idempotent checks the web app runs once per session after login. Currently reports agents whose email provider cannot auto-approve deletions (Outlook, SMTP) and raises a single in-app notification per distinct set of affected agents. Safe to call repeatedly: a warning the user has already seen is not raised again.
 */
export const runStartupChecks = <ThrowOnError extends boolean = false>(
  options?: Options<RunStartupChecksData, ThrowOnError>,
): RequestResult<
  RunStartupChecksResponses,
  RunStartupChecksErrors,
  ThrowOnError
> =>
  (options?.client ?? client).post<
    RunStartupChecksResponses,
    RunStartupChecksErrors,
    ThrowOnError
  >({
    responseType: "json",
    url: "/api/notifications/startup-checks",
    ...options,
  });

/**
 * Unregister mobile push token
 *
 * Deactivate a previously registered Expo push token for the current user.
 */
export const unregisterMobileDeviceToken = <
  ThrowOnError extends boolean = false,
>(
  options: Options<UnregisterMobileDeviceTokenData, ThrowOnError>,
): RequestResult<
  UnregisterMobileDeviceTokenResponses,
  UnregisterMobileDeviceTokenErrors,
  ThrowOnError
> =>
  (options.client ?? client).delete<
    UnregisterMobileDeviceTokenResponses,
    UnregisterMobileDeviceTokenErrors,
    ThrowOnError
  >({
    responseType: "json",
    url: "/api/notifications/device-token",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Register mobile push token
 *
 * Register or refresh Expo push token for the current user.
 */
export const registerMobileDeviceToken = <ThrowOnError extends boolean = false>(
  options: Options<RegisterMobileDeviceTokenData, ThrowOnError>,
): RequestResult<
  RegisterMobileDeviceTokenResponses,
  RegisterMobileDeviceTokenErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    RegisterMobileDeviceTokenResponses,
    RegisterMobileDeviceTokenErrors,
    ThrowOnError
  >({
    responseType: "json",
    url: "/api/notifications/device-token",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Delete selected notifications
 *
 * Delete the given notifications for the current user. Ids that are unknown, owned by another user, or already deleted are skipped, so a stale selection still clears what it legitimately can; the returned count is the number actually deleted.
 */
export const bulkDeleteNotifications = <ThrowOnError extends boolean = false>(
  options: Options<BulkDeleteNotificationsData, ThrowOnError>,
): RequestResult<
  BulkDeleteNotificationsResponses,
  BulkDeleteNotificationsErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    BulkDeleteNotificationsResponses,
    BulkDeleteNotificationsErrors,
    ThrowOnError
  >({
    responseType: "json",
    url: "/api/notifications/bulk-delete",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Delete all read notifications
 *
 * Delete every notification the current user has already read. Unread notifications are never touched, so this cannot destroy something the user has not seen.
 */
export const deleteReadNotifications = <ThrowOnError extends boolean = false>(
  options?: Options<DeleteReadNotificationsData, ThrowOnError>,
): RequestResult<
  DeleteReadNotificationsResponses,
  DeleteReadNotificationsErrors,
  ThrowOnError
> =>
  (options?.client ?? client).post<
    DeleteReadNotificationsResponses,
    DeleteReadNotificationsErrors,
    ThrowOnError
  >({
    responseType: "json",
    url: "/api/notifications/delete-read",
    ...options,
  });

/**
 * Delete a notification
 *
 * Delete a single notification for the current user. Idempotent: deleting one that is already deleted succeeds rather than returning 404, so a retry or a double click is not an error.
 */
export const deleteNotification = <ThrowOnError extends boolean = false>(
  options: Options<DeleteNotificationData, ThrowOnError>,
): RequestResult<
  DeleteNotificationResponses,
  DeleteNotificationErrors,
  ThrowOnError
> =>
  (options.client ?? client).delete<
    DeleteNotificationResponses,
    DeleteNotificationErrors,
    ThrowOnError
  >({
    responseType: "json",
    url: "/api/notifications/{notification_id}",
    ...options,
  });

/**
 * Stream realtime user events
 */
export const streamRealtimeEvents = <ThrowOnError extends boolean = false>(
  options?: Options<StreamRealtimeEventsData, ThrowOnError>,
): RequestResult<
  StreamRealtimeEventsResponses,
  StreamRealtimeEventsErrors,
  ThrowOnError
> =>
  (options?.client ?? client).get<
    StreamRealtimeEventsResponses,
    StreamRealtimeEventsErrors,
    ThrowOnError
  >({
    responseType: "json",
    url: "/api/events/stream",
    ...options,
  });

/**
 * Get Execution Status
 *
 * Post-approval agent/orchestrator execution state for polling after resolve.
 */
export const getExecutionStatusApiApprovalQueueRequestIdExecutionStatusGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetExecutionStatusApiApprovalQueueRequestIdExecutionStatusGetData,
    ThrowOnError
  >,
): RequestResult<
  GetExecutionStatusApiApprovalQueueRequestIdExecutionStatusGetResponses,
  GetExecutionStatusApiApprovalQueueRequestIdExecutionStatusGetErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetExecutionStatusApiApprovalQueueRequestIdExecutionStatusGetResponses,
    GetExecutionStatusApiApprovalQueueRequestIdExecutionStatusGetErrors,
    ThrowOnError
  >({
    responseType: "json",
    url: "/api/approval-queue/{request_id}/execution-status",
    ...options,
  });

/**
 * Get Approval Execution Health
 *
 * Lightweight post-approval liveness / stuck hints (see also execution-status).
 */
export const getApprovalExecutionHealthApiApprovalQueueRequestIdHealthGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetApprovalExecutionHealthApiApprovalQueueRequestIdHealthGetData,
    ThrowOnError
  >,
): RequestResult<
  GetApprovalExecutionHealthApiApprovalQueueRequestIdHealthGetResponses,
  GetApprovalExecutionHealthApiApprovalQueueRequestIdHealthGetErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetApprovalExecutionHealthApiApprovalQueueRequestIdHealthGetResponses,
    GetApprovalExecutionHealthApiApprovalQueueRequestIdHealthGetErrors,
    ThrowOnError
  >({
    responseType: "json",
    url: "/api/approval-queue/{request_id}/health",
    ...options,
  });

/**
 * Get Execution Diagnostics
 *
 * Snapshot + recent trace tail + chat log lines matching correlation_id (best-effort).
 */
export const getExecutionDiagnosticsApiApprovalQueueRequestIdExecutionDiagnosticsGet =
  <ThrowOnError extends boolean = false>(
    options: Options<
      GetExecutionDiagnosticsApiApprovalQueueRequestIdExecutionDiagnosticsGetData,
      ThrowOnError
    >,
  ): RequestResult<
    GetExecutionDiagnosticsApiApprovalQueueRequestIdExecutionDiagnosticsGetResponses,
    GetExecutionDiagnosticsApiApprovalQueueRequestIdExecutionDiagnosticsGetErrors,
    ThrowOnError
  > =>
    (options.client ?? client).get<
      GetExecutionDiagnosticsApiApprovalQueueRequestIdExecutionDiagnosticsGetResponses,
      GetExecutionDiagnosticsApiApprovalQueueRequestIdExecutionDiagnosticsGetErrors,
      ThrowOnError
    >({
      responseType: "json",
      url: "/api/approval-queue/{request_id}/execution-diagnostics",
      ...options,
    });

/**
 * Stream Execution Trace
 *
 * Server-Sent Events: live approval execution trace (Redis pub/sub when configured; else in-process tail).
 */
export const streamExecutionTraceApiApprovalQueueRequestIdExecutionTraceStreamGet =
  <ThrowOnError extends boolean = false>(
    options: Options<
      StreamExecutionTraceApiApprovalQueueRequestIdExecutionTraceStreamGetData,
      ThrowOnError
    >,
  ): RequestResult<
    StreamExecutionTraceApiApprovalQueueRequestIdExecutionTraceStreamGetResponses,
    StreamExecutionTraceApiApprovalQueueRequestIdExecutionTraceStreamGetErrors,
    ThrowOnError
  > =>
    (options.client ?? client).get<
      StreamExecutionTraceApiApprovalQueueRequestIdExecutionTraceStreamGetResponses,
      StreamExecutionTraceApiApprovalQueueRequestIdExecutionTraceStreamGetErrors,
      ThrowOnError
    >({
      responseType: "json",
      url: "/api/approval-queue/{request_id}/execution-trace/stream",
      ...options,
    });

/**
 * List Approvals
 */
export const listApprovalsApiApprovalsGet = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<ListApprovalsApiApprovalsGetData, ThrowOnError>,
): RequestResult<
  ListApprovalsApiApprovalsGetResponses,
  ListApprovalsApiApprovalsGetErrors,
  ThrowOnError
> =>
  (options?.client ?? client).get<
    ListApprovalsApiApprovalsGetResponses,
    ListApprovalsApiApprovalsGetErrors,
    ThrowOnError
  >({
    responseType: "json",
    url: "/api/approvals",
    ...options,
  });

/**
 * Pending Count
 */
export const pendingCountApiApprovalsPendingCountGet = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<PendingCountApiApprovalsPendingCountGetData, ThrowOnError>,
): RequestResult<
  PendingCountApiApprovalsPendingCountGetResponses,
  PendingCountApiApprovalsPendingCountGetErrors,
  ThrowOnError
> =>
  (options?.client ?? client).get<
    PendingCountApiApprovalsPendingCountGetResponses,
    PendingCountApiApprovalsPendingCountGetErrors,
    ThrowOnError
  >({
    responseType: "json",
    url: "/api/approvals/pending-count",
    ...options,
  });

/**
 * Get Approval
 *
 * The owning table's full payload for one row.
 *
 * The list stays narrow on purpose; this is what the expanded row loads. The
 * per-kind endpoints it replaced are still the ones doing the work -- this
 * dispatches to them rather than re-reading their tables, so ownership checks
 * and response shapes stay in one place.
 */
export const getApprovalApiApprovalsApprovalIdGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetApprovalApiApprovalsApprovalIdGetData, ThrowOnError>,
): RequestResult<
  GetApprovalApiApprovalsApprovalIdGetResponses,
  GetApprovalApiApprovalsApprovalIdGetErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetApprovalApiApprovalsApprovalIdGetResponses,
    GetApprovalApiApprovalsApprovalIdGetErrors,
    ThrowOnError
  >({
    responseType: "json",
    url: "/api/approvals/{approval_id}",
    ...options,
  });

/**
 * Decide Approval
 *
 * Approve or reject one row, whatever kind it is.
 *
 * This replaced nine per-kind POSTs. It does not reimplement any of them: each
 * branch calls the handler that already ran that decision, so agent resumption,
 * billing attribution and post-approval execution behave exactly as before.
 */
export const decideApprovalApiApprovalsApprovalIdDecidePost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    DecideApprovalApiApprovalsApprovalIdDecidePostData,
    ThrowOnError
  >,
): RequestResult<
  DecideApprovalApiApprovalsApprovalIdDecidePostResponses,
  DecideApprovalApiApprovalsApprovalIdDecidePostErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    DecideApprovalApiApprovalsApprovalIdDecidePostResponses,
    DecideApprovalApiApprovalsApprovalIdDecidePostErrors,
    ThrowOnError
  >({
    responseType: "json",
    url: "/api/approvals/{approval_id}/decide",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * List support tickets (support only, FIFO)
 */
export const listTicketsApiSupportTicketsGet = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<ListTicketsApiSupportTicketsGetData, ThrowOnError>,
): RequestResult<
  ListTicketsApiSupportTicketsGetResponses,
  ListTicketsApiSupportTicketsGetErrors,
  ThrowOnError
> =>
  (options?.client ?? client).get<
    ListTicketsApiSupportTicketsGetResponses,
    ListTicketsApiSupportTicketsGetErrors,
    ThrowOnError
  >({
    responseTransformer: listTicketsApiSupportTicketsGetResponseTransformer,
    responseType: "json",
    url: "/api/support/tickets",
    ...options,
  });

/**
 * Create support ticket
 *
 * Submit a support ticket. User is taken from the authenticated session; user_id must not be sent in the body.
 */
export const createSupportTicketApiSupportTicketsPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<CreateSupportTicketApiSupportTicketsPostData, ThrowOnError>,
): RequestResult<
  CreateSupportTicketApiSupportTicketsPostResponses,
  CreateSupportTicketApiSupportTicketsPostErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    CreateSupportTicketApiSupportTicketsPostResponses,
    CreateSupportTicketApiSupportTicketsPostErrors,
    ThrowOnError
  >({
    responseTransformer:
      createSupportTicketApiSupportTicketsPostResponseTransformer,
    responseType: "json",
    url: "/api/support/tickets",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Get an owned ticket or support ticket detail
 */
export const getTicketApiSupportTicketsTicketIdGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetTicketApiSupportTicketsTicketIdGetData, ThrowOnError>,
): RequestResult<
  GetTicketApiSupportTicketsTicketIdGetResponses,
  GetTicketApiSupportTicketsTicketIdGetErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetTicketApiSupportTicketsTicketIdGetResponses,
    GetTicketApiSupportTicketsTicketIdGetErrors,
    ThrowOnError
  >({
    responseTransformer:
      getTicketApiSupportTicketsTicketIdGetResponseTransformer,
    responseType: "json",
    url: "/api/support/tickets/{ticket_id}",
    ...options,
  });

/**
 * Support ticket action (assign_me, release, mark_solved, escalate_tier2)
 */
export const updateTicketApiSupportTicketsTicketIdPatch = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    UpdateTicketApiSupportTicketsTicketIdPatchData,
    ThrowOnError
  >,
): RequestResult<
  UpdateTicketApiSupportTicketsTicketIdPatchResponses,
  UpdateTicketApiSupportTicketsTicketIdPatchErrors,
  ThrowOnError
> =>
  (options.client ?? client).patch<
    UpdateTicketApiSupportTicketsTicketIdPatchResponses,
    UpdateTicketApiSupportTicketsTicketIdPatchErrors,
    ThrowOnError
  >({
    responseTransformer:
      updateTicketApiSupportTicketsTicketIdPatchResponseTransformer,
    responseType: "json",
    url: "/api/support/tickets/{ticket_id}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Get Ticket Messages
 */
export const getTicketMessagesApiSupportTicketsTicketIdMessagesGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetTicketMessagesApiSupportTicketsTicketIdMessagesGetData,
    ThrowOnError
  >,
): RequestResult<
  GetTicketMessagesApiSupportTicketsTicketIdMessagesGetResponses,
  GetTicketMessagesApiSupportTicketsTicketIdMessagesGetErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetTicketMessagesApiSupportTicketsTicketIdMessagesGetResponses,
    GetTicketMessagesApiSupportTicketsTicketIdMessagesGetErrors,
    ThrowOnError
  >({
    responseTransformer:
      getTicketMessagesApiSupportTicketsTicketIdMessagesGetResponseTransformer,
    responseType: "json",
    url: "/api/support/tickets/{ticket_id}/messages",
    ...options,
  });

/**
 * Reply To Ticket
 */
export const replyToTicketApiSupportTicketsTicketIdMessagesPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    ReplyToTicketApiSupportTicketsTicketIdMessagesPostData,
    ThrowOnError
  >,
): RequestResult<
  ReplyToTicketApiSupportTicketsTicketIdMessagesPostResponses,
  ReplyToTicketApiSupportTicketsTicketIdMessagesPostErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    ReplyToTicketApiSupportTicketsTicketIdMessagesPostResponses,
    ReplyToTicketApiSupportTicketsTicketIdMessagesPostErrors,
    ThrowOnError
  >({
    ...formDataBodySerializer,
    responseTransformer:
      replyToTicketApiSupportTicketsTicketIdMessagesPostResponseTransformer,
    responseType: "json",
    url: "/api/support/tickets/{ticket_id}/messages",
    ...options,
    headers: {
      "Content-Type": null,
      ...options.headers,
    },
  });

/**
 * Add Initial Ticket Attachments
 */
export const addInitialTicketAttachmentsApiSupportTicketsTicketIdAttachmentsPost =
  <ThrowOnError extends boolean = false>(
    options: Options<
      AddInitialTicketAttachmentsApiSupportTicketsTicketIdAttachmentsPostData,
      ThrowOnError
    >,
  ): RequestResult<
    AddInitialTicketAttachmentsApiSupportTicketsTicketIdAttachmentsPostResponses,
    AddInitialTicketAttachmentsApiSupportTicketsTicketIdAttachmentsPostErrors,
    ThrowOnError
  > =>
    (options.client ?? client).post<
      AddInitialTicketAttachmentsApiSupportTicketsTicketIdAttachmentsPostResponses,
      AddInitialTicketAttachmentsApiSupportTicketsTicketIdAttachmentsPostErrors,
      ThrowOnError
    >({
      ...formDataBodySerializer,
      responseTransformer:
        addInitialTicketAttachmentsApiSupportTicketsTicketIdAttachmentsPostResponseTransformer,
      responseType: "json",
      url: "/api/support/tickets/{ticket_id}/attachments",
      ...options,
      headers: {
        "Content-Type": null,
        ...options.headers,
      },
    });

/**
 * Download Ticket Attachment
 */
export const downloadTicketAttachmentApiSupportTicketsTicketIdAttachmentsAttachmentIdGet =
  <ThrowOnError extends boolean = false>(
    options: Options<
      DownloadTicketAttachmentApiSupportTicketsTicketIdAttachmentsAttachmentIdGetData,
      ThrowOnError
    >,
  ): RequestResult<
    DownloadTicketAttachmentApiSupportTicketsTicketIdAttachmentsAttachmentIdGetResponses,
    DownloadTicketAttachmentApiSupportTicketsTicketIdAttachmentsAttachmentIdGetErrors,
    ThrowOnError
  > =>
    (options.client ?? client).get<
      DownloadTicketAttachmentApiSupportTicketsTicketIdAttachmentsAttachmentIdGetResponses,
      DownloadTicketAttachmentApiSupportTicketsTicketIdAttachmentsAttachmentIdGetErrors,
      ThrowOnError
    >({
      responseType: "json",
      url: "/api/support/tickets/{ticket_id}/attachments/{attachment_id}",
      ...options,
    });

/**
 * Get Dashboard
 */
export const getReferralDashboard = <ThrowOnError extends boolean = false>(
  options?: Options<GetReferralDashboardData, ThrowOnError>,
): RequestResult<
  GetReferralDashboardResponses,
  GetReferralDashboardErrors,
  ThrowOnError
> =>
  (options?.client ?? client).get<
    GetReferralDashboardResponses,
    GetReferralDashboardErrors,
    ThrowOnError
  >({
    responseType: "json",
    url: "/api/referrals/dashboard",
    ...options,
  });

/**
 * List Signups
 */
export const listReferralSignups = <ThrowOnError extends boolean = false>(
  options?: Options<ListReferralSignupsData, ThrowOnError>,
): RequestResult<
  ListReferralSignupsResponses,
  ListReferralSignupsErrors,
  ThrowOnError
> =>
  (options?.client ?? client).get<
    ListReferralSignupsResponses,
    ListReferralSignupsErrors,
    ThrowOnError
  >({
    responseType: "json",
    url: "/api/referrals/signups",
    ...options,
  });

/**
 * List Commissions
 */
export const listReferralUserCommissions = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<ListReferralUserCommissionsData, ThrowOnError>,
): RequestResult<
  ListReferralUserCommissionsResponses,
  ListReferralUserCommissionsErrors,
  ThrowOnError
> =>
  (options?.client ?? client).get<
    ListReferralUserCommissionsResponses,
    ListReferralUserCommissionsErrors,
    ThrowOnError
  >({
    responseType: "json",
    url: "/api/referrals/commissions",
    ...options,
  });

/**
 * Sync Connect Status
 */
export const syncReferralConnectStatus = <ThrowOnError extends boolean = false>(
  options?: Options<SyncReferralConnectStatusData, ThrowOnError>,
): RequestResult<
  SyncReferralConnectStatusResponses,
  SyncReferralConnectStatusErrors,
  ThrowOnError
> =>
  (options?.client ?? client).post<
    SyncReferralConnectStatusResponses,
    SyncReferralConnectStatusErrors,
    ThrowOnError
  >({
    responseType: "json",
    url: "/api/referrals/connect/sync",
    ...options,
  });

/**
 * Enroll
 */
export const enrollReferralProgram = <ThrowOnError extends boolean = false>(
  options?: Options<EnrollReferralProgramData, ThrowOnError>,
): RequestResult<
  EnrollReferralProgramResponses,
  EnrollReferralProgramErrors,
  ThrowOnError
> =>
  (options?.client ?? client).post<
    EnrollReferralProgramResponses,
    EnrollReferralProgramErrors,
    ThrowOnError
  >({
    responseType: "json",
    url: "/api/referrals/enroll",
    ...options,
  });

/**
 * Partner Join
 */
export const joinReferralPartnerProgram = <
  ThrowOnError extends boolean = false,
>(
  options: Options<JoinReferralPartnerProgramData, ThrowOnError>,
): RequestResult<
  JoinReferralPartnerProgramResponses,
  JoinReferralPartnerProgramErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    JoinReferralPartnerProgramResponses,
    JoinReferralPartnerProgramErrors,
    ThrowOnError
  >({
    responseType: "json",
    url: "/api/referrals/partner/join",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Connect Onboard
 */
export const startReferralConnectOnboarding = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<StartReferralConnectOnboardingData, ThrowOnError>,
): RequestResult<
  StartReferralConnectOnboardingResponses,
  StartReferralConnectOnboardingErrors,
  ThrowOnError
> =>
  (options?.client ?? client).post<
    StartReferralConnectOnboardingResponses,
    StartReferralConnectOnboardingErrors,
    ThrowOnError
  >({
    responseType: "json",
    url: "/api/referrals/connect/onboard",
    ...options,
  });

/**
 * List all users (admin)
 *
 * Paginated list of users. Optional search by email or name. Superuser only.
 */
export const listAdminUsers = <ThrowOnError extends boolean = false>(
  options?: Options<ListAdminUsersData, ThrowOnError>,
): RequestResult<ListAdminUsersResponses, ListAdminUsersErrors, ThrowOnError> =>
  (options?.client ?? client).get<
    ListAdminUsersResponses,
    ListAdminUsersErrors,
    ThrowOnError
  >({
    responseTransformer: listAdminUsersResponseTransformer,
    responseType: "json",
    url: "/api/admin/users",
    ...options,
  });

/**
 * Get user by ID (admin)
 *
 * Fetch a single user with roles. Superuser only.
 */
export const getAdminUser = <ThrowOnError extends boolean = false>(
  options: Options<GetAdminUserData, ThrowOnError>,
): RequestResult<GetAdminUserResponses, GetAdminUserErrors, ThrowOnError> =>
  (options.client ?? client).get<
    GetAdminUserResponses,
    GetAdminUserErrors,
    ThrowOnError
  >({
    responseTransformer: getAdminUserResponseTransformer,
    responseType: "json",
    url: "/api/admin/users/{user_id}",
    ...options,
  });

/**
 * Update user (admin)
 *
 * Update name, email, credit_balance, email_verified, and/or is_suspended. Email uniqueness enforced. Superuser only.
 */
export const updateAdminUser = <ThrowOnError extends boolean = false>(
  options: Options<UpdateAdminUserData, ThrowOnError>,
): RequestResult<
  UpdateAdminUserResponses,
  UpdateAdminUserErrors,
  ThrowOnError
> =>
  (options.client ?? client).patch<
    UpdateAdminUserResponses,
    UpdateAdminUserErrors,
    ThrowOnError
  >({
    responseTransformer: updateAdminUserResponseTransformer,
    responseType: "json",
    url: "/api/admin/users/{user_id}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Set user roles (admin)
 *
 * Replace user's roles with the given list (by name). Superuser only.
 */
export const updateAdminUserRoles = <ThrowOnError extends boolean = false>(
  options: Options<UpdateAdminUserRolesData, ThrowOnError>,
): RequestResult<
  UpdateAdminUserRolesResponses,
  UpdateAdminUserRolesErrors,
  ThrowOnError
> =>
  (options.client ?? client).put<
    UpdateAdminUserRolesResponses,
    UpdateAdminUserRolesErrors,
    ThrowOnError
  >({
    url: "/api/admin/users/{user_id}/roles",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * List audit logs for a user (admin)
 *
 * Audit log entries for admin actions on this user. Superuser only.
 */
export const listAdminUserAuditLogs = <ThrowOnError extends boolean = false>(
  options: Options<ListAdminUserAuditLogsData, ThrowOnError>,
): RequestResult<
  ListAdminUserAuditLogsResponses,
  ListAdminUserAuditLogsErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    ListAdminUserAuditLogsResponses,
    ListAdminUserAuditLogsErrors,
    ThrowOnError
  >({
    responseTransformer: listAdminUserAuditLogsResponseTransformer,
    responseType: "json",
    url: "/api/admin/users/{user_id}/audit-logs",
    ...options,
  });

/**
 * Run active-agent RAG readiness pass (superuser only)
 *
 * Runs one proactive readiness scan for agents used in the configured recent window and auto-queues reindex jobs where needed.
 */
export const runActiveAgentRagReadinessPass = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<RunActiveAgentRagReadinessPassData, ThrowOnError>,
): RequestResult<
  RunActiveAgentRagReadinessPassResponses,
  RunActiveAgentRagReadinessPassErrors,
  ThrowOnError
> =>
  (options?.client ?? client).post<
    RunActiveAgentRagReadinessPassResponses,
    RunActiveAgentRagReadinessPassErrors,
    ThrowOnError
  >({
    responseType: "json",
    url: "/api/admin/documents/active-rag-readiness/run",
    ...options,
  });

/**
 * Reindex all documents (superuser only)
 *
 * Reindex RAG embeddings for all agents from their stored sources (files/URLs). Use after embedding model or chunking changes. Superuser only. Jobs are queued by default (requires Redis + worker); use ?queue=false to run synchronously.
 */
export const reindexAllDocuments = <ThrowOnError extends boolean = false>(
  options?: Options<ReindexAllDocumentsData, ThrowOnError>,
): RequestResult<
  ReindexAllDocumentsResponses,
  ReindexAllDocumentsErrors,
  ThrowOnError
> =>
  (options?.client ?? client).post<
    ReindexAllDocumentsResponses,
    ReindexAllDocumentsErrors,
    ThrowOnError
  >({
    responseType: "json",
    url: "/api/admin/documents/reindex",
    ...options,
  });

/**
 * List all roles (admin)
 *
 * Returns all roles in the system (id and name). Superuser only.
 */
export const listAdminRoles = <ThrowOnError extends boolean = false>(
  options?: Options<ListAdminRolesData, ThrowOnError>,
): RequestResult<ListAdminRolesResponses, ListAdminRolesErrors, ThrowOnError> =>
  (options?.client ?? client).get<
    ListAdminRolesResponses,
    ListAdminRolesErrors,
    ThrowOnError
  >({
    responseType: "json",
    url: "/api/admin/roles",
    ...options,
  });

/**
 * Ephemeral agent cleanup stats (admin)
 *
 * Returns how many ephemeral agents are currently eligible for cleanup (dry-run).
 */
export const getEphemeralAgentCleanupStats = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<GetEphemeralAgentCleanupStatsData, ThrowOnError>,
): RequestResult<
  GetEphemeralAgentCleanupStatsResponses,
  GetEphemeralAgentCleanupStatsErrors,
  ThrowOnError
> =>
  (options?.client ?? client).get<
    GetEphemeralAgentCleanupStatsResponses,
    GetEphemeralAgentCleanupStatsErrors,
    ThrowOnError
  >({
    responseType: "json",
    url: "/api/admin/ephemeral-agents/stats",
    ...options,
  });

/**
 * Run ephemeral agent cleanup (admin)
 *
 * Executes cleanup for runtime-spawned ephemeral agents older than max_age_hours.
 */
export const runEphemeralAgentCleanup = <ThrowOnError extends boolean = false>(
  options?: Options<RunEphemeralAgentCleanupData, ThrowOnError>,
): RequestResult<
  RunEphemeralAgentCleanupResponses,
  RunEphemeralAgentCleanupErrors,
  ThrowOnError
> =>
  (options?.client ?? client).post<
    RunEphemeralAgentCleanupResponses,
    RunEphemeralAgentCleanupErrors,
    ThrowOnError
  >({
    responseType: "json",
    url: "/api/admin/ephemeral-agents/cleanup",
    ...options,
  });

/**
 * Get agent (admin, incl. deleted)
 *
 * Fetch a single agent by id including soft-deleted ones. Superuser only. Audit-logged.
 */
export const adminGetAgent = <ThrowOnError extends boolean = false>(
  options: Options<AdminGetAgentData, ThrowOnError>,
): RequestResult<AdminGetAgentResponses, AdminGetAgentErrors, ThrowOnError> =>
  (options.client ?? client).get<
    AdminGetAgentResponses,
    AdminGetAgentErrors,
    ThrowOnError
  >({
    responseType: "json",
    url: "/api/admin/agents/{agent_id}",
    ...options,
  });

/**
 * List agent conversations (admin, incl. deleted)
 *
 * Paginated list of all conversations for an agent (incl. soft-deleted agent and conversations). Superuser only. Audit-logged.
 */
export const adminListAgentConversations = <
  ThrowOnError extends boolean = false,
>(
  options: Options<AdminListAgentConversationsData, ThrowOnError>,
): RequestResult<
  AdminListAgentConversationsResponses,
  AdminListAgentConversationsErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    AdminListAgentConversationsResponses,
    AdminListAgentConversationsErrors,
    ThrowOnError
  >({
    responseType: "json",
    url: "/api/admin/agents/{agent_id}/conversations",
    ...options,
  });

/**
 * Get conversation with messages (admin)
 *
 * Fetch a conversation and all its messages without ownership or live-agent filters. Superuser only. Audit-logged.
 */
export const adminGetConversation = <ThrowOnError extends boolean = false>(
  options: Options<AdminGetConversationData, ThrowOnError>,
): RequestResult<
  AdminGetConversationResponses,
  AdminGetConversationErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    AdminGetConversationResponses,
    AdminGetConversationErrors,
    ThrowOnError
  >({
    responseType: "json",
    url: "/api/admin/conversations/{conversation_id}",
    ...options,
  });

/**
 * List user agents (admin, incl. deleted)
 *
 * Paginated list of all agents for a user (incl. soft-deleted). Superuser only. Audit-logged.
 */
export const adminListUserAgents = <ThrowOnError extends boolean = false>(
  options: Options<AdminListUserAgentsData, ThrowOnError>,
): RequestResult<
  AdminListUserAgentsResponses,
  AdminListUserAgentsErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    AdminListUserAgentsResponses,
    AdminListUserAgentsErrors,
    ThrowOnError
  >({
    responseType: "json",
    url: "/api/admin/users/{user_id}/agents",
    ...options,
  });

/**
 * Admin List Templates
 */
export const listReferralTemplates = <ThrowOnError extends boolean = false>(
  options?: Options<ListReferralTemplatesData, ThrowOnError>,
): RequestResult<
  ListReferralTemplatesResponses,
  ListReferralTemplatesErrors,
  ThrowOnError
> =>
  (options?.client ?? client).get<
    ListReferralTemplatesResponses,
    ListReferralTemplatesErrors,
    ThrowOnError
  >({
    responseType: "json",
    url: "/api/admin/referrals/templates",
    ...options,
  });

/**
 * Admin Create Template
 */
export const createReferralTemplate = <ThrowOnError extends boolean = false>(
  options: Options<CreateReferralTemplateData, ThrowOnError>,
): RequestResult<
  CreateReferralTemplateResponses,
  CreateReferralTemplateErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    CreateReferralTemplateResponses,
    CreateReferralTemplateErrors,
    ThrowOnError
  >({
    responseType: "json",
    url: "/api/admin/referrals/templates",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Admin Update Template
 */
export const updateReferralTemplate = <ThrowOnError extends boolean = false>(
  options: Options<UpdateReferralTemplateData, ThrowOnError>,
): RequestResult<
  UpdateReferralTemplateResponses,
  UpdateReferralTemplateErrors,
  ThrowOnError
> =>
  (options.client ?? client).patch<
    UpdateReferralTemplateResponses,
    UpdateReferralTemplateErrors,
    ThrowOnError
  >({
    responseType: "json",
    url: "/api/admin/referrals/templates/{template_id}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Admin Get Settings
 */
export const getReferralSettings = <ThrowOnError extends boolean = false>(
  options?: Options<GetReferralSettingsData, ThrowOnError>,
): RequestResult<
  GetReferralSettingsResponses,
  GetReferralSettingsErrors,
  ThrowOnError
> =>
  (options?.client ?? client).get<
    GetReferralSettingsResponses,
    GetReferralSettingsErrors,
    ThrowOnError
  >({
    responseType: "json",
    url: "/api/admin/referrals/settings",
    ...options,
  });

/**
 * Admin Update Settings
 */
export const updateReferralSettings = <ThrowOnError extends boolean = false>(
  options: Options<UpdateReferralSettingsData, ThrowOnError>,
): RequestResult<
  UpdateReferralSettingsResponses,
  UpdateReferralSettingsErrors,
  ThrowOnError
> =>
  (options.client ?? client).patch<
    UpdateReferralSettingsResponses,
    UpdateReferralSettingsErrors,
    ThrowOnError
  >({
    responseType: "json",
    url: "/api/admin/referrals/settings",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Admin List Invites
 */
export const listReferralInvites = <ThrowOnError extends boolean = false>(
  options?: Options<ListReferralInvitesData, ThrowOnError>,
): RequestResult<
  ListReferralInvitesResponses,
  ListReferralInvitesErrors,
  ThrowOnError
> =>
  (options?.client ?? client).get<
    ListReferralInvitesResponses,
    ListReferralInvitesErrors,
    ThrowOnError
  >({
    responseType: "json",
    url: "/api/admin/referrals/invites",
    ...options,
  });

/**
 * Admin Create Invite
 */
export const createReferralInvite = <ThrowOnError extends boolean = false>(
  options: Options<CreateReferralInviteData, ThrowOnError>,
): RequestResult<
  CreateReferralInviteResponses,
  CreateReferralInviteErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    CreateReferralInviteResponses,
    CreateReferralInviteErrors,
    ThrowOnError
  >({
    responseType: "json",
    url: "/api/admin/referrals/invites",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Admin Revoke Invite
 */
export const revokeReferralInvite = <ThrowOnError extends boolean = false>(
  options: Options<RevokeReferralInviteData, ThrowOnError>,
): RequestResult<
  RevokeReferralInviteResponses,
  RevokeReferralInviteErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    RevokeReferralInviteResponses,
    RevokeReferralInviteErrors,
    ThrowOnError
  >({
    responseType: "json",
    url: "/api/admin/referrals/invites/{invite_id}/revoke",
    ...options,
  });

/**
 * Admin Rotate Invite
 */
export const rotateReferralInvite = <ThrowOnError extends boolean = false>(
  options: Options<RotateReferralInviteData, ThrowOnError>,
): RequestResult<
  RotateReferralInviteResponses,
  RotateReferralInviteErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    RotateReferralInviteResponses,
    RotateReferralInviteErrors,
    ThrowOnError
  >({
    responseType: "json",
    url: "/api/admin/referrals/invites/{invite_id}/rotate",
    ...options,
  });

/**
 * Admin Delete Invite
 */
export const deleteReferralInvite = <ThrowOnError extends boolean = false>(
  options: Options<DeleteReferralInviteData, ThrowOnError>,
): RequestResult<
  DeleteReferralInviteResponses,
  DeleteReferralInviteErrors,
  ThrowOnError
> =>
  (options.client ?? client).delete<
    DeleteReferralInviteResponses,
    DeleteReferralInviteErrors,
    ThrowOnError
  >({
    responseType: "json",
    url: "/api/admin/referrals/invites/{invite_id}",
    ...options,
  });

/**
 * Admin List Referrers
 */
export const listReferrers = <ThrowOnError extends boolean = false>(
  options?: Options<ListReferrersData, ThrowOnError>,
): RequestResult<ListReferrersResponses, ListReferrersErrors, ThrowOnError> =>
  (options?.client ?? client).get<
    ListReferrersResponses,
    ListReferrersErrors,
    ThrowOnError
  >({
    responseType: "json",
    url: "/api/admin/referrals/referrers",
    ...options,
  });

/**
 * Admin Create Referrer
 */
export const createReferrer = <ThrowOnError extends boolean = false>(
  options: Options<CreateReferrerData, ThrowOnError>,
): RequestResult<CreateReferrerResponses, CreateReferrerErrors, ThrowOnError> =>
  (options.client ?? client).post<
    CreateReferrerResponses,
    CreateReferrerErrors,
    ThrowOnError
  >({
    responseType: "json",
    url: "/api/admin/referrals/referrers",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Admin Remove Referrer
 */
export const removeReferrer = <ThrowOnError extends boolean = false>(
  options: Options<RemoveReferrerData, ThrowOnError>,
): RequestResult<RemoveReferrerResponses, RemoveReferrerErrors, ThrowOnError> =>
  (options.client ?? client).delete<
    RemoveReferrerResponses,
    RemoveReferrerErrors,
    ThrowOnError
  >({
    responseType: "json",
    url: "/api/admin/referrals/referrers/{referrer_id}",
    ...options,
  });

/**
 * Admin Get Referrer
 */
export const getReferrerAdminDetail = <ThrowOnError extends boolean = false>(
  options: Options<GetReferrerAdminDetailData, ThrowOnError>,
): RequestResult<
  GetReferrerAdminDetailResponses,
  GetReferrerAdminDetailErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetReferrerAdminDetailResponses,
    GetReferrerAdminDetailErrors,
    ThrowOnError
  >({
    responseType: "json",
    url: "/api/admin/referrals/referrers/{referrer_id}",
    ...options,
  });

/**
 * Admin Update Referrer Status
 */
export const updateReferrerStatus = <ThrowOnError extends boolean = false>(
  options: Options<UpdateReferrerStatusData, ThrowOnError>,
): RequestResult<
  UpdateReferrerStatusResponses,
  UpdateReferrerStatusErrors,
  ThrowOnError
> =>
  (options.client ?? client).patch<
    UpdateReferrerStatusResponses,
    UpdateReferrerStatusErrors,
    ThrowOnError
  >({
    responseType: "json",
    url: "/api/admin/referrals/referrers/{referrer_id}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Admin Rotate Referrer Code
 */
export const rotateReferrerCode = <ThrowOnError extends boolean = false>(
  options: Options<RotateReferrerCodeData, ThrowOnError>,
): RequestResult<
  RotateReferrerCodeResponses,
  RotateReferrerCodeErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    RotateReferrerCodeResponses,
    RotateReferrerCodeErrors,
    ThrowOnError
  >({
    responseType: "json",
    url: "/api/admin/referrals/referrers/{referrer_id}/rotate-code",
    ...options,
  });

/**
 * Admin Reapply Template
 */
export const reapplyReferrerTemplate = <ThrowOnError extends boolean = false>(
  options: Options<ReapplyReferrerTemplateData, ThrowOnError>,
): RequestResult<
  ReapplyReferrerTemplateResponses,
  ReapplyReferrerTemplateErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    ReapplyReferrerTemplateResponses,
    ReapplyReferrerTemplateErrors,
    ThrowOnError
  >({
    responseType: "json",
    url: "/api/admin/referrals/referrers/{referrer_id}/reapply-template",
    ...options,
  });

/**
 * Admin Override
 */
export const overrideReferralAttribution = <
  ThrowOnError extends boolean = false,
>(
  options: Options<OverrideReferralAttributionData, ThrowOnError>,
): RequestResult<
  OverrideReferralAttributionResponses,
  OverrideReferralAttributionErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    OverrideReferralAttributionResponses,
    OverrideReferralAttributionErrors,
    ThrowOnError
  >({
    responseType: "json",
    url: "/api/admin/referrals/attributions/override",
    ...options,
  });

/**
 * Admin List Commissions
 */
export const listReferralCommissions = <ThrowOnError extends boolean = false>(
  options?: Options<ListReferralCommissionsData, ThrowOnError>,
): RequestResult<
  ListReferralCommissionsResponses,
  ListReferralCommissionsErrors,
  ThrowOnError
> =>
  (options?.client ?? client).get<
    ListReferralCommissionsResponses,
    ListReferralCommissionsErrors,
    ThrowOnError
  >({
    responseType: "json",
    url: "/api/admin/referrals/commissions",
    ...options,
  });

/**
 * Admin Tax Export
 */
export const exportReferralTaxReport = <ThrowOnError extends boolean = false>(
  options: Options<ExportReferralTaxReportData, ThrowOnError>,
): RequestResult<
  ExportReferralTaxReportResponses,
  ExportReferralTaxReportErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    ExportReferralTaxReportResponses,
    ExportReferralTaxReportErrors,
    ThrowOnError
  >({
    responseType: "json",
    url: "/api/admin/referrals/tax-export/{year}",
    ...options,
  });

/**
 * Admin Preview Payouts
 */
export const previewReferralPayouts = <ThrowOnError extends boolean = false>(
  options?: Options<PreviewReferralPayoutsData, ThrowOnError>,
): RequestResult<
  PreviewReferralPayoutsResponses,
  PreviewReferralPayoutsErrors,
  ThrowOnError
> =>
  (options?.client ?? client).get<
    PreviewReferralPayoutsResponses,
    PreviewReferralPayoutsErrors,
    ThrowOnError
  >({
    responseType: "json",
    url: "/api/admin/referrals/payouts/preview",
    ...options,
  });

/**
 * Admin Run Payouts
 */
export const runReferralPayouts = <ThrowOnError extends boolean = false>(
  options?: Options<RunReferralPayoutsData, ThrowOnError>,
): RequestResult<
  RunReferralPayoutsResponses,
  RunReferralPayoutsErrors,
  ThrowOnError
> =>
  (options?.client ?? client).post<
    RunReferralPayoutsResponses,
    RunReferralPayoutsErrors,
    ThrowOnError
  >({
    responseType: "json",
    url: "/api/admin/referrals/payouts/run",
    ...options,
  });

/**
 * Message latency by conversation message id
 *
 * Returns ModelQuery latency rows where billing_message_id matches the message. Caller must own the conversation or have admin:support_read_history (or superuser).
 */
export const getMessageLatencyApiAdminSupportMetricsMessagesMessageIdLatencyGet =
  <ThrowOnError extends boolean = false>(
    options: Options<
      GetMessageLatencyApiAdminSupportMetricsMessagesMessageIdLatencyGetData,
      ThrowOnError
    >,
  ): RequestResult<
    GetMessageLatencyApiAdminSupportMetricsMessagesMessageIdLatencyGetResponses,
    GetMessageLatencyApiAdminSupportMetricsMessagesMessageIdLatencyGetErrors,
    ThrowOnError
  > =>
    (options.client ?? client).get<
      GetMessageLatencyApiAdminSupportMetricsMessagesMessageIdLatencyGetResponses,
      GetMessageLatencyApiAdminSupportMetricsMessagesMessageIdLatencyGetErrors,
      ThrowOnError
    >({
      responseTransformer:
        getMessageLatencyApiAdminSupportMetricsMessagesMessageIdLatencyGetResponseTransformer,
      responseType: "json",
      url: "/api/admin/support/metrics/messages/{message_id}/latency",
      ...options,
    });

/**
 * User latency summary
 *
 * Aggregates ModelQuery.duration_ms for agents owned by user_id. Caller must be that user or have admin:support_read_history (or superuser).
 */
export const getUserLatencySummaryApiAdminSupportMetricsUsersUserIdLatencySummaryGet =
  <ThrowOnError extends boolean = false>(
    options: Options<
      GetUserLatencySummaryApiAdminSupportMetricsUsersUserIdLatencySummaryGetData,
      ThrowOnError
    >,
  ): RequestResult<
    GetUserLatencySummaryApiAdminSupportMetricsUsersUserIdLatencySummaryGetResponses,
    GetUserLatencySummaryApiAdminSupportMetricsUsersUserIdLatencySummaryGetErrors,
    ThrowOnError
  > =>
    (options.client ?? client).get<
      GetUserLatencySummaryApiAdminSupportMetricsUsersUserIdLatencySummaryGetResponses,
      GetUserLatencySummaryApiAdminSupportMetricsUsersUserIdLatencySummaryGetErrors,
      ThrowOnError
    >({
      responseType: "json",
      url: "/api/admin/support/metrics/users/{user_id}/latency-summary",
      ...options,
    });

/**
 * List recent instruction evaluation runs
 */
export const listInstructionEvaluationsApiAdminInstructionEvaluationsGet = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<
    ListInstructionEvaluationsApiAdminInstructionEvaluationsGetData,
    ThrowOnError
  >,
): RequestResult<
  ListInstructionEvaluationsApiAdminInstructionEvaluationsGetResponses,
  ListInstructionEvaluationsApiAdminInstructionEvaluationsGetErrors,
  ThrowOnError
> =>
  (options?.client ?? client).get<
    ListInstructionEvaluationsApiAdminInstructionEvaluationsGetResponses,
    ListInstructionEvaluationsApiAdminInstructionEvaluationsGetErrors,
    ThrowOnError
  >({
    responseType: "json",
    url: "/api/admin/instruction-evaluations",
    ...options,
  });

/**
 * List recent mismatches across runs
 */
export const listInstructionMismatchesApiAdminInstructionEvaluationsMismatchesGet =
  <ThrowOnError extends boolean = false>(
    options?: Options<
      ListInstructionMismatchesApiAdminInstructionEvaluationsMismatchesGetData,
      ThrowOnError
    >,
  ): RequestResult<
    ListInstructionMismatchesApiAdminInstructionEvaluationsMismatchesGetResponses,
    ListInstructionMismatchesApiAdminInstructionEvaluationsMismatchesGetErrors,
    ThrowOnError
  > =>
    (options?.client ?? client).get<
      ListInstructionMismatchesApiAdminInstructionEvaluationsMismatchesGetResponses,
      ListInstructionMismatchesApiAdminInstructionEvaluationsMismatchesGetErrors,
      ThrowOnError
    >({
      responseType: "json",
      url: "/api/admin/instruction-evaluations/mismatches",
      ...options,
    });

/**
 * Delete runs older than retention window
 */
export const purgeInstructionEvaluationsApiAdminInstructionEvaluationsPurgeExpiredPost =
  <ThrowOnError extends boolean = false>(
    options?: Options<
      PurgeInstructionEvaluationsApiAdminInstructionEvaluationsPurgeExpiredPostData,
      ThrowOnError
    >,
  ): RequestResult<
    PurgeInstructionEvaluationsApiAdminInstructionEvaluationsPurgeExpiredPostResponses,
    PurgeInstructionEvaluationsApiAdminInstructionEvaluationsPurgeExpiredPostErrors,
    ThrowOnError
  > =>
    (options?.client ?? client).post<
      PurgeInstructionEvaluationsApiAdminInstructionEvaluationsPurgeExpiredPostResponses,
      PurgeInstructionEvaluationsApiAdminInstructionEvaluationsPurgeExpiredPostErrors,
      ThrowOnError
    >({
      responseType: "json",
      url: "/api/admin/instruction-evaluations/purge-expired",
      ...options,
    });

/**
 * Get one evaluation run with related rows
 */
export const getInstructionEvaluationApiAdminInstructionEvaluationsRunIdGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetInstructionEvaluationApiAdminInstructionEvaluationsRunIdGetData,
    ThrowOnError
  >,
): RequestResult<
  GetInstructionEvaluationApiAdminInstructionEvaluationsRunIdGetResponses,
  GetInstructionEvaluationApiAdminInstructionEvaluationsRunIdGetErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetInstructionEvaluationApiAdminInstructionEvaluationsRunIdGetResponses,
    GetInstructionEvaluationApiAdminInstructionEvaluationsRunIdGetErrors,
    ThrowOnError
  >({
    responseType: "json",
    url: "/api/admin/instruction-evaluations/{run_id}",
    ...options,
  });

/**
 * Expected vs stored prompt previews (lightweight)
 */
export const getPromptDiffApiAdminInstructionEvaluationsRunIdPromptDiffGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetPromptDiffApiAdminInstructionEvaluationsRunIdPromptDiffGetData,
    ThrowOnError
  >,
): RequestResult<
  GetPromptDiffApiAdminInstructionEvaluationsRunIdPromptDiffGetResponses,
  GetPromptDiffApiAdminInstructionEvaluationsRunIdPromptDiffGetErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetPromptDiffApiAdminInstructionEvaluationsRunIdPromptDiffGetResponses,
    GetPromptDiffApiAdminInstructionEvaluationsRunIdPromptDiffGetErrors,
    ThrowOnError
  >({
    responseType: "json",
    url: "/api/admin/instruction-evaluations/{run_id}/prompt-diff",
    ...options,
  });

/**
 * Re-run validation on stored snapshot metadata
 */
export const revalidateInstructionEvaluationApiAdminInstructionEvaluationsRunIdRevalidatePost =
  <ThrowOnError extends boolean = false>(
    options: Options<
      RevalidateInstructionEvaluationApiAdminInstructionEvaluationsRunIdRevalidatePostData,
      ThrowOnError
    >,
  ): RequestResult<
    RevalidateInstructionEvaluationApiAdminInstructionEvaluationsRunIdRevalidatePostResponses,
    RevalidateInstructionEvaluationApiAdminInstructionEvaluationsRunIdRevalidatePostErrors,
    ThrowOnError
  > =>
    (options.client ?? client).post<
      RevalidateInstructionEvaluationApiAdminInstructionEvaluationsRunIdRevalidatePostResponses,
      RevalidateInstructionEvaluationApiAdminInstructionEvaluationsRunIdRevalidatePostErrors,
      ThrowOnError
    >({
      responseType: "json",
      url: "/api/admin/instruction-evaluations/{run_id}/revalidate",
      ...options,
    });

/**
 * List provider data isolation audit events
 *
 * Returns a paginated log of every enforcement event that blocked Google API data from reaching a restricted LLM provider (currently DeepSeek). Superuser access required. Provided as compliance evidence for Google OAuth verification.
 */
export const listIsolationAuditEvents = <ThrowOnError extends boolean = false>(
  options?: Options<ListIsolationAuditEventsData, ThrowOnError>,
): RequestResult<
  ListIsolationAuditEventsResponses,
  ListIsolationAuditEventsErrors,
  ThrowOnError
> =>
  (options?.client ?? client).get<
    ListIsolationAuditEventsResponses,
    ListIsolationAuditEventsErrors,
    ThrowOnError
  >({
    responseTransformer: listIsolationAuditEventsResponseTransformer,
    responseType: "json",
    url: "/api/admin/isolation-audit",
    ...options,
  });

/**
 * List Provider Configs
 */
export const listExtensionProviderConfigs = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<ListExtensionProviderConfigsData, ThrowOnError>,
): RequestResult<
  ListExtensionProviderConfigsResponses,
  ListExtensionProviderConfigsErrors,
  ThrowOnError
> =>
  (options?.client ?? client).get<
    ListExtensionProviderConfigsResponses,
    ListExtensionProviderConfigsErrors,
    ThrowOnError
  >({
    responseType: "json",
    url: "/api/admin/extension/providers",
    ...options,
  });

/**
 * Update Provider Config
 */
export const updateExtensionProviderConfig = <
  ThrowOnError extends boolean = false,
>(
  options: Options<UpdateExtensionProviderConfigData, ThrowOnError>,
): RequestResult<
  UpdateExtensionProviderConfigResponses,
  UpdateExtensionProviderConfigErrors,
  ThrowOnError
> =>
  (options.client ?? client).patch<
    UpdateExtensionProviderConfigResponses,
    UpdateExtensionProviderConfigErrors,
    ThrowOnError
  >({
    responseType: "json",
    url: "/api/admin/extension/providers/{provider_key}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * List Tool Configs
 */
export const listExtensionToolConfigs = <ThrowOnError extends boolean = false>(
  options: Options<ListExtensionToolConfigsData, ThrowOnError>,
): RequestResult<
  ListExtensionToolConfigsResponses,
  ListExtensionToolConfigsErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    ListExtensionToolConfigsResponses,
    ListExtensionToolConfigsErrors,
    ThrowOnError
  >({
    responseType: "json",
    url: "/api/admin/extension/providers/{provider_key}/tools",
    ...options,
  });

/**
 * Update Tool Config
 */
export const updateExtensionToolConfig = <ThrowOnError extends boolean = false>(
  options: Options<UpdateExtensionToolConfigData, ThrowOnError>,
): RequestResult<
  UpdateExtensionToolConfigResponses,
  UpdateExtensionToolConfigErrors,
  ThrowOnError
> =>
  (options.client ?? client).patch<
    UpdateExtensionToolConfigResponses,
    UpdateExtensionToolConfigErrors,
    ThrowOnError
  >({
    responseType: "json",
    url: "/api/admin/extension/providers/{provider_key}/tools/{tool_name}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * List Toolkits
 */
export const listExtensionToolkits = <ThrowOnError extends boolean = false>(
  options?: Options<ListExtensionToolkitsData, ThrowOnError>,
): RequestResult<
  ListExtensionToolkitsResponses,
  ListExtensionToolkitsErrors,
  ThrowOnError
> =>
  (options?.client ?? client).get<
    ListExtensionToolkitsResponses,
    ListExtensionToolkitsErrors,
    ThrowOnError
  >({
    responseType: "json",
    url: "/api/admin/extension/toolkits",
    ...options,
  });

/**
 * Activate Toolkit Endpoint
 */
export const activateExtensionToolkit = <ThrowOnError extends boolean = false>(
  options: Options<ActivateExtensionToolkitData, ThrowOnError>,
): RequestResult<
  ActivateExtensionToolkitResponses,
  ActivateExtensionToolkitErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    ActivateExtensionToolkitResponses,
    ActivateExtensionToolkitErrors,
    ThrowOnError
  >({
    responseType: "json",
    url: "/api/admin/extension/providers/{provider_key}/activate-toolkit",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Register Webhook Subscription
 *
 * Point this Composio project's webhook at /api/extension/webhook of this deployment.
 *
 * A project has ONE webhook subscription, and registering replaces its URL: run this only from the
 * deployment that should receive the project's trigger events (use a separate Composio project per
 * environment).
 */
export const registerExtensionWebhookSubscription = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<RegisterExtensionWebhookSubscriptionData, ThrowOnError>,
): RequestResult<
  RegisterExtensionWebhookSubscriptionResponses,
  RegisterExtensionWebhookSubscriptionErrors,
  ThrowOnError
> =>
  (options?.client ?? client).post<
    RegisterExtensionWebhookSubscriptionResponses,
    RegisterExtensionWebhookSubscriptionErrors,
    ThrowOnError
  >({
    responseType: "json",
    url: "/api/admin/extension/webhook-subscription",
    ...options,
  });

/**
 * List Servers
 */
export const listAdminMcpServers = <ThrowOnError extends boolean = false>(
  options?: Options<ListAdminMcpServersData, ThrowOnError>,
): RequestResult<
  ListAdminMcpServersResponses,
  ListAdminMcpServersErrors,
  ThrowOnError
> =>
  (options?.client ?? client).get<
    ListAdminMcpServersResponses,
    ListAdminMcpServersErrors,
    ThrowOnError
  >({
    responseTransformer: listAdminMcpServersResponseTransformer,
    responseType: "json",
    url: "/api/admin/mcp/servers",
    ...options,
  });

/**
 * Create Server
 */
export const createAdminMcpServer = <ThrowOnError extends boolean = false>(
  options: Options<CreateAdminMcpServerData, ThrowOnError>,
): RequestResult<
  CreateAdminMcpServerResponses,
  CreateAdminMcpServerErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    CreateAdminMcpServerResponses,
    CreateAdminMcpServerErrors,
    ThrowOnError
  >({
    responseTransformer: createAdminMcpServerResponseTransformer,
    responseType: "json",
    url: "/api/admin/mcp/servers",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Delete Server
 */
export const deleteAdminMcpServer = <ThrowOnError extends boolean = false>(
  options: Options<DeleteAdminMcpServerData, ThrowOnError>,
): RequestResult<
  DeleteAdminMcpServerResponses,
  DeleteAdminMcpServerErrors,
  ThrowOnError
> =>
  (options.client ?? client).delete<
    DeleteAdminMcpServerResponses,
    DeleteAdminMcpServerErrors,
    ThrowOnError
  >({ url: "/api/admin/mcp/servers/{server_id}", ...options });

/**
 * Update Server
 */
export const updateAdminMcpServer = <ThrowOnError extends boolean = false>(
  options: Options<UpdateAdminMcpServerData, ThrowOnError>,
): RequestResult<
  UpdateAdminMcpServerResponses,
  UpdateAdminMcpServerErrors,
  ThrowOnError
> =>
  (options.client ?? client).patch<
    UpdateAdminMcpServerResponses,
    UpdateAdminMcpServerErrors,
    ThrowOnError
  >({
    responseTransformer: updateAdminMcpServerResponseTransformer,
    responseType: "json",
    url: "/api/admin/mcp/servers/{server_id}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * List Tools
 */
export const listAdminMcpTools = <ThrowOnError extends boolean = false>(
  options: Options<ListAdminMcpToolsData, ThrowOnError>,
): RequestResult<
  ListAdminMcpToolsResponses,
  ListAdminMcpToolsErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    ListAdminMcpToolsResponses,
    ListAdminMcpToolsErrors,
    ThrowOnError
  >({
    responseTransformer: listAdminMcpToolsResponseTransformer,
    responseType: "json",
    url: "/api/admin/mcp/servers/{server_id}/tools",
    ...options,
  });

/**
 * Update Tool
 */
export const updateAdminMcpTool = <ThrowOnError extends boolean = false>(
  options: Options<UpdateAdminMcpToolData, ThrowOnError>,
): RequestResult<
  UpdateAdminMcpToolResponses,
  UpdateAdminMcpToolErrors,
  ThrowOnError
> =>
  (options.client ?? client).patch<
    UpdateAdminMcpToolResponses,
    UpdateAdminMcpToolErrors,
    ThrowOnError
  >({
    responseTransformer: updateAdminMcpToolResponseTransformer,
    responseType: "json",
    url: "/api/admin/mcp/servers/{server_id}/tools/{tool_name}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Review Tools
 */
export const reviewAdminMcpTools = <ThrowOnError extends boolean = false>(
  options: Options<ReviewAdminMcpToolsData, ThrowOnError>,
): RequestResult<
  ReviewAdminMcpToolsResponses,
  ReviewAdminMcpToolsErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    ReviewAdminMcpToolsResponses,
    ReviewAdminMcpToolsErrors,
    ThrowOnError
  >({
    responseType: "json",
    url: "/api/admin/mcp/servers/{server_id}/tools/review",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Accept Ai Suggestions
 *
 * Adopt the model's more lenient levels for these tools (or all that have one) as the admin's own decision.
 */
export const acceptAdminMcpAiSuggestions = <
  ThrowOnError extends boolean = false,
>(
  options: Options<AcceptAdminMcpAiSuggestionsData, ThrowOnError>,
): RequestResult<
  AcceptAdminMcpAiSuggestionsResponses,
  AcceptAdminMcpAiSuggestionsErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    AcceptAdminMcpAiSuggestionsResponses,
    AcceptAdminMcpAiSuggestionsErrors,
    ThrowOnError
  >({
    responseType: "json",
    url: "/api/admin/mcp/servers/{server_id}/tools/accept-ai",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * List Snapshots
 */
export const listAdminMcpSnapshots = <ThrowOnError extends boolean = false>(
  options: Options<ListAdminMcpSnapshotsData, ThrowOnError>,
): RequestResult<
  ListAdminMcpSnapshotsResponses,
  ListAdminMcpSnapshotsErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    ListAdminMcpSnapshotsResponses,
    ListAdminMcpSnapshotsErrors,
    ThrowOnError
  >({
    responseTransformer: listAdminMcpSnapshotsResponseTransformer,
    responseType: "json",
    url: "/api/admin/mcp/servers/{server_id}/snapshots",
    ...options,
  });

/**
 * List Discovery Candidates
 *
 * Your own connections to this server: the ones you could use for discovery.
 */
export const listAdminMcpDiscoveryCandidates = <
  ThrowOnError extends boolean = false,
>(
  options: Options<ListAdminMcpDiscoveryCandidatesData, ThrowOnError>,
): RequestResult<
  ListAdminMcpDiscoveryCandidatesResponses,
  ListAdminMcpDiscoveryCandidatesErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    ListAdminMcpDiscoveryCandidatesResponses,
    ListAdminMcpDiscoveryCandidatesErrors,
    ThrowOnError
  >({
    responseType: "json",
    url: "/api/admin/mcp/servers/{server_id}/discovery-candidates",
    ...options,
  });

/**
 * Set Discovery Connection
 *
 * Use one of your own connections to read this server's tools (or clear it with null).
 */
export const setAdminMcpDiscoveryConnection = <
  ThrowOnError extends boolean = false,
>(
  options: Options<SetAdminMcpDiscoveryConnectionData, ThrowOnError>,
): RequestResult<
  SetAdminMcpDiscoveryConnectionResponses,
  SetAdminMcpDiscoveryConnectionErrors,
  ThrowOnError
> =>
  (options.client ?? client).put<
    SetAdminMcpDiscoveryConnectionResponses,
    SetAdminMcpDiscoveryConnectionErrors,
    ThrowOnError
  >({
    responseTransformer: setAdminMcpDiscoveryConnectionResponseTransformer,
    responseType: "json",
    url: "/api/admin/mcp/servers/{server_id}/discovery-connection",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Discover Server
 *
 * Read this server's tools now. Waits for the result (up to a minute and a half).
 */
export const runAdminMcpServerDiscovery = <
  ThrowOnError extends boolean = false,
>(
  options: Options<RunAdminMcpServerDiscoveryData, ThrowOnError>,
): RequestResult<
  RunAdminMcpServerDiscoveryResponses,
  RunAdminMcpServerDiscoveryErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    RunAdminMcpServerDiscoveryResponses,
    RunAdminMcpServerDiscoveryErrors,
    ThrowOnError
  >({
    responseTransformer: runAdminMcpServerDiscoveryResponseTransformer,
    responseType: "json",
    url: "/api/admin/mcp/servers/{server_id}/discover",
    ...options,
  });

/**
 * Discover All
 *
 * Start a run over every enabled server in the background. Poll the server list for each one's status.
 */
export const runAdminMcpDiscovery = <ThrowOnError extends boolean = false>(
  options?: Options<RunAdminMcpDiscoveryData, ThrowOnError>,
): RequestResult<
  RunAdminMcpDiscoveryResponses,
  RunAdminMcpDiscoveryErrors,
  ThrowOnError
> =>
  (options?.client ?? client).post<
    RunAdminMcpDiscoveryResponses,
    RunAdminMcpDiscoveryErrors,
    ThrowOnError
  >({
    responseType: "json",
    url: "/api/admin/mcp/discover",
    ...options,
  });

/**
 * List Platform Settings
 */
export const listPlatformSettings = <ThrowOnError extends boolean = false>(
  options?: Options<ListPlatformSettingsData, ThrowOnError>,
): RequestResult<
  ListPlatformSettingsResponses,
  ListPlatformSettingsErrors,
  ThrowOnError
> =>
  (options?.client ?? client).get<
    ListPlatformSettingsResponses,
    ListPlatformSettingsErrors,
    ThrowOnError
  >({
    responseTransformer: listPlatformSettingsResponseTransformer,
    responseType: "json",
    url: "/api/admin/platform-settings",
    ...options,
  });

/**
 * Reset Platform Setting
 */
export const resetPlatformSetting = <ThrowOnError extends boolean = false>(
  options: Options<ResetPlatformSettingData, ThrowOnError>,
): RequestResult<
  ResetPlatformSettingResponses,
  ResetPlatformSettingErrors,
  ThrowOnError
> =>
  (options.client ?? client).delete<
    ResetPlatformSettingResponses,
    ResetPlatformSettingErrors,
    ThrowOnError
  >({ url: "/api/admin/platform-settings/{key}", ...options });

/**
 * Set Platform Setting
 */
export const setPlatformSetting = <ThrowOnError extends boolean = false>(
  options: Options<SetPlatformSettingData, ThrowOnError>,
): RequestResult<
  SetPlatformSettingResponses,
  SetPlatformSettingErrors,
  ThrowOnError
> =>
  (options.client ?? client).put<
    SetPlatformSettingResponses,
    SetPlatformSettingErrors,
    ThrowOnError
  >({
    responseTransformer: setPlatformSettingResponseTransformer,
    responseType: "json",
    url: "/api/admin/platform-settings/{key}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * List Connection Types
 */
export const listAdminConnectionTypes = <ThrowOnError extends boolean = false>(
  options?: Options<ListAdminConnectionTypesData, ThrowOnError>,
): RequestResult<
  ListAdminConnectionTypesResponses,
  ListAdminConnectionTypesErrors,
  ThrowOnError
> =>
  (options?.client ?? client).get<
    ListAdminConnectionTypesResponses,
    ListAdminConnectionTypesErrors,
    ThrowOnError
  >({
    responseType: "json",
    url: "/api/admin/connection-types",
    ...options,
  });

/**
 * Update Connection Type
 */
export const updateAdminConnectionType = <ThrowOnError extends boolean = false>(
  options: Options<UpdateAdminConnectionTypeData, ThrowOnError>,
): RequestResult<
  UpdateAdminConnectionTypeResponses,
  UpdateAdminConnectionTypeErrors,
  ThrowOnError
> =>
  (options.client ?? client).patch<
    UpdateAdminConnectionTypeResponses,
    UpdateAdminConnectionTypeErrors,
    ThrowOnError
  >({
    responseType: "json",
    url: "/api/admin/connection-types/{provider_key}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * List Audit Log
 */
export const listAdminAuditLog = <ThrowOnError extends boolean = false>(
  options?: Options<ListAdminAuditLogData, ThrowOnError>,
): RequestResult<
  ListAdminAuditLogResponses,
  ListAdminAuditLogErrors,
  ThrowOnError
> =>
  (options?.client ?? client).get<
    ListAdminAuditLogResponses,
    ListAdminAuditLogErrors,
    ThrowOnError
  >({
    responseTransformer: listAdminAuditLogResponseTransformer,
    responseType: "json",
    url: "/api/admin/audit-log",
    ...options,
  });

/**
 * List Billing Plans
 */
export const listBillingPlans = <ThrowOnError extends boolean = false>(
  options?: Options<ListBillingPlansData, ThrowOnError>,
): RequestResult<
  ListBillingPlansResponses,
  ListBillingPlansErrors,
  ThrowOnError
> =>
  (options?.client ?? client).get<
    ListBillingPlansResponses,
    ListBillingPlansErrors,
    ThrowOnError
  >({
    responseTransformer: listBillingPlansResponseTransformer,
    responseType: "json",
    url: "/api/admin/billing/plans",
    ...options,
  });

/**
 * List Billing Pricing
 */
export const listBillingPricing = <ThrowOnError extends boolean = false>(
  options?: Options<ListBillingPricingData, ThrowOnError>,
): RequestResult<
  ListBillingPricingResponses,
  ListBillingPricingErrors,
  ThrowOnError
> =>
  (options?.client ?? client).get<
    ListBillingPricingResponses,
    ListBillingPricingErrors,
    ThrowOnError
  >({
    responseTransformer: listBillingPricingResponseTransformer,
    responseType: "json",
    url: "/api/admin/billing/pricing",
    ...options,
  });

/**
 * Create Billing Price
 */
export const createBillingPrice = <ThrowOnError extends boolean = false>(
  options: Options<CreateBillingPriceData, ThrowOnError>,
): RequestResult<
  CreateBillingPriceResponses,
  CreateBillingPriceErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    CreateBillingPriceResponses,
    CreateBillingPriceErrors,
    ThrowOnError
  >({
    responseTransformer: createBillingPriceResponseTransformer,
    responseType: "json",
    url: "/api/admin/billing/pricing",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Create Billing Plan Version
 */
export const createBillingPlanVersion = <ThrowOnError extends boolean = false>(
  options: Options<CreateBillingPlanVersionData, ThrowOnError>,
): RequestResult<
  CreateBillingPlanVersionResponses,
  CreateBillingPlanVersionErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    CreateBillingPlanVersionResponses,
    CreateBillingPlanVersionErrors,
    ThrowOnError
  >({
    responseTransformer: createBillingPlanVersionResponseTransformer,
    responseType: "json",
    url: "/api/admin/billing/plans/{key}/versions",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * List Categories
 */
export const adminListSystemAgentCategories = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<AdminListSystemAgentCategoriesData, ThrowOnError>,
): RequestResult<
  AdminListSystemAgentCategoriesResponses,
  AdminListSystemAgentCategoriesErrors,
  ThrowOnError
> =>
  (options?.client ?? client).get<
    AdminListSystemAgentCategoriesResponses,
    AdminListSystemAgentCategoriesErrors,
    ThrowOnError
  >({
    responseType: "json",
    url: "/api/admin/system-agents/categories",
    ...options,
  });

/**
 * Create Category
 */
export const adminCreateSystemAgentCategory = <
  ThrowOnError extends boolean = false,
>(
  options: Options<AdminCreateSystemAgentCategoryData, ThrowOnError>,
): RequestResult<
  AdminCreateSystemAgentCategoryResponses,
  AdminCreateSystemAgentCategoryErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    AdminCreateSystemAgentCategoryResponses,
    AdminCreateSystemAgentCategoryErrors,
    ThrowOnError
  >({
    responseType: "json",
    url: "/api/admin/system-agents/categories",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Delete Category
 */
export const adminDeleteSystemAgentCategory = <
  ThrowOnError extends boolean = false,
>(
  options: Options<AdminDeleteSystemAgentCategoryData, ThrowOnError>,
): RequestResult<
  AdminDeleteSystemAgentCategoryResponses,
  AdminDeleteSystemAgentCategoryErrors,
  ThrowOnError
> =>
  (options.client ?? client).delete<
    AdminDeleteSystemAgentCategoryResponses,
    AdminDeleteSystemAgentCategoryErrors,
    ThrowOnError
  >({ url: "/api/admin/system-agents/categories/{slug}", ...options });

/**
 * Update Category
 */
export const adminUpdateSystemAgentCategory = <
  ThrowOnError extends boolean = false,
>(
  options: Options<AdminUpdateSystemAgentCategoryData, ThrowOnError>,
): RequestResult<
  AdminUpdateSystemAgentCategoryResponses,
  AdminUpdateSystemAgentCategoryErrors,
  ThrowOnError
> =>
  (options.client ?? client).patch<
    AdminUpdateSystemAgentCategoryResponses,
    AdminUpdateSystemAgentCategoryErrors,
    ThrowOnError
  >({
    responseType: "json",
    url: "/api/admin/system-agents/categories/{slug}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Put Category Translation
 */
export const adminPutSystemAgentCategoryTranslation = <
  ThrowOnError extends boolean = false,
>(
  options: Options<AdminPutSystemAgentCategoryTranslationData, ThrowOnError>,
): RequestResult<
  AdminPutSystemAgentCategoryTranslationResponses,
  AdminPutSystemAgentCategoryTranslationErrors,
  ThrowOnError
> =>
  (options.client ?? client).put<
    AdminPutSystemAgentCategoryTranslationResponses,
    AdminPutSystemAgentCategoryTranslationErrors,
    ThrowOnError
  >({
    responseType: "json",
    url: "/api/admin/system-agents/categories/{slug}/translations/{locale}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * List Templates
 */
export const adminListSystemAgentTemplates = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<AdminListSystemAgentTemplatesData, ThrowOnError>,
): RequestResult<
  AdminListSystemAgentTemplatesResponses,
  AdminListSystemAgentTemplatesErrors,
  ThrowOnError
> =>
  (options?.client ?? client).get<
    AdminListSystemAgentTemplatesResponses,
    AdminListSystemAgentTemplatesErrors,
    ThrowOnError
  >({
    responseType: "json",
    url: "/api/admin/system-agents",
    ...options,
  });

/**
 * Create Template
 */
export const adminCreateSystemAgentTemplate = <
  ThrowOnError extends boolean = false,
>(
  options: Options<AdminCreateSystemAgentTemplateData, ThrowOnError>,
): RequestResult<
  AdminCreateSystemAgentTemplateResponses,
  AdminCreateSystemAgentTemplateErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    AdminCreateSystemAgentTemplateResponses,
    AdminCreateSystemAgentTemplateErrors,
    ThrowOnError
  >({
    responseType: "json",
    url: "/api/admin/system-agents",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Get Template
 */
export const adminGetSystemAgentTemplate = <
  ThrowOnError extends boolean = false,
>(
  options: Options<AdminGetSystemAgentTemplateData, ThrowOnError>,
): RequestResult<
  AdminGetSystemAgentTemplateResponses,
  AdminGetSystemAgentTemplateErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    AdminGetSystemAgentTemplateResponses,
    AdminGetSystemAgentTemplateErrors,
    ThrowOnError
  >({
    responseType: "json",
    url: "/api/admin/system-agents/{template_id}",
    ...options,
  });

/**
 * Update Template
 */
export const adminUpdateSystemAgentTemplate = <
  ThrowOnError extends boolean = false,
>(
  options: Options<AdminUpdateSystemAgentTemplateData, ThrowOnError>,
): RequestResult<
  AdminUpdateSystemAgentTemplateResponses,
  AdminUpdateSystemAgentTemplateErrors,
  ThrowOnError
> =>
  (options.client ?? client).patch<
    AdminUpdateSystemAgentTemplateResponses,
    AdminUpdateSystemAgentTemplateErrors,
    ThrowOnError
  >({
    responseType: "json",
    url: "/api/admin/system-agents/{template_id}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Publish Template
 */
export const adminPublishSystemAgentTemplate = <
  ThrowOnError extends boolean = false,
>(
  options: Options<AdminPublishSystemAgentTemplateData, ThrowOnError>,
): RequestResult<
  AdminPublishSystemAgentTemplateResponses,
  AdminPublishSystemAgentTemplateErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    AdminPublishSystemAgentTemplateResponses,
    AdminPublishSystemAgentTemplateErrors,
    ThrowOnError
  >({
    responseType: "json",
    url: "/api/admin/system-agents/{template_id}/publish",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Unpublish Template
 */
export const adminUnpublishSystemAgentTemplate = <
  ThrowOnError extends boolean = false,
>(
  options: Options<AdminUnpublishSystemAgentTemplateData, ThrowOnError>,
): RequestResult<
  AdminUnpublishSystemAgentTemplateResponses,
  AdminUnpublishSystemAgentTemplateErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    AdminUnpublishSystemAgentTemplateResponses,
    AdminUnpublishSystemAgentTemplateErrors,
    ThrowOnError
  >({
    responseType: "json",
    url: "/api/admin/system-agents/{template_id}/unpublish",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Archive Template
 */
export const adminArchiveSystemAgentTemplate = <
  ThrowOnError extends boolean = false,
>(
  options: Options<AdminArchiveSystemAgentTemplateData, ThrowOnError>,
): RequestResult<
  AdminArchiveSystemAgentTemplateResponses,
  AdminArchiveSystemAgentTemplateErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    AdminArchiveSystemAgentTemplateResponses,
    AdminArchiveSystemAgentTemplateErrors,
    ThrowOnError
  >({
    responseType: "json",
    url: "/api/admin/system-agents/{template_id}/archive",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Duplicate Template
 */
export const adminDuplicateSystemAgentTemplate = <
  ThrowOnError extends boolean = false,
>(
  options: Options<AdminDuplicateSystemAgentTemplateData, ThrowOnError>,
): RequestResult<
  AdminDuplicateSystemAgentTemplateResponses,
  AdminDuplicateSystemAgentTemplateErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    AdminDuplicateSystemAgentTemplateResponses,
    AdminDuplicateSystemAgentTemplateErrors,
    ThrowOnError
  >({
    responseType: "json",
    url: "/api/admin/system-agents/{template_id}/duplicate",
    ...options,
  });

/**
 * List Versions
 */
export const adminListSystemAgentTemplateVersions = <
  ThrowOnError extends boolean = false,
>(
  options: Options<AdminListSystemAgentTemplateVersionsData, ThrowOnError>,
): RequestResult<
  AdminListSystemAgentTemplateVersionsResponses,
  AdminListSystemAgentTemplateVersionsErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    AdminListSystemAgentTemplateVersionsResponses,
    AdminListSystemAgentTemplateVersionsErrors,
    ThrowOnError
  >({
    responseType: "json",
    url: "/api/admin/system-agents/{template_id}/versions",
    ...options,
  });

/**
 * Restore Version
 */
export const adminRestoreSystemAgentTemplateVersion = <
  ThrowOnError extends boolean = false,
>(
  options: Options<AdminRestoreSystemAgentTemplateVersionData, ThrowOnError>,
): RequestResult<
  AdminRestoreSystemAgentTemplateVersionResponses,
  AdminRestoreSystemAgentTemplateVersionErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    AdminRestoreSystemAgentTemplateVersionResponses,
    AdminRestoreSystemAgentTemplateVersionErrors,
    ThrowOnError
  >({
    responseType: "json",
    url: "/api/admin/system-agents/{template_id}/versions/{version_no}/restore",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Put Translation
 */
export const adminPutSystemAgentTemplateTranslation = <
  ThrowOnError extends boolean = false,
>(
  options: Options<AdminPutSystemAgentTemplateTranslationData, ThrowOnError>,
): RequestResult<
  AdminPutSystemAgentTemplateTranslationResponses,
  AdminPutSystemAgentTemplateTranslationErrors,
  ThrowOnError
> =>
  (options.client ?? client).put<
    AdminPutSystemAgentTemplateTranslationResponses,
    AdminPutSystemAgentTemplateTranslationErrors,
    ThrowOnError
  >({
    responseType: "json",
    url: "/api/admin/system-agents/{template_id}/translations/{locale}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Put Content
 */
export const adminPutSystemAgentTemplateContent = <
  ThrowOnError extends boolean = false,
>(
  options: Options<AdminPutSystemAgentTemplateContentData, ThrowOnError>,
): RequestResult<
  AdminPutSystemAgentTemplateContentResponses,
  AdminPutSystemAgentTemplateContentErrors,
  ThrowOnError
> =>
  (options.client ?? client).put<
    AdminPutSystemAgentTemplateContentResponses,
    AdminPutSystemAgentTemplateContentErrors,
    ThrowOnError
  >({
    responseType: "json",
    url: "/api/admin/system-agents/{template_id}/content/{locale}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Get Draft
 */
export const adminGetSystemAgentTemplateDraft = <
  ThrowOnError extends boolean = false,
>(
  options: Options<AdminGetSystemAgentTemplateDraftData, ThrowOnError>,
): RequestResult<
  AdminGetSystemAgentTemplateDraftResponses,
  AdminGetSystemAgentTemplateDraftErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    AdminGetSystemAgentTemplateDraftResponses,
    AdminGetSystemAgentTemplateDraftErrors,
    ThrowOnError
  >({
    responseType: "json",
    url: "/api/admin/system-agents/{template_id}/draft",
    ...options,
  });

/**
 * Update Draft
 */
export const adminUpdateSystemAgentTemplateDraft = <
  ThrowOnError extends boolean = false,
>(
  options: Options<AdminUpdateSystemAgentTemplateDraftData, ThrowOnError>,
): RequestResult<
  AdminUpdateSystemAgentTemplateDraftResponses,
  AdminUpdateSystemAgentTemplateDraftErrors,
  ThrowOnError
> =>
  (options.client ?? client).patch<
    AdminUpdateSystemAgentTemplateDraftResponses,
    AdminUpdateSystemAgentTemplateDraftErrors,
    ThrowOnError
  >({
    responseType: "json",
    url: "/api/admin/system-agents/{template_id}/draft",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Deployed versions of every platform component
 *
 * Returns the build identity (app version, image commit SHA, Python version, host, start time) of the responding API process, the database's Alembic revision, and every API process and queue worker currently publishing to the fleet presence registry, and the Kubernetes pods of this namespace with their spec image and pulled digest. Superuser access required. Not cacheable.
 */
export const getPlatformVersions = <ThrowOnError extends boolean = false>(
  options?: Options<GetPlatformVersionsData, ThrowOnError>,
): RequestResult<
  GetPlatformVersionsResponses,
  GetPlatformVersionsErrors,
  ThrowOnError
> =>
  (options?.client ?? client).get<
    GetPlatformVersionsResponses,
    GetPlatformVersionsErrors,
    ThrowOnError
  >({
    responseTransformer: getPlatformVersionsResponseTransformer,
    responseType: "json",
    url: "/api/admin/versions",
    ...options,
  });

/**
 * Enroll
 */
export const enrollExtensionConnection = <ThrowOnError extends boolean = false>(
  options: Options<EnrollExtensionConnectionData, ThrowOnError>,
): RequestResult<
  EnrollExtensionConnectionResponses,
  EnrollExtensionConnectionErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    EnrollExtensionConnectionResponses,
    EnrollExtensionConnectionErrors,
    ThrowOnError
  >({
    responseType: "json",
    url: "/api/admin/extension/enrollment",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Revoke
 */
export const revokeExtensionConnection = <ThrowOnError extends boolean = false>(
  options: Options<RevokeExtensionConnectionData, ThrowOnError>,
): RequestResult<
  RevokeExtensionConnectionResponses,
  RevokeExtensionConnectionErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    RevokeExtensionConnectionResponses,
    RevokeExtensionConnectionErrors,
    ThrowOnError
  >({
    responseType: "json",
    url: "/api/admin/extension/enrollment/revoke",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * List MCP servers
 *
 * List MCP servers for the current user and agent.
 */
export const listMcp = <ThrowOnError extends boolean = false>(
  options: Options<ListMcpData, ThrowOnError>,
): RequestResult<ListMcpResponses, ListMcpErrors, ThrowOnError> =>
  (options.client ?? client).get<ListMcpResponses, ListMcpErrors, ThrowOnError>(
    {
      responseType: "json",
      url: "/api/mcp",
      ...options,
    },
  );

/**
 * Create MCP server
 *
 * Create an MCP server for the agent.
 */
export const createMcp = <ThrowOnError extends boolean = false>(
  options: Options<CreateMcpData, ThrowOnError>,
): RequestResult<CreateMcpResponses, CreateMcpErrors, ThrowOnError> =>
  (options.client ?? client).post<
    CreateMcpResponses,
    CreateMcpErrors,
    ThrowOnError
  >({
    responseType: "json",
    url: "/api/mcp",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Probe a remote MCP server
 *
 * Detect transport and whether the server needs OAuth, a token, or nothing.
 */
export const probeMcp = <ThrowOnError extends boolean = false>(
  options: Options<ProbeMcpData, ThrowOnError>,
): RequestResult<ProbeMcpResponses, ProbeMcpErrors, ThrowOnError> =>
  (options.client ?? client).post<
    ProbeMcpResponses,
    ProbeMcpErrors,
    ThrowOnError
  >({
    responseType: "json",
    url: "/api/mcp/probe",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * MCP server catalog
 *
 * The whole curated catalog. Entries whose OAuth app is not configured yet are flagged available=false. Servers outside the catalog are requested through a support ticket.
 */
export const listMcpCatalog = <ThrowOnError extends boolean = false>(
  options?: Options<ListMcpCatalogData, ThrowOnError>,
): RequestResult<ListMcpCatalogResponses, ListMcpCatalogErrors, ThrowOnError> =>
  (options?.client ?? client).get<
    ListMcpCatalogResponses,
    ListMcpCatalogErrors,
    ThrowOnError
  >({
    responseType: "json",
    url: "/api/mcp/catalog",
    ...options,
  });

/**
 * Tools of a catalog server
 *
 * What a catalog server offers (name, description, level) as of its last discovery, so people can see it before connecting. Reads and writes are labelled; new or changed tools are flagged.
 */
export const listMcpCatalogTools = <ThrowOnError extends boolean = false>(
  options: Options<ListMcpCatalogToolsData, ThrowOnError>,
): RequestResult<
  ListMcpCatalogToolsResponses,
  ListMcpCatalogToolsErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    ListMcpCatalogToolsResponses,
    ListMcpCatalogToolsErrors,
    ThrowOnError
  >({
    responseTransformer: listMcpCatalogToolsResponseTransformer,
    responseType: "json",
    url: "/api/mcp/catalog/{entry_id}/tools",
    ...options,
  });

/**
 * Logo of a catalog server
 *
 * The logo we fetched and validated for this catalog server, served from our own origin so people's browsers never contact a third party for it.
 */
export const getMcpCatalogIcon = <ThrowOnError extends boolean = false>(
  options: Options<GetMcpCatalogIconData, ThrowOnError>,
): RequestResult<
  GetMcpCatalogIconResponses,
  GetMcpCatalogIconErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetMcpCatalogIconResponses,
    GetMcpCatalogIconErrors,
    ThrowOnError
  >({
    responseType: "blob",
    url: "/api/mcp/catalog/{entry_id}/icon",
    ...options,
  });

/**
 * Start MCP OAuth
 *
 * Discover the server's authorization server, register, and return the consent URL to open.
 */
export const startMcpOauth = <ThrowOnError extends boolean = false>(
  options: Options<StartMcpOauthData, ThrowOnError>,
): RequestResult<StartMcpOauthResponses, StartMcpOauthErrors, ThrowOnError> =>
  (options.client ?? client).post<
    StartMcpOauthResponses,
    StartMcpOauthErrors,
    ThrowOnError
  >({
    responseType: "json",
    url: "/api/mcp/{server_id}/oauth/start",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Delete MCP server
 *
 * Delete an MCP server.
 */
export const deleteMcp = <ThrowOnError extends boolean = false>(
  options: Options<DeleteMcpData, ThrowOnError>,
): RequestResult<DeleteMcpResponses, DeleteMcpErrors, ThrowOnError> =>
  (options.client ?? client).delete<
    DeleteMcpResponses,
    DeleteMcpErrors,
    ThrowOnError
  >({
    responseType: "json",
    url: "/api/mcp/{server_id}",
    ...options,
  });

/**
 * Get MCP server
 *
 * Get one MCP server by ID.
 */
export const getMcp = <ThrowOnError extends boolean = false>(
  options: Options<GetMcpData, ThrowOnError>,
): RequestResult<GetMcpResponses, GetMcpErrors, ThrowOnError> =>
  (options.client ?? client).get<GetMcpResponses, GetMcpErrors, ThrowOnError>({
    responseType: "json",
    url: "/api/mcp/{server_id}",
    ...options,
  });

/**
 * Update MCP server
 *
 * Update an MCP server.
 */
export const updateMcp = <ThrowOnError extends boolean = false>(
  options: Options<UpdateMcpData, ThrowOnError>,
): RequestResult<UpdateMcpResponses, UpdateMcpErrors, ThrowOnError> =>
  (options.client ?? client).patch<
    UpdateMcpResponses,
    UpdateMcpErrors,
    ThrowOnError
  >({
    responseType: "json",
    url: "/api/mcp/{server_id}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * List MCP tools
 *
 * List tools exposed by the MCP server.
 */
export const listMcpTools = <ThrowOnError extends boolean = false>(
  options: Options<ListMcpToolsData, ThrowOnError>,
): RequestResult<ListMcpToolsResponses, ListMcpToolsErrors, ThrowOnError> =>
  (options.client ?? client).get<
    ListMcpToolsResponses,
    ListMcpToolsErrors,
    ThrowOnError
  >({
    responseType: "json",
    url: "/api/mcp/{server_id}/tools",
    ...options,
  });

/**
 * List MCP resources
 *
 * List resources exposed by the MCP server.
 */
export const listMcpResources = <ThrowOnError extends boolean = false>(
  options: Options<ListMcpResourcesData, ThrowOnError>,
): RequestResult<
  ListMcpResourcesResponses,
  ListMcpResourcesErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    ListMcpResourcesResponses,
    ListMcpResourcesErrors,
    ThrowOnError
  >({
    responseType: "json",
    url: "/api/mcp/{server_id}/resources",
    ...options,
  });

/**
 * Test MCP connection
 *
 * Connect to the MCP server and return list of tools and resources.
 */
export const testMcp = <ThrowOnError extends boolean = false>(
  options: Options<TestMcpData, ThrowOnError>,
): RequestResult<TestMcpResponses, TestMcpErrors, ThrowOnError> =>
  (options.client ?? client).post<
    TestMcpResponses,
    TestMcpErrors,
    ThrowOnError
  >({
    responseType: "json",
    url: "/api/mcp/{server_id}/test",
    ...options,
  });

/**
 * Get full execution trace by ID (developer only)
 *
 * Returns the complete execution trace for a single model_query ID. Includes raw user input, model response, all tool calls, LLM hop details, trigger context, linked user/agent metadata, and approval request if any. **Access is restricted to users with the 'developer' role or 'trace:read_full' permission.** This endpoint exposes PII and must not be used in user-facing flows.
 */
export const getDeveloperTrace = <ThrowOnError extends boolean = false>(
  options: Options<GetDeveloperTraceData, ThrowOnError>,
): RequestResult<
  GetDeveloperTraceResponses,
  GetDeveloperTraceErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetDeveloperTraceResponses,
    GetDeveloperTraceErrors,
    ThrowOnError
  >({
    responseType: "json",
    url: "/api/developer/trace/{trace_id}",
    ...options,
  });

/**
 * List Promotions
 */
export const listPromotionsApiAdminPromotionsGet = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<ListPromotionsApiAdminPromotionsGetData, ThrowOnError>,
): RequestResult<
  ListPromotionsApiAdminPromotionsGetResponses,
  ListPromotionsApiAdminPromotionsGetErrors,
  ThrowOnError
> =>
  (options?.client ?? client).get<
    ListPromotionsApiAdminPromotionsGetResponses,
    ListPromotionsApiAdminPromotionsGetErrors,
    ThrowOnError
  >({
    responseTransformer: listPromotionsApiAdminPromotionsGetResponseTransformer,
    responseType: "json",
    url: "/api/admin/promotions",
    ...options,
  });

/**
 * Create Promotion
 */
export const createPromotionApiAdminPromotionsPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<CreatePromotionApiAdminPromotionsPostData, ThrowOnError>,
): RequestResult<
  CreatePromotionApiAdminPromotionsPostResponses,
  CreatePromotionApiAdminPromotionsPostErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    CreatePromotionApiAdminPromotionsPostResponses,
    CreatePromotionApiAdminPromotionsPostErrors,
    ThrowOnError
  >({
    responseTransformer:
      createPromotionApiAdminPromotionsPostResponseTransformer,
    responseType: "json",
    url: "/api/admin/promotions",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Get Promotion
 */
export const getPromotionApiAdminPromotionsPromotionIdGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetPromotionApiAdminPromotionsPromotionIdGetData,
    ThrowOnError
  >,
): RequestResult<
  GetPromotionApiAdminPromotionsPromotionIdGetResponses,
  GetPromotionApiAdminPromotionsPromotionIdGetErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetPromotionApiAdminPromotionsPromotionIdGetResponses,
    GetPromotionApiAdminPromotionsPromotionIdGetErrors,
    ThrowOnError
  >({
    responseTransformer:
      getPromotionApiAdminPromotionsPromotionIdGetResponseTransformer,
    responseType: "json",
    url: "/api/admin/promotions/{promotion_id}",
    ...options,
  });

/**
 * Update Promotion
 */
export const updatePromotionApiAdminPromotionsPromotionIdPatch = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    UpdatePromotionApiAdminPromotionsPromotionIdPatchData,
    ThrowOnError
  >,
): RequestResult<
  UpdatePromotionApiAdminPromotionsPromotionIdPatchResponses,
  UpdatePromotionApiAdminPromotionsPromotionIdPatchErrors,
  ThrowOnError
> =>
  (options.client ?? client).patch<
    UpdatePromotionApiAdminPromotionsPromotionIdPatchResponses,
    UpdatePromotionApiAdminPromotionsPromotionIdPatchErrors,
    ThrowOnError
  >({
    responseTransformer:
      updatePromotionApiAdminPromotionsPromotionIdPatchResponseTransformer,
    responseType: "json",
    url: "/api/admin/promotions/{promotion_id}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Revoke Promotion
 */
export const revokePromotionApiAdminPromotionsPromotionIdRevokePost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    RevokePromotionApiAdminPromotionsPromotionIdRevokePostData,
    ThrowOnError
  >,
): RequestResult<
  RevokePromotionApiAdminPromotionsPromotionIdRevokePostResponses,
  RevokePromotionApiAdminPromotionsPromotionIdRevokePostErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    RevokePromotionApiAdminPromotionsPromotionIdRevokePostResponses,
    RevokePromotionApiAdminPromotionsPromotionIdRevokePostErrors,
    ThrowOnError
  >({
    responseTransformer:
      revokePromotionApiAdminPromotionsPromotionIdRevokePostResponseTransformer,
    responseType: "json",
    url: "/api/admin/promotions/{promotion_id}/revoke",
    ...options,
  });

/**
 * Generate Promo Link
 */
export const generatePromoLinkApiAdminPromotionsPromotionIdGenerateTokenPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GeneratePromoLinkApiAdminPromotionsPromotionIdGenerateTokenPostData,
    ThrowOnError
  >,
): RequestResult<
  GeneratePromoLinkApiAdminPromotionsPromotionIdGenerateTokenPostResponses,
  GeneratePromoLinkApiAdminPromotionsPromotionIdGenerateTokenPostErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    GeneratePromoLinkApiAdminPromotionsPromotionIdGenerateTokenPostResponses,
    GeneratePromoLinkApiAdminPromotionsPromotionIdGenerateTokenPostErrors,
    ThrowOnError
  >({
    responseType: "json",
    url: "/api/admin/promotions/{promotion_id}/generate-token",
    ...options,
  });

/**
 * List Promotion Usages
 */
export const listPromotionUsagesApiAdminPromotionsPromotionIdUsagesGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    ListPromotionUsagesApiAdminPromotionsPromotionIdUsagesGetData,
    ThrowOnError
  >,
): RequestResult<
  ListPromotionUsagesApiAdminPromotionsPromotionIdUsagesGetResponses,
  ListPromotionUsagesApiAdminPromotionsPromotionIdUsagesGetErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    ListPromotionUsagesApiAdminPromotionsPromotionIdUsagesGetResponses,
    ListPromotionUsagesApiAdminPromotionsPromotionIdUsagesGetErrors,
    ThrowOnError
  >({
    responseTransformer:
      listPromotionUsagesApiAdminPromotionsPromotionIdUsagesGetResponseTransformer,
    responseType: "json",
    url: "/api/admin/promotions/{promotion_id}/usages",
    ...options,
  });

/**
 * Vendor-invoice reconciliation (admin)
 *
 * Compare reconstructed recorded vendor costs against operator-supplied invoice figures for a calendar month.  Report-only: no writes, no balance mutations. Requires superuser session.
 */
export const adminVendorReconciliation = <ThrowOnError extends boolean = false>(
  options: Options<AdminVendorReconciliationData, ThrowOnError>,
): RequestResult<
  AdminVendorReconciliationResponses,
  AdminVendorReconciliationErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    AdminVendorReconciliationResponses,
    AdminVendorReconciliationErrors,
    ThrowOnError
  >({
    responseType: "json",
    url: "/api/admin/vendor-reconciliation",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Internal credit-ledger reconciliation (admin)
 *
 * Compare two INDEPENDENT internal records that must agree after Phase 3.1: the credit ledger (SUM credit_transactions.credits_added for usage kinds) and the work log (-SUM model_queries.credits_used).  Non-zero drift is a Phase 3.1 regression.  Report-only: no writes, no balance mutations.  This is NOT vendor-invoice reconciliation (defect L); see POST /api/admin/vendor-reconciliation for that.  Requires superuser session.
 */
export const adminInternalReconciliation = <
  ThrowOnError extends boolean = false,
>(
  options: Options<AdminInternalReconciliationData, ThrowOnError>,
): RequestResult<
  AdminInternalReconciliationResponses,
  AdminInternalReconciliationErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    AdminInternalReconciliationResponses,
    AdminInternalReconciliationErrors,
    ThrowOnError
  >({
    responseTransformer: adminInternalReconciliationResponseTransformer,
    responseType: "json",
    url: "/api/admin/internal-reconciliation",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Per-provider cost and margin rollup (admin)
 *
 * Report-only per-provider cost and margin rollup over three lenses: COGS (what the platform paid — billed=True run_cost_line rows), absorbed costs (billed=False rows, costs eaten internally), and revenue derived via the blended realized rate from actual cash and credit inflows.
 *
 * **Honesty caveats (mirror the service note):**  COGS is a LOWER BOUND — runs that die before writing any run_cost_line row are invisible here (A/F/R gap).  Revenue uses a BLENDED rate diluted by granted credits (referral_grant, developer_monthly); do NOT substitute the list rate (1 credit = $0.001).  Margin is indicative only when margin_complete=False.  No writes, no balance mutations.  Requires superuser session.
 */
export const adminCostRollup = <ThrowOnError extends boolean = false>(
  options: Options<AdminCostRollupData, ThrowOnError>,
): RequestResult<
  AdminCostRollupResponses,
  AdminCostRollupErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    AdminCostRollupResponses,
    AdminCostRollupErrors,
    ThrowOnError
  >({
    responseTransformer: adminCostRollupResponseTransformer,
    responseType: "json",
    url: "/api/admin/cost-rollup",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Credit a user back after a service incident (admin)
 *
 * Award credits to a user as incident remediation or goodwill.  Every call is idempotent: re-submitting the same ``(user_id, incident_ref)`` pair is a safe no-op — the user will not be credited twice.  The adjustment is ledgered with ``kind='make_user_whole'`` so reconciliation never sees unexplained drift.
 *
 * **Response:** ``applied=true`` means the credit was applied in this call.  ``applied=false`` means this was a dedup no-op (the user was already credited on a prior call with the same ``(user_id, incident_ref)`` pair); ``credits_added`` will be 0 in that case.  Callers MUST check ``applied`` — HTTP 200 alone does not mean the credit landed.
 *
 * **Idempotency:** the key is derived as ``derive_charge_key(fallback='make_whole:<incident_ref>:<user_id>', phase='make_whole')``.  Both ``incident_ref`` AND ``user_id`` anchor the key because the charge_key unique index is GLOBAL (not per-user).  An incident-only key would cause user 1 to consume the key for all 50 users in a 50-user incident, silently leaving users 2-50 uncredited.  The (user_id, incident_ref) pair guarantees each user gets their own independent dedup slot.
 *
 * **Amount cap:** controlled by ``billing.make_whole_max_credits_per_call`` in Admin > Platform settings.  0 = uncapped.  The cap is NOT overridable via this request body — a caller-supplied bypass defeats the purpose of the ceiling.  Change the env var and redeploy instead.
 *
 * Requires superuser session.
 */
export const adminMakeUserWhole = <ThrowOnError extends boolean = false>(
  options: Options<AdminMakeUserWholeData, ThrowOnError>,
): RequestResult<
  AdminMakeUserWholeResponses,
  AdminMakeUserWholeErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    AdminMakeUserWholeResponses,
    AdminMakeUserWholeErrors,
    ThrowOnError
  >({
    responseType: "json",
    url: "/api/admin/make-user-whole",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * List LLM provider top-ups (admin)
 */
export const adminListLlmProviderTopups = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<AdminListLlmProviderTopupsData, ThrowOnError>,
): RequestResult<
  AdminListLlmProviderTopupsResponses,
  AdminListLlmProviderTopupsErrors,
  ThrowOnError
> =>
  (options?.client ?? client).get<
    AdminListLlmProviderTopupsResponses,
    AdminListLlmProviderTopupsErrors,
    ThrowOnError
  >({
    responseTransformer: adminListLlmProviderTopupsResponseTransformer,
    responseType: "json",
    url: "/api/admin/llm-provider-topups",
    ...options,
  });

/**
 * Record an LLM provider top-up or monthly limit (admin)
 *
 * Append a ledger row used to estimate the remaining balance of providers that have no balance API.  When first putting a provider on the ledger, record its CURRENT balance as kind='balance' with effective_at=now; later money added is kind='topup'.  Groq: kind='monthly_limit' (takes precedence).  effective_at in the future is rejected.  The response's `warnings` explain rows that will not move the runway.  Requires superuser session.
 */
export const adminCreateLlmProviderTopup = <
  ThrowOnError extends boolean = false,
>(
  options: Options<AdminCreateLlmProviderTopupData, ThrowOnError>,
): RequestResult<
  AdminCreateLlmProviderTopupResponses,
  AdminCreateLlmProviderTopupErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    AdminCreateLlmProviderTopupResponses,
    AdminCreateLlmProviderTopupErrors,
    ThrowOnError
  >({
    responseTransformer: adminCreateLlmProviderTopupResponseTransformer,
    responseType: "json",
    url: "/api/admin/llm-provider-topups",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Delete an LLM provider top-up row (admin)
 *
 * Remove a mistakenly entered ledger row.  Rows are never edited in place.  Requires superuser session.
 */
export const adminDeleteLlmProviderTopup = <
  ThrowOnError extends boolean = false,
>(
  options: Options<AdminDeleteLlmProviderTopupData, ThrowOnError>,
): RequestResult<
  AdminDeleteLlmProviderTopupResponses,
  AdminDeleteLlmProviderTopupErrors,
  ThrowOnError
> =>
  (options.client ?? client).delete<
    AdminDeleteLlmProviderTopupResponses,
    AdminDeleteLlmProviderTopupErrors,
    ThrowOnError
  >({ url: "/api/admin/llm-provider-topups/{topup_id}", ...options });

/**
 * Runway for every LLM provider (admin)
 *
 * Estimated days of money left per provider, from the top-up ledger minus recorded run_cost_line.vendor_usd.  A LOWER-BOUND spend estimate: see the honesty notes in app/services/llm_provider_runway.py.  DeepSeek/OpenRouter real balances are reported by the probe job, not here.  Requires superuser session.
 */
export const adminListLlmProviderRunway = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<AdminListLlmProviderRunwayData, ThrowOnError>,
): RequestResult<
  AdminListLlmProviderRunwayResponses,
  AdminListLlmProviderRunwayErrors,
  ThrowOnError
> =>
  (options?.client ?? client).get<
    AdminListLlmProviderRunwayResponses,
    AdminListLlmProviderRunwayErrors,
    ThrowOnError
  >({
    responseTransformer: adminListLlmProviderRunwayResponseTransformer,
    responseType: "json",
    url: "/api/admin/llm-provider-runway",
    ...options,
  });

/**
 * Runway for one LLM provider (admin)
 */
export const adminGetLlmProviderRunway = <ThrowOnError extends boolean = false>(
  options: Options<AdminGetLlmProviderRunwayData, ThrowOnError>,
): RequestResult<
  AdminGetLlmProviderRunwayResponses,
  AdminGetLlmProviderRunwayErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    AdminGetLlmProviderRunwayResponses,
    AdminGetLlmProviderRunwayErrors,
    ThrowOnError
  >({
    responseTransformer: adminGetLlmProviderRunwayResponseTransformer,
    responseType: "json",
    url: "/api/admin/llm-provider-runway/{provider_key}",
    ...options,
  });

/**
 * List dead-letter cases awaiting manual review
 */
export const listPendingDeadLetterCases = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<ListPendingDeadLetterCasesData, ThrowOnError>,
): RequestResult<
  ListPendingDeadLetterCasesResponses,
  ListPendingDeadLetterCasesErrors,
  ThrowOnError
> =>
  (options?.client ?? client).get<
    ListPendingDeadLetterCasesResponses,
    ListPendingDeadLetterCasesErrors,
    ThrowOnError
  >({
    responseTransformer: listPendingDeadLetterCasesResponseTransformer,
    responseType: "json",
    url: "/api/admin/deadletters/pending",
    ...options,
  });

/**
 * Record a manual-review decision for a dead-letter case (admin)
 *
 * Decide a pending_review case: 'refund' credits the full original charge, 'stand' applies no refund, 'partial' credits body.credits (must be 1..credits_used). Refund/partial route through amake_user_whole with an idempotency key derived from the case id, so re-submitting the same decision after a client retry cannot double-refund. A case that is not pending_review (already decided) returns 409.
 */
export const decideDeadLetterCase = <ThrowOnError extends boolean = false>(
  options: Options<DecideDeadLetterCaseData, ThrowOnError>,
): RequestResult<
  DecideDeadLetterCaseResponses,
  DecideDeadLetterCaseErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    DecideDeadLetterCaseResponses,
    DecideDeadLetterCaseErrors,
    ThrowOnError
  >({
    responseType: "json",
    url: "/api/admin/deadletters/{case_id}/decide",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Twilio WhatsApp webhook (incoming message)
 *
 * Incoming WhatsApp webhook: resolve agent by To, run chat pipeline, return TwiML.
 */
export const incomingWhatsappApiTwilioWhatsappIncomingPost = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<
    IncomingWhatsappApiTwilioWhatsappIncomingPostData,
    ThrowOnError
  >,
): RequestResult<
  IncomingWhatsappApiTwilioWhatsappIncomingPostResponses,
  unknown,
  ThrowOnError
> =>
  (options?.client ?? client).post<
    IncomingWhatsappApiTwilioWhatsappIncomingPostResponses,
    unknown,
    ThrowOnError
  >({
    responseType: "json",
    url: "/api/twilio/whatsapp/incoming",
    ...options,
  });

/**
 * Whatsapp Cloud Webhook Verify
 *
 * Meta webhook verification endpoint (GET).
 */
export const whatsappCloudWebhookVerifyApiWhatsappCloudWebhookGet = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<
    WhatsappCloudWebhookVerifyApiWhatsappCloudWebhookGetData,
    ThrowOnError
  >,
): RequestResult<
  WhatsappCloudWebhookVerifyApiWhatsappCloudWebhookGetResponses,
  unknown,
  ThrowOnError
> =>
  (options?.client ?? client).get<
    WhatsappCloudWebhookVerifyApiWhatsappCloudWebhookGetResponses,
    unknown,
    ThrowOnError
  >({
    responseType: "json",
    url: "/api/whatsapp-cloud/webhook",
    ...options,
  });

/**
 * Whatsapp Cloud Webhook Post
 *
 * Meta webhook inbound endpoint (POST).
 */
export const whatsappCloudWebhookPostApiWhatsappCloudWebhookPost = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<
    WhatsappCloudWebhookPostApiWhatsappCloudWebhookPostData,
    ThrowOnError
  >,
): RequestResult<
  WhatsappCloudWebhookPostApiWhatsappCloudWebhookPostResponses,
  unknown,
  ThrowOnError
> =>
  (options?.client ?? client).post<
    WhatsappCloudWebhookPostApiWhatsappCloudWebhookPostResponses,
    unknown,
    ThrowOnError
  >({
    responseType: "json",
    url: "/api/whatsapp-cloud/webhook",
    ...options,
  });

/**
 * Mattermost outgoing webhook
 *
 * Incoming Mattermost outgoing webhook. Validate token, run pipeline, return reply as JSON response.
 */
export const incomingMattermostApiChannelsMattermostIncomingPost = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<
    IncomingMattermostApiChannelsMattermostIncomingPostData,
    ThrowOnError
  >,
): RequestResult<
  IncomingMattermostApiChannelsMattermostIncomingPostResponses,
  unknown,
  ThrowOnError
> =>
  (options?.client ?? client).post<
    IncomingMattermostApiChannelsMattermostIncomingPostResponses,
    unknown,
    ThrowOnError
  >({
    responseType: "json",
    url: "/api/channels/mattermost/incoming",
    ...options,
  });

/**
 * Google Chat HTTP interaction events
 *
 * Inbound Google Chat events. Verify OIDC, run pipeline, return synchronous Message JSON.
 */
export const incomingGoogleChatApiChannelsGoogleChatIncomingUserConnectionIdPost =
  <ThrowOnError extends boolean = false>(
    options: Options<
      IncomingGoogleChatApiChannelsGoogleChatIncomingUserConnectionIdPostData,
      ThrowOnError
    >,
  ): RequestResult<
    IncomingGoogleChatApiChannelsGoogleChatIncomingUserConnectionIdPostResponses,
    IncomingGoogleChatApiChannelsGoogleChatIncomingUserConnectionIdPostErrors,
    ThrowOnError
  > =>
    (options.client ?? client).post<
      IncomingGoogleChatApiChannelsGoogleChatIncomingUserConnectionIdPostResponses,
      IncomingGoogleChatApiChannelsGoogleChatIncomingUserConnectionIdPostErrors,
      ThrowOnError
    >({
      responseType: "json",
      url: "/api/channels/google-chat/incoming/{user_connection_id}",
      ...options,
    });

/**
 * Shared Telegram bot webhook
 *
 * Inbound shared Telegram updates with DM-only rules and tenant binding resolution.
 */
export const incomingSharedTelegramApiChannelsTelegramSharedIncomingPost = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<
    IncomingSharedTelegramApiChannelsTelegramSharedIncomingPostData,
    ThrowOnError
  >,
): RequestResult<
  IncomingSharedTelegramApiChannelsTelegramSharedIncomingPostResponses,
  unknown,
  ThrowOnError
> =>
  (options?.client ?? client).post<
    IncomingSharedTelegramApiChannelsTelegramSharedIncomingPostResponses,
    unknown,
    ThrowOnError
  >({
    responseType: "json",
    url: "/api/channels/telegram/shared/incoming",
    ...options,
  });

/**
 * Telegram webhook events
 *
 * Inbound Telegram updates with webhook secret verification, idempotency, and chat pipeline execution.
 */
export const incomingTelegramApiChannelsTelegramIncomingUserConnectionIdPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    IncomingTelegramApiChannelsTelegramIncomingUserConnectionIdPostData,
    ThrowOnError
  >,
): RequestResult<
  IncomingTelegramApiChannelsTelegramIncomingUserConnectionIdPostResponses,
  IncomingTelegramApiChannelsTelegramIncomingUserConnectionIdPostErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    IncomingTelegramApiChannelsTelegramIncomingUserConnectionIdPostResponses,
    IncomingTelegramApiChannelsTelegramIncomingUserConnectionIdPostErrors,
    ThrowOnError
  >({
    responseType: "json",
    url: "/api/channels/telegram/incoming/{user_connection_id}",
    ...options,
  });

/**
 * Stream chat response
 *
 * Streams an agent response as NDJSON, including execution metadata, text chunks, and final usage metrics.
 */
export const generateStream = <ThrowOnError extends boolean = false>(
  options: Options<GenerateStreamData, ThrowOnError>,
): RequestResult<GenerateStreamResponses, GenerateStreamErrors, ThrowOnError> =>
  (options.client ?? client).post<
    GenerateStreamResponses,
    GenerateStreamErrors,
    ThrowOnError
  >({
    responseType: "json",
    url: "/generate_stream",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Stop an in-flight chat run
 *
 * Explicitly cancels a detached chat run started via /generate_stream. Client disconnect alone never cancels a run (WS-A) -- this is the only supported way to stop one. Only the run's owner may stop it; shared-link runs are never stoppable (no run_id is ever issued for them).
 */
export const stopGenerateStream = <ThrowOnError extends boolean = false>(
  options: Options<StopGenerateStreamData, ThrowOnError>,
): RequestResult<
  StopGenerateStreamResponses,
  StopGenerateStreamErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    StopGenerateStreamResponses,
    StopGenerateStreamErrors,
    ThrowOnError
  >({
    responseType: "json",
    url: "/generate_stream/{run_id}/stop",
    ...options,
  });

/**
 * Read the lines of a chat run from an offset
 *
 * Returns the NDJSON lines a stoppable run has produced from `after` on, so a reader who left the chat mid-answer can rejoin it. `next` is the offset to ask for next; `done` is true once the run has ended and every line has been returned. Only the run's owner may read it. Poll this while the conversation reports an active run.
 */
export const getGenerateStreamLines = <ThrowOnError extends boolean = false>(
  options: Options<GetGenerateStreamLinesData, ThrowOnError>,
): RequestResult<
  GetGenerateStreamLinesResponses,
  GetGenerateStreamLinesErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetGenerateStreamLinesResponses,
    GetGenerateStreamLinesErrors,
    ThrowOnError
  >({
    responseType: "json",
    url: "/generate_stream/{run_id}/lines",
    ...options,
  });

/**
 * Chat features the admin has switched on
 *
 * Which optional chat features are available to the signed-in user (currently voice dictation).
 */
export const getChatCapabilities = <ThrowOnError extends boolean = false>(
  options?: Options<GetChatCapabilitiesData, ThrowOnError>,
): RequestResult<
  GetChatCapabilitiesResponses,
  GetChatCapabilitiesErrors,
  ThrowOnError
> =>
  (options?.client ?? client).get<
    GetChatCapabilitiesResponses,
    GetChatCapabilitiesErrors,
    ThrowOnError
  >({
    responseType: "json",
    url: "/chat/capabilities",
    ...options,
  });

/**
 * Transcribe dictated audio
 *
 * Transcribes a short voice recording for the chat composer. The vendor cost is billed to the caller.
 */
export const transcribeChatAudio = <ThrowOnError extends boolean = false>(
  options: Options<TranscribeChatAudioData, ThrowOnError>,
): RequestResult<
  TranscribeChatAudioResponses,
  TranscribeChatAudioErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    TranscribeChatAudioResponses,
    TranscribeChatAudioErrors,
    ThrowOnError
  >({
    ...formDataBodySerializer,
    responseType: "json",
    url: "/chat/transcribe",
    ...options,
    headers: {
      "Content-Type": null,
      ...options.headers,
    },
  });

/**
 * View shared conversation
 *
 * Validate link and return conversation (read-only snapshot) and interaction permission.
 */
export const getSharedConversationSharedTokenGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetSharedConversationSharedTokenGetData, ThrowOnError>,
): RequestResult<
  GetSharedConversationSharedTokenGetResponses,
  GetSharedConversationSharedTokenGetErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetSharedConversationSharedTokenGetResponses,
    GetSharedConversationSharedTokenGetErrors,
    ThrowOnError
  >({
    responseType: "json",
    url: "/shared/{token}",
    ...options,
  });

/**
 * Send message in shared conversation
 *
 * Stream a reply in the shared conversation (if allow_interaction is true).
 */
export const postSharedChatSharedTokenChatPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PostSharedChatSharedTokenChatPostData, ThrowOnError>,
): RequestResult<
  PostSharedChatSharedTokenChatPostResponses,
  PostSharedChatSharedTokenChatPostErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    PostSharedChatSharedTokenChatPostResponses,
    PostSharedChatSharedTokenChatPostErrors,
    ThrowOnError
  >({
    responseType: "json",
    url: "/shared/{token}/chat",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Update RAG index
 *
 * Authenticated legacy endpoint. Delete is the only supported action; add/update are disabled — use /api/agents/{agent_id}/documents* instead.
 */
export const updateAgentIndex = <ThrowOnError extends boolean = false>(
  options: Options<UpdateAgentIndexData, ThrowOnError>,
): RequestResult<
  UpdateAgentIndexResponses,
  UpdateAgentIndexErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    UpdateAgentIndexResponses,
    UpdateAgentIndexErrors,
    ThrowOnError
  >({
    responseType: "json",
    url: "/update_agent_index",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Upload JSONL and index (disabled)
 */
export const uploadAndIndex = <ThrowOnError extends boolean = false>(
  options: Options<UploadAndIndexData, ThrowOnError>,
): RequestResult<UploadAndIndexResponses, UploadAndIndexErrors, ThrowOnError> =>
  (options.client ?? client).post<
    UploadAndIndexResponses,
    UploadAndIndexErrors,
    ThrowOnError
  >({
    ...formDataBodySerializer,
    responseType: "json",
    url: "/upload_and_index",
    ...options,
    headers: {
      "Content-Type": null,
      ...options.headers,
    },
  });

/**
 * Ingest document (disabled)
 */
export const ingestDocument = <ThrowOnError extends boolean = false>(
  options: Options<IngestDocumentData, ThrowOnError>,
): RequestResult<IngestDocumentResponses, IngestDocumentErrors, ThrowOnError> =>
  (options.client ?? client).post<
    IngestDocumentResponses,
    IngestDocumentErrors,
    ThrowOnError
  >({
    ...formDataBodySerializer,
    responseType: "json",
    url: "/ingest_document",
    ...options,
    headers: {
      "Content-Type": null,
      ...options.headers,
    },
  });

/**
 * Health check
 *
 * Returns status, agents with RAG, Thyra AI flag, RAG/LLM providers, DB status, code-execution readiness, and browser-automation readiness. Returns 503 while LanceDB warm-up is pending (startupProbe budget: 15 min) or when any LanceDB pool is wedged (all permits held and stuck). After warm-up completes — even with a failure or timeout — this returns 200 so an Azure blip is not an outage.
 */
export const getHealth = <ThrowOnError extends boolean = false>(
  options?: Options<GetHealthData, ThrowOnError>,
): RequestResult<GetHealthResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).get<GetHealthResponses, unknown, ThrowOnError>({
    responseType: "json",
    url: "/health",
    ...options,
  });

/**
 * Readiness check
 *
 * Returns 200 when configured Postgres and Redis dependencies are reachable and no LanceDB pool is wedged; 503 otherwise. Use for Kubernetes readinessProbe.
 */
export const healthReadyHealthReadyGet = <ThrowOnError extends boolean = false>(
  options?: Options<HealthReadyHealthReadyGetData, ThrowOnError>,
): RequestResult<HealthReadyHealthReadyGetResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).get<
    HealthReadyHealthReadyGetResponses,
    unknown,
    ThrowOnError
  >({
    responseType: "json",
    url: "/health/ready",
    ...options,
  });

/**
 * Code execution worker readiness
 *
 * Returns 200 if a code-execution worker has built the image and is consuming the queue, 503 otherwise.
 */
export const healthCodeExecutionHealthCodeExecutionGet = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<
    HealthCodeExecutionHealthCodeExecutionGetData,
    ThrowOnError
  >,
): RequestResult<
  HealthCodeExecutionHealthCodeExecutionGetResponses,
  unknown,
  ThrowOnError
> =>
  (options?.client ?? client).get<
    HealthCodeExecutionHealthCodeExecutionGetResponses,
    unknown,
    ThrowOnError
  >({
    responseType: "json",
    url: "/health/code-execution",
    ...options,
  });

/**
 * Browser automation worker readiness
 *
 * Returns 200 when the browser-automation readiness key is set (Python worker + Node sidecar healthy), 503 otherwise.
 */
export const healthBrowserAutomationHealthBrowserAutomationGet = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<
    HealthBrowserAutomationHealthBrowserAutomationGetData,
    ThrowOnError
  >,
): RequestResult<
  HealthBrowserAutomationHealthBrowserAutomationGetResponses,
  unknown,
  ThrowOnError
> =>
  (options?.client ?? client).get<
    HealthBrowserAutomationHealthBrowserAutomationGetResponses,
    unknown,
    ThrowOnError
  >({
    responseType: "json",
    url: "/health/browser-automation",
    ...options,
  });

/**
 * RAG config fingerprint
 *
 * Returns effective RAG settings fingerprint to verify API/worker environment parity.
 */
export const healthRagConfigHealthRagConfigGet = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<HealthRagConfigHealthRagConfigGetData, ThrowOnError>,
): RequestResult<
  HealthRagConfigHealthRagConfigGetResponses,
  HealthRagConfigHealthRagConfigGetErrors,
  ThrowOnError
> =>
  (options?.client ?? client).get<
    HealthRagConfigHealthRagConfigGetResponses,
    HealthRagConfigHealthRagConfigGetErrors,
    ThrowOnError
  >({
    responseType: "json",
    url: "/health/rag-config",
    ...options,
  });

/**
 * Deployed revision (Alembic + image SHA)
 *
 * Returns the current Alembic migration revision of the running database and the commit SHA baked into the running image. Use to verify whether a deployed image contains a specific migration without shell access. Auth-gated; not suitable for liveness probes.
 */
export const healthVersionHealthVersionGet = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<HealthVersionHealthVersionGetData, ThrowOnError>,
): RequestResult<
  HealthVersionHealthVersionGetResponses,
  HealthVersionHealthVersionGetErrors,
  ThrowOnError
> =>
  (options?.client ?? client).get<
    HealthVersionHealthVersionGetResponses,
    HealthVersionHealthVersionGetErrors,
    ThrowOnError
  >({
    responseType: "json",
    url: "/health/version",
    ...options,
  });

/**
 * Deterministic proxy-fallback trigger (test fixture)
 *
 * Returns 403 to the configured datacenter egress IPs and 200 to everything else. Used to prove the DataImpulse proxy fallback and its billing end to end: a direct request from the cluster is refused, which raises rotate_proxy, which engages the paid residential proxy, whose different exit IP then gets 200. Returns 404 when PROXY_CANARY_BLOCKED_IPS is unset, so it is inert by default.
 */
export const proxyCanaryHealthProxyCanaryGet = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<ProxyCanaryHealthProxyCanaryGetData, ThrowOnError>,
): RequestResult<
  ProxyCanaryHealthProxyCanaryGetResponses,
  unknown,
  ThrowOnError
> =>
  (options?.client ?? client).get<
    ProxyCanaryHealthProxyCanaryGetResponses,
    unknown,
    ThrowOnError
  >({
    responseType: "json",
    url: "/health/proxy-canary",
    ...options,
  });

/**
 * List configured provider models
 *
 * Lists available models for the configured provider and their supported methods.
 */
export const modelsListModelsGet = <ThrowOnError extends boolean = false>(
  options?: Options<ModelsListModelsGetData, ThrowOnError>,
): RequestResult<ModelsListModelsGetResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).get<
    ModelsListModelsGetResponses,
    unknown,
    ThrowOnError
  >({
    responseType: "json",
    url: "/models",
    ...options,
  });
